export const translation = {
  "Footer_Copyright": " このシステムはNeufast Limitedによって提供されています",
  "Table_RowsPerPage": "1ページあたりの行数:",
  "MainMenu_Language": "使用言語",
  "MainMenu_CandidateLogin": "候補者用ログイン",
  "MainMenu_RecruiterLogin": "採用担当者用ログイン",
  "Recruiter_Menu_Dashboard": "候補者",
  "Recruiter_Menu_Statistics": "統計情報",
  "Recruiter_Menu_Settings": "仕事とアセスメント",
  "Recruiter_Menu_Settings_old": "求人情報＆ビデオインタビュー",
  "Recruiter_Menu_Review": "面接のレビュー",
  "Recruiter_Menu_Greeting": "こんにちは, {name}",
  "Recruiter_Menu_Logout": "アカウントのログアウト",
  "Recruiter_Menu_AccountSetting": "アカウント設定",
  "Recruiter_Menu_LogoutInProgress": "ログアウト中...",
  "Recruiter_Menu_Greeting_Acting": "こんにちは, {name} (演出)",
  "Recruiter_Menu_Interview_Monitor": "インタビューモニター",
  "Login_HiEmployer": "こんにちは、採用担当者様, ",
  "Login_HiCandidate": "こんにちは、候補者の皆様 ",
  "Login_WelcomeBack": "ビデオ面接＆アセスメントへようこそ",
  "Login_EnterYourDetailsBelow": "下記より詳細を入力してください。",
  "Login_Email": "Eメール",
  "Login_Password": "パスワード",
  "Login_AccessCode": "パスワード",
  "Login_ForgotPassword": "パスワードを忘れましたか?",
  "Login_RememberMe": "記録する",
  "Login_Login": "ログイン",
  "Login_Terms_Prefix": "「ログイン」をクリックすると、私たちの活動に同意したものとみなされます。 ",
  "Login_Terms_Suffix": ".",

  "Login_Terms_Conditions": "利用規約",
  "Login_Terms_Conditions_Close": "閉じる",
  "Login_Terms_Conditions_Content": ["<h2>Neufast利用規約</h2>",
    "<h3>1.規約</h3>",
    "<p><a href='http://www.neufast.com'>http://www.neufast.com</a>にアクセスすることで、お客様は、本利用規約およびすべての法令に従うことに同意し、適用される地域の法令を遵守する責任を負うことに同意するものとします。 これらの条件に同意されない場合、このサイトをご利用になることはできません。本ウェブサイトに含まれる資料は、適用される著作権法および商標法によって保護されています。</p>",
    "<h3>2. 利用ライセンス</h3>",
    "<ol type='a'>",
    "<li>Neufastのウェブサイト上の資料（情報またはソフトウェア）を、個人的かつ非商業目的での閲覧のみ、一時的にダウンロードすることが許可されています。これはライセンス付与であり、所有権の譲渡ではなく、このライセンスに基づき、以下のことを行うことはできません。",
    "<ol type='i'>",
    "<li>資料の変更または複製。</li>",
    "<li>営利目的、または公共の場（営利、非営利を問わない）での使用。</li>",
    "<li>Neufastのウェブサイトに含まれるいかなるソフトウェアの逆コンパイルまたはリバースエンジニアリングを試みること。</li>",
    "<li>資料から著作権またはその他の所有権に関する表記を削除すること、または</li>",
    "<li>資料を他人に譲渡したり、他のサーバーに「ミラーリング」すること。</li>",
    "</ol>",
    "</li>",
    "<li>このライセンスは、お客様がこれらの制限に違反した場合、自動的に終了するものとし、Neufastはいつでもこれを終了させることができるものとします。これらの資料の閲覧を終了した場合、または本使用許諾が終了した場合、お客様は、電子または印刷された形式であるかを問わず、お客様が所有するダウンロードした資料をすべて破棄しなければなりません。</li>",
    "</ol>",
    "<h3>3. 免責事項</h3>",
    "<ol type='a'>",
    "<li>Neufastのウェブサイトの資料は、「現状のまま」提供されます。Neufastは、明示または黙示を問わず、いかなる保証も行わず、商品性、特定目的への適合性、知的財産またはその他の権利の非侵害に関する黙示の保証または条件を含むがこれに限定されない他のすべての保証を否認し否定するものとします。</li>",
    "<li>さらに、Neufastは、ウェブサイト上の資料、または資料や本サイトにリンクされたサイトに関する正確性、可能性のある結果、または使用の信頼性に関して、いかなる保証も表明も行いません。.</li>",
    "</ol>",
    "<h3>4. 制限事項</h3>",
    "<p>NeufastまたはNeufastの認定代理人が口頭または書面でその可能性を通知されていたとしても、Neufastまたはそのサプライヤーは、NeufastのWebサイト上の資料の使用または使用不能から生じるいかなる損害（データまたは利益の損失、事業の中断による損害を含むがこれに限定しない）にも責任を負わないものとします。一部の裁判管轄では、黙示的保証の制限、または結果的もしくは付随的損害に対する責任の制限を認めていないため、これらの制限はお客様に適用されない場合があります。</p>",
    "<h3>5. 資料の正確性</h3>",
    "<p>Neufastのウェブサイトに表示される資料には、技術的な誤り、誤植、または写真上の誤りが含まれている可能性があります。 Neufastは、そのWebサイト上の資料が正確、完全または最新であることを保証するものではありません。Neufast は、Webサイトに含まれる資料をいつでも予告なく変更することができます。 しかし、 Neufastは資料を更新する義務を負わないものとします。</p>",
    "<h3>6.関連リンク</h3>",
    "<p>当ウェブサイトにリンクしている全てのサイトにおいて確認するものではなく、リンク先のサイトのコンテンツについて責任を負うものではありません。リンクの掲載は、Neufastがそのサイトを推奨していることを意味するものではありません。リンク先のウェブサイトの使用は、自身の責任で行ってください。</p>",
    "<h3>7. 内容変更</h3>",
    "<p>Neufastは、当ウェブサイトの利用条件を、必要に応じて予告なしに変更することがあります。 当ウェブサイトのご利用にあたっては、以下のご利用条件をお読みいただき、これらの条件に同意された場合のみご利用ください。.</p>",
    "<h3>8. 準拠法</h3>",
    "<p>本規約は、香港法に準拠し、同法に従って解釈され、お客様は、同州または所在地の裁判所の専属管轄権に取消不能の形で遵守するものとします。</p>",
    "<h3>9. 一般事項</h3>",
    "<p>当社は、厳格なプライバシーポリシーの管理に留意しておりますが、欧州連合の一般データ保護規則（GDPR）への完全な準拠を監査・確認されたものではありません。 欧州市民および欧州居住者のユーザーは、当社のサービスの利用を開始する前に、これらを認識し、同意するものとします。</p>",
    "<h3>10. 個人情報の削除</h3>",
    "<p>お客様のお名前、電子メールアドレス、ログイン情報は、お客様のユーザーアカウントが閉鎖されてから3ヶ月後に、当社のシステムから削除されます。閲覧情報、求人情報、面接の質問、動画、スコア、コメントなどの非個人情報は、評価やサービス品質の向上を目的として集計され、当社のシステムに保存されます。</p>",
    "<h3>11. 権利制限を受けないもの</h3>",
    "<p>この文責のいかなる内容も、個人データ（プライバシー）条例（PDPO）に基づくデータ主体の権利を制限するものではありません。</p>",
  
  ],
  "Login_Privacy_Policy" : "プライバシーポリシー声明",
  "Login_Privacy_Policy_Close": "閉じる",
  "Login_Privacy_Policy_Content": [
    "<h2>プライバシーポリシーステートメント(PPS)</h2>",
    "<p>Neufast Limited(「会社」)は、ユーザーの個人データを尊重し保護することを約束し、個人データ保護の原則および個人データプライバシー委員会(PCPD)によって発行された個人データ(プライバシー)条例(「条例」)のすべての関連規定を遵守することを約束します。データは、当社のウェブサイトサービス Neufast.com(「サイト」)によって収集されます。当社のPPSは、当社が取り扱う個人データに関連するプライバシーポリシーおよび慣行に関する一般的な声明です</p>",
    "<h3>1.実践声明</h3>",
    "<ol type='a'>",
    "<li>以下の個人データが収集されます:",
    "<ol type='i'>",
    "<li>ユーザーの氏名、電子メール、電話番号、履歴書を含む人事記録</li>",
    "<li>テキスト、オーディオ、ビデオ形式のビデオと回答を含む、ユーザーのパフォーマンスを含む評価記録</li>",
    "<li>IPアドレス、デバイスタイプ、ブラウザ、OS、国、動作記録、ログなどの動作パラメータ</li>",
    "</ol>",
    "</li>",
    "<li>サイトを使用する過程で、ユーザーは個人情報および/またはデータを開示したり、提供を求められたりする場合があります。本サイトが提供するさまざまなサービスを利用し、享受するために、ユーザーは当社に個人情報および/またはデータを提供する必要がある場合があります。ユーザーは、本サイトで要求された情報および/またはデータを提供する義務を負いませんが、ユーザーが提供しなかった場合、当社は本サイトで特定のサービスを提供することができません</li>",
    "<li>ユーザーは、ユーザーが当社に提供する情報が自発的であり、正確、真実、最新かつ完全であることに同意するものとします。そうでない場合、または当社がそのように疑う合理的な理由がある場合、当社はユーザーに対してサービスをキャンセルおよび/または拒否する権利を有します。</li>",
    "</ol>",
    "<h3>2.収集の目的</h3>",
    "<ol>",
    "<li>",
    "サイト上の情報およびデータを収集および使用する当社の目的には、以下が含まれますが、これらに限定されません。",
    "<ul>",
    "<li>利用者に提供されるサービスの日常業務のため;</li>",
    "<li>雇用者が幅広い職種・産業の求人候補者の適合性を評価するのを支援すること;</li>",
    "<li>ユーザーのインタビュースキル向上を支援する</li>",
    "<li>ユーザーからの問い合わせ、要求、苦情の処理とフォローアップのため;</li>",
    "<li>サイトの使用に関連する管理上の通知および連絡に関する連絡、およびユーザーの 問い合わせまたは要求に対応するため;</li>",
    "<li>将来のマーケティングおよびプロモーション目的またはその他の内部目的のための開発において当社を支援するため;</li>",
    "<li>当社および/または関連会社が当社 が提供するサービスの提供に関連する目的でユーザーの個人データを使用することを容易にするため;</li>",
    "<li>内部使用のためのさらなる発展を支援するために、サイトの使用状況を分析するためにユーザーに関する統計を取得すること。および</li>",
    "<li>記載された関連目的のためにサイトが提供するサービスの改善を支援するため。</li>",
    "</ul>",
    "</li>",
    "<li>ユーザーが18歳未満の場合、当社は、ユーザーをサイトのメンバーとして登録するための「お問い合わせ」のセクションに記載されている連絡先の詳細が記載されている責任あるカスタマーサポートエグゼクティブに連絡することができる親または保護者などの親の責任を持つ人物に事前の同意を求めることを強くお勧めします。</li>",
    "<li>当社は、上記の目的に関連して必要かつ適切であるが過度ではない個人データのみを収集するよう努めています。</li>",
    "<li>当社が上記以外の目的でお客様の個人データの使用を要求する場合、当社はお客様の所定の同意を求めます。お客様が未成年者の場合は、親権者または保護者が所定の同意を行ってください</li>",
    "</ol>",
    "<h3>3.データ保護の原則</h3>",
    "個人データのすべての処理は、以下のデータ保護原則に従って行われるものとします。",
    "<ul>",
    "<li>個人データは合法的、公正かつ透明に処理されなければならない。</li>",
    "<li>個人データは、特定の、明示的かつ正当な目的のためにのみ収集することができます。</li>",
    "<li>個人データは、処理に必要なものに関連し、限定されなければならない</li>",
    "<li>個人データは正確でなければならず、消去または修正するためにあらゆる努力を払って最新の状態に保たれなければなりません。</li>",
    "<li>個人データは、処理に必要な場合にのみデータ主体を特定できる形式で保持する必要があります。</li>",
    "<li>個人データは、適切なセキュリティを確保する方法で処理する必要があります。</li>",
    "</ul>",
    "<h3>4.データインベントリ</h3>",
    "<ol>",
    "<li>",
    "また、データ処理のさまざまな側面を決定するために、データインベントリとデータフロープロセスも保持しています。",
    "<ul>",
    "<li>個人データを利用する業務プロセス.</li>",
    "<li>個人データの収集および/または使用の目的.</li>",
    "<li>個人データのソース.</li>",
    "<li>処理アクティビティ.</li>",
    "<li>任意のデータ転送、および誰への転送</li>",
    "<li>データへのアクセス、修正、またはオプトアウトの要求。このようなデータインベントリは容易になります</li>",
    "</ul>",
    "</li>",
    "<li>Neufast Limitedは、そのデータおよび関連する処理活動を追跡し、関連するプライバシーおよびその他の法律および規制を遵守するためのより良い立場に私たちを置きます。</li>",
    "</ol>",
    "<h3>5.セキュリティ</h3>",
    "<p>ユーザーの個人情報とデータのセキュリティは、Neufast Limitedにとって重要です。当社は、ユーザーの個人情報およびデータが不正アクセスから保護されることを常に保証するよう努めます。当社は、ユーザーの個人情報およびデータを保護、保護、および保護するために、適切な電子的および管理上の措置を講じています</p>",
    "<p>ユーザーが提供するすべての個人情報およびデータは、当社またはその許可された第三者の権限のある担当者のみがアクセスでき、そのような担当者は、そのような個人情報およびデータにアクセスする際にこのプライバシーステートメントの条件を遵守するように指示されるものとします。ユーザーは、個人情報とデータが収集される目的を達成するために必要な期間のみ保持されるので安心できます。登録ユーザーは、自分の固有のユーザー名とパスワードを秘密かつ機密に保つことによって保護し、これらの詳細を誰とも共有しないでください</p>",
    "<p>当社は、本サイトでの電子決済取引を容易にするために第三者のサービスプロバイダーを使用しています。</p>",
    "<p>当社は、送信中および受信後の両方で、ユーザーがサイトに提出した個人情報およびデータを保護するために、一般に認められている業界標準に従います。ただし、インターネットを介した送信方法や電子ストレージの方法は、100%安全ではありません。したがって、当社は、ユーザーの 個人情報およびデータを不正アクセスから保護するよう努めていますが、当社はその絶対的なセキュリティを保証するものではありません</p>",
    "<h3>6.データ処理の法的根拠</h3>",
    "<p>当社は、個人データの処理に法的根拠があることを保証します。このような法的根拠には、(i)個人データの処理におけるNeufast Limitedの正当な事業上の利益が含まれます。(ii)適用される法律または規制で義務付けられている場合、そのような個人データを処理するための特定の同意を求める。および/または(iii)適用される法律および規制に基づくその他の関連する根拠</p>",
    "<h4>正当な利益</h4>",
    "<p>Neufast Limitedは、個人データの保護を必要とするデータ主体の利益または基本的権利および自由によってそのような利益が優先される場合を除き、Neufast Limitedが追求する正当な利益のために個人データの処理が必要であることを意味する「正当な利益」の法的根拠に基づいて個人データを処理します。</p>",
    "<h4>正当な利益評価</h4>",
    "<p>関連する各状況において、私たちは以下を評価します:(i)これらの正当な利益が何であるか。(ii)目的を達成するためにそのようなデータを処理する必要があるかどうか。(iii)データ主体の関連する権利。また、そのような権利とそのような目的を達成する上での当社の利益とのバランスを取り、Neufast Limitedが正当な利益に基づいて個人データを処理できると結論付ける前に、そのような権利がNeufast Limitedの正当な利益に優先しないようにします</p>",
    "<h4>データ主体と通信する</h4>",
    "<p>すべてのデータ主体は、当社が個人データ、関連する個人データのカテゴリ、および処理の目的を収集していることを通知されます。これは、データ主体が個人データの収集と処理について明確であり、そのような収集と処理がデータ主体の合理的な期待の範囲内であることを確認するためです。すべてのデータ主体は、当社が保有する個人データへのアクセスおよび/または修正を要求する権利に加えて、いつでも個人データの収集および処理に異議を唱えることができます。</p>",
    "<h4>データセキュリティメカニズム</h4>",
    "<p>また、収集および処理する個人データの機密性とセキュリティを保護するための適切なメカニズム、ポリシー、および手順を実装しています。データの最小化を含むがこれに限定されない処理のリスクまたは潜在的な悪影響を軽減することにより、そのような個人データに関連するデータ主体のプライバシーおよび関連する権利を尊重します。 匿名化、暗号化、アクセス制限、その他すべての技術的セキュリティ方法および個人データを保護するための取り組み。このようなデータ主体のプライバシーおよび関連する権利の保護により、Neufast Limitedは正当な利益の法的根拠に基づいて個人データを処理することができます。上記の評価を徹底的に実施した結果、Neufast Limitedは、正当な利益の下で個人データを収集および処理していると結論付けています。</p>",
    "<ol type='a'>",
    "<li>",
    "<p>顧客および運用上のニーズへの対応個人データのカテゴリを処理する主な目的は、上記のとおりです。</p>",
    "<p>Neufast Limitedが同じ処理を行う正当な利益があります。なぜなら、そのような目的はすべて、Neufast Limitedが企業および技術組織としての顧客とその運用ニーズにサービスを提供するために不可欠だからです。</p>",
    "<p> Neufast Limitedのような企業は、従業員がその事業(したがって人事記録)のために働き、サービスプロバイダーがそれを運営し続けること(したがって他の業務記録)を必要としています。</p>",
    "<p> Neufastのような技術組織は、人事および教育分野のクライアントにサービスを提供するためにサービスを強化するために必要な技術をさらに強化する技術を開発する必要があります。</p>",
    "</li>",
    "<li>",
    "<p>Inform the Pubic</p>",
    "<p>採用組織として、Neufast Limitedは、私たちのコミュニティと世界で何が起こっているのかを知る一般の権利を尊重します。Neufast Limitedは、法律とジャーナリズム倫理の両方において、そのような出来事を一般に知らせる義務(「通知する義務」)を持っています</p>",
    "<p>これらの推奨事項は、利用可能なときにいつでもアクセスできるそのようなWebサイトの他のすべての記事またはコンテンツを閲覧することを禁止または制限するものではありません。</p>",
    "</li>",
    "<li>",
    "<p>Consent</p>",
    "<p>ダイレクトマーケティングの実施を含む個人データを処理する前に、適用される法的要件により特定の同意を得る必要がある場合、当社はそのような特定の同意が次のように取得されるようにします:</p>",
    "<ol type='a'>",
    "<li>同意は明確、明示的、具体的でなければなりません;</li>",
    "<li>データ主体は、当社が使用する予定の個人データの種類を完全に認識しています。そのような使用の目的(データ主体へのサービスの改善やダイレクトマーケティングなど)。および</li>",
    "<li>譲受人の名前/身元(当社がお客様のデータを転送する場合)、および譲受人がお客様の個人データをどのように使用するか。</li>",
    "</ol>",
    "</li>",
    "</ol>",
    "<h3>7.データ主体の権利</h3>",
    "<p>Neufast Limitedは、データ主体がデータ処理およびそれらについて記録されたデータに関して以下の権利を有することを尊重します:</p>",
    "<ol>",
    "<li>保持されている情報の性質と開示先に関するアクセスを要求すること。</li>",
    "<li>損傷や苦痛を引き起こす可能性のある処理を防止する</li>",
    "<li>ダイレクトマーケティングを目的とした処理を防止するため</li>",
    "<li>それらに大きな影響を与える自動化された意思決定プロセスの仕組み(もしあれば)について知らされること.</li>",
    "<li>自動化されたプロセスによってのみ行われることに影響を与える重要な決定をしないこと。</li>",
    "<li>不正確なデータを忘れたり破棄したりする権利を含む、修正、ブロック、消去のための措置を講じること。</li>",
    "<li>監督当局に要請すること(例:.プライバシーコミッショナーまたはデータ保護責任者)は、関連するプライバシーおよびその他の法律のいずれかの規定に違反しているかどうかを評価します</li>",
    "<li>構造化され、一般的に使用され、機械で読み取り可能な形式で個人データを提供し、そのようなデータを別のデータ管理者に送信する権利</li>",
    "<li>発生している自動プロファイリングに異議を唱えるには.</li>",
    "</ol>",
    "<h3>8.個人データの転送</h3>",
    "<p>当社は、当社が保有する個人データの機密を保持し、上記の目的のために以下の当事者に転送される場合があります。</p>",
    "<ol>",
    "<li>クラウドサービスプロバイダー、請負業者、またはNeufast Limitedに管理、技術、またはその他のサービスを提供する第三者;</li>",
    "<li>管轄の法執行機関、規制当局、政府機関、裁判所、またはその他の第三者に対して†開示が必要であると当社が考える場合、(i)適用法または規制の問題として、(ii)当社の法的権利を行使、確立、または防御するため、または(iii)お客様または他の人の重要な利益を保護するために;</li>",
    "<li>当社の事業の一部の購入、再編、合併、または買収の提案に関連して、このプライバシー通知で開示された目的にのみお客様の個人情報を使用する必要があることを購入者に通知することを条件とします。</li>",
    "<li>Neufast Limitedの関連会社</li>",
    "</ol>",
    "<p>そのような転送の場合、Neufast Limitedは契約またはその他の手段を使用して、データ転送者が転送された個人データの機密を保持し、関連するすべての個人データプライバシー法および規制を遵守することを保証するものとします。</p>",
    "<p>上記のように、お客様が候補者、従業員、または研修生であり、当社が本サービスを通じてお客様の個人情報を収集している場合、当社はお客様との契約に従って、お客様に代わって個人情報を収集します。お客様の個人情報が第三者と共有される方法の詳細については、関連する潜在的な雇用主に連絡するか、その潜在的な雇用主のプライバシーポリシー/プライバシー通知を参照してください</p>",
    "<p>上記サブ条項(iv)に記載されている状況に関して - Neufast Limitedの関連会社間のグループ内転送に国境を越えたデータ転送が含まれる場合、Neufast Limitedはそのような個人データのセキュリティを保護するための拘束力のある企業規則を採用する場合があります。関係するすべての関連会社が関連するプライバシーおよびその他の法律を遵守することを保証します</p>",
    "<h3>9.個人データの保持</h3>",
    "<p>Neufast Limitedがユーザーの個人情報および/またはデータを取得すると、「実践宣言」のセクションに記載されているように、データが収集された目的を達成するために必要な期間、当社のシステムで安全に維持されます。.登録後、ユーザーはデータ管理者、つまりユーザーが当社のサイトを使用している雇用主/トレーナーに連絡することにより、サイトから個人情報を削除したり、サイトのメンバーシップを終了したりできます。当社は、当社の法的義務の遵守、規制要件の遵守、ユーザー間の紛争の解決、詐欺や乱用の防止、または本プライバシーステートメントと利用規約の施行のために合理的に必要がある場合、ユーザーがアカウントを閉鎖した後もユーザーの個人情報を保持する場合があります</p>",
    "<h3>10.このプライバシーに関する声明の変更</h3>",
    "<p>当社は、当社が必要と判断した場合、いつでもこのプライバシーステートメントを更新、改訂、修正、または修正する権利を留保するため、ユーザーはこのプライバシーステートメントを頻繁に確認することを強くお勧めします。当社が本プライバシーステートメントを更新、改訂、修正、または修正することを決定した場合、当社は、当社が収集する情報、その使用方法、およびどのような状況下で当社が開示するかをユーザーが認識できるように、それらの変更をサイトおよび/または当社が適切と判断するその他の場所に掲載します</p>",
    "<p>当社がこのプライバシーステートメントに重大な変更を加える場合、このウェブページ、電子メール、またはサイトのホームページでの通知によってユーザーに通知します。このプライバシーステートメントのそのような変更は、当社がサイトに同じものを掲載した時点から適用されるものとします。ユーザーが本サイト および本サイト上のサービスを継続して使用することは、本プライバシーステートメントの変更を承諾したものとみなされます</p>",
    "<h3>11.Cookiesの使用</h3>",
    "<p>Cookiesは、ウェブサイトがサイトにいる間に記録保持の目的で個人のハードドライブに転送する情報の項目です。Cookieは、とりわけ、パスワード、購入、および設定を保存することにより、Webサーフィンを容易にします。Cookiesの使用は業界標準であり、ほとんどの主要なウェブサイトでCookiesを見つけることができます</p>",
    "<p>Cookie自体には個人を特定する情報は含まれていませんが、当社はユーザーによるサービスの使用を、ユーザーが以前に送信した個人識別情報に関連付けることができます。</p>",
    "<p>ほとんどのブラウザは、Cookiesを受け入れるように初期設定されています。上記の情報を開示したくない場合は、Cookieを拒否するように設定する必要があります。ただし、そうすると、サイトのほとんどの領域が正しく機能しなくなる可能性があります.</p>",
    "<h3>12.アウトソーシングの取り決め</h3>",
    "<p>当社は、社内のリソースを使用してITシステムの開発と保守を行ってきました。当社がITシステムに関連する特定のサービスを提供するためにサードパーティベンダーを雇う場合、ベンダーは通常の状況下でITシステムに保存されている個人データにアクセスすることはできません。</p>",
    "<p>そのようなベンダーがそのようなアクセス権を持っている例外的なケースでは、当社は合理的な措置を講じて、(i)そのようなベンダーは契約上、そのような個人データの機密を保持し、不正アクセス、使用、損失、保持、変更、転送などを防止するための適切な手段を採用する義務があります。</p>",
    "<h3>13.照会、同意の撤回、データアクセス要求およびデータ訂正</h3>",
    "<p>個人は、当社が保有する個人データの処理、問い合わせ、アクセスの要求、および修正に対する同意を撤回する権利を有します。雇用主またはトレーナーに連絡して、データにアクセスして修正してください。</p>",
    "当社が保有するペルソナデータの問い合わせ、アクセス、または修正をご希望の場合は、次の宛先にリクエストを送信してください。",
    "<p>Data Privacy Officer</p>",
    "<p>Dr. Dennis Lee</p>",
    "<p>Neufast Limited</p>",
    "<p>住所: ユニット2, 3/F, ビル2W, No.2 Science Park Avenue West, Shatin, N.T., Hong Kong</p>",
    "<p>電話: (+852)59876904</p>",
    "<p>電子メール: customer-service@neufast.com</p>",
    "<h3>14.国際データ転送</h3>",
    "<p>ユーザーの個人情報は、ユーザーが居住している国以外の国に転送され、処理される場合があります。これらの国には、ユーザーの国の法律とは異なるデータ保護法がある場合があります。具体的には、現地の法律で別段の定めがない限り、提供される当社のウェブサイト、システム、およびサードパーティのサービスは、EEA、シンガポール、香港特別行政区で処理されます</p>",
    "<p>ただし、当社は、ユーザーの個人情報がこのプライバシー通知および適用法に従って保護され続けることを要求するために適切な保護措置を講じています。ユーザーがEEAまたは英国出身の場合、これには、当社のグループ会社間、および当社の第三者サービスプロバイダーおよびパートナーとの個人情報の転送に関する欧州委員会の標準契約条項の実施が含まれます。標準契約条項は、EEA以外の企業が欧州経済領域のデータ保護法に従って処理するEEAおよび英国の個人情報を保護することを要求しています</p>",
    "<h3>15.個人データの削除</h3>",
    "<p>雇用主またはトレーナーは、システム上の個人データを管理するデータ管理者として機能します。名前、電子メール、電話番号、履歴書、画像、元のビデオ、オーディオなどの個人データは、雇用主またはトレーナーがプラットフォーム上で削除できます。あなたがあなたのデータを提供したユーザーであるならば、あなたがあなたの個人情報を削除するためにあなたが私たちのプラットフォームを使う会社に連絡してください。また、ユーザーの個人情報は、ユーザーアカウントが閉鎖されてから3か月後にシステムから削除されます。求人情報、面接の質問、編集されたビデオ、スコア、回答などの非個人情報は、評価とサービス品質の向上のみを目的として集約され、システムに保存されます。編集された動画やその他の情報は、雇用主/トレーナーから customer-service@neufast.com.</p>にメールで通知された場合、当社の合意に従って削除することもできます。</p>",
  ],
  "And" : "と",
  "Login_Personal_Information_Collection" : "Personal Information Collection Statement",
  "Login_Personal_Information_Collection_Close": "閉じる",
  "Login_Personal_Information_Collection_Content": [
    "<h2>Personal Information Collection Statement</h2>",
    "<p>Neufast Limited ('Company') is committed to protecting the respects personal data and is committed to protect compliance with the data protection principles and all relevant provisions of the Personal Data (Privacy) Ordinance ('Ordinance').</p>",
    "<h3>Purpose of Collection</h3>",
    "<ol>",
    "<li>The personal data collected from you will be used for the purpose of artificial intelligence (AI) video interview.</li>",
    "<li>",
    "<p>Personal data marked with (*) in this Personal Information Collection Statement is regarded as voluntary for purpose as stated in paragraphs 1 above. Failure to provide this data may affect the processing and outcome of your application. We will use data for the following purposes or any of them (which may vary depending on the nature of your relationship with us):</p>",
    "<ol type='a'>",
    "<li>to assist employers to assess the suitability of candidates for job vacancy for a wide spectrum of jobs and industries; and</li>",
    "<li>to help users to enhance their interview and presentation skills; and</li>",
    "<li>Any other purposes relating to the purposes listed above.</li>",
    "</ol>",
    "</li>",
    "<li>Your enquiry may also be used for the compilation of statistics on the number and nature of enquiries received by us. The outcome of the resulting statistics will not be in a form that will identify your enquiry and any of your personal data.</li>",
    "</ol>",
    "<h3>Statement of Possible Transferees</h3>",
    "<ol start='4'>",
    "<li>",
    "We will keep confidential the personal data that we hold, which may be transferred to the following parties for the purposes as stated above.",
    "<ol type='i'>",
    "<li>Cloud service providers, contractors or third parties which/who provide administrative, technology or other services to Neufast Limited for its operations; Microsoft is our service provider. No data storage is allowed for Microsoft. AWS and MongoDB Atlas is our data storage service provider.</li>",
    "<li>To any competent law enforcement body, regulatory, government agency, court or other third party where we believe disclosure is necessary (i) as a matter of applicable law or regulation, (ii) to exercise, establish or defend our legal rights, or (iii) to protect your vital interests or those of any other person;</li>",
    "</ol>",
    "</li>",
    "</ol>",
    "<h3>Direct Marketing</h3>",
    "<ol start='5'>",
    "<li>We may use your personal data in direct marketing, but we will not so use your personal data unless we have received your consent (which includes an indication of no objection to the intended use).</li>",
    "<li>You may, at any time without charge, choose to opt-out from us using your personal data for direct marketing by writing to our Data Privacy Officer stated in Statement 9.</li>",
    "<li>When you visit this website, we may use cookie files to store and track information about your preferences, purchases and saving passwords for the purposes of providing our services to you stated in ‘Purpose of Collection’ section.</li>",
    "</ol>",
    "<h3>Rights of Enquiries, Access and Correction to Personal Data</h3>",
    "<ol start='8'>",
    "<li>Under the PDPO, any individual has the right to make enquiries, request access to and correction of his or her personal data held by us. In accordance with the terms of the POPO, we have the right to charge a reasonable fee for the processing of any data access request.</li>",
    "</ol>",
    "<h3>Notice of Contact Person to Request Access of Correction:</h3>",
    "<ol start='9'>",
    "<li>",
    "<p>Please contact our following staff to request access or correction of your data.</p>",
    "<p>Data Privacy Officer</p>",
    "<p>Dr. Dennis Lee</p>",
    "<p>Neufast Limited</p>",
    "<p>Address: Unit 2, 3/F, Building 2W, No.2 Science Park Avenue West, Shatin, N.T., Hong Kong</p>",
    "<p>Email: customer-service@neufast.com</p>",
    "</li>",
    "</ol>",
    "<h3>Security Measures</h3>",
    "<ol start='10'>",
    "<li>All data in our system is encrypted during transit and storage. We have applied significant safety measures in a technical and organizational level to ensure the data is stored in a secure manner. However, please be aware that no physical or technical system is completely secure or immune from outages, losses, attacks, circumvention, design or implementation flaws, and human error. Therefore, we cannot and do not ensure or warrant that information you transmit to Neufast will not be lost or compromised, either during or after transmission.</li>",
    "<li>You are responsible for maintaining the secrecy of your unique password and account information at all times, to the extent your access includes an account and password (Candidates do not have an account and password when using the Services).</li>",
    "</ol>"
  ],
  // "Login_Terms": "プライバシーポリシーと利用規約",
  // "Login_Terms_Close": "閉じる",
  // "Login_Terms_Content": ["<h2>Neufast利用規約</h2>",
  //   "<h3>1.規約</h3>",
  //   "<p><a href='http://www.neufast.com'>http://www.neufast.com</a>にアクセスすることで、お客様は、本利用規約およびすべての法令に従うことに同意し、適用される地域の法令を遵守する責任を負うことに同意するものとします。 これらの条件に同意されない場合、このサイトをご利用になることはできません。本ウェブサイトに含まれる資料は、適用される著作権法および商標法によって保護されています。</p>",
  //   "<h3>2. 利用ライセンス</h3>",
  //   "<ol type='a'>",
  //   "<li>Neufastのウェブサイト上の資料（情報またはソフトウェア）を、個人的かつ非商業目的での閲覧のみ、一時的にダウンロードすることが許可されています。これはライセンス付与であり、所有権の譲渡ではなく、このライセンスに基づき、以下のことを行うことはできません。",
  //   "<ol type='i'>",
  //   "<li>資料の変更または複製。</li>",
  //   "<li>営利目的、または公共の場（営利、非営利を問わない）での使用。</li>",
  //   "<li>Neufastのウェブサイトに含まれるいかなるソフトウェアの逆コンパイルまたはリバースエンジニアリングを試みること。</li>",
  //   "<li>資料から著作権またはその他の所有権に関する表記を削除すること、または</li>",
  //   "<li>資料を他人に譲渡したり、他のサーバーに「ミラーリング」すること。</li>",
  //   "</ol>",
  //   "</li>",
  //   "<li>このライセンスは、お客様がこれらの制限に違反した場合、自動的に終了するものとし、Neufastはいつでもこれを終了させることができるものとします。これらの資料の閲覧を終了した場合、または本使用許諾が終了した場合、お客様は、電子または印刷された形式であるかを問わず、お客様が所有するダウンロードした資料をすべて破棄しなければなりません。</li>",
  //   "</ol>",
  //   "<h3>3. 免責事項</h3>",
  //   "<ol type='a'>",
  //   "<li>Neufastのウェブサイトの資料は、「現状のまま」提供されます。Neufastは、明示または黙示を問わず、いかなる保証も行わず、商品性、特定目的への適合性、知的財産またはその他の権利の非侵害に関する黙示の保証または条件を含むがこれに限定されない他のすべての保証を否認し否定するものとします。</li>",
  //   "<li>さらに、Neufastは、ウェブサイト上の資料、または資料や本サイトにリンクされたサイトに関する正確性、可能性のある結果、または使用の信頼性に関して、いかなる保証も表明も行いません。.</li>",
  //   "</ol>",
  //   "<h3>4. 制限事項</h3>",
  //   "<p>NeufastまたはNeufastの認定代理人が口頭または書面でその可能性を通知されていたとしても、Neufastまたはそのサプライヤーは、NeufastのWebサイト上の資料の使用または使用不能から生じるいかなる損害（データまたは利益の損失、事業の中断による損害を含むがこれに限定しない）にも責任を負わないものとします。一部の裁判管轄では、黙示的保証の制限、または結果的もしくは付随的損害に対する責任の制限を認めていないため、これらの制限はお客様に適用されない場合があります。</p>",
  //   "<h3>5. 資料の正確性</h3>",
  //   "<p>Neufastのウェブサイトに表示される資料には、技術的な誤り、誤植、または写真上の誤りが含まれている可能性があります。 Neufastは、そのWebサイト上の資料が正確、完全または最新であることを保証するものではありません。Neufast は、Webサイトに含まれる資料をいつでも予告なく変更することができます。 しかし、 Neufastは資料を更新する義務を負わないものとします。</p>",
  //   "<h3>6.関連リンク</h3>",
  //   "<p>当ウェブサイトにリンクしている全てのサイトにおいて確認するものではなく、リンク先のサイトのコンテンツについて責任を負うものではありません。リンクの掲載は、Neufastがそのサイトを推奨していることを意味するものではありません。リンク先のウェブサイトの使用は、自身の責任で行ってください。</p>",
  //   "<h3>7. 内容変更</h3>",
  //   "<p>Neufastは、当ウェブサイトの利用条件を、必要に応じて予告なしに変更することがあります。 当ウェブサイトのご利用にあたっては、以下のご利用条件をお読みいただき、これらの条件に同意された場合のみご利用ください。.</p>",
  //   "<h3>8. 準拠法</h3>",
  //   "<p>本規約は、香港法に準拠し、同法に従って解釈され、お客様は、同州または所在地の裁判所の専属管轄権に取消不能の形で遵守するものとします。</p>",
  //   "<h3>9. 一般事項</h3>",
  //   "<p>当社は、厳格なプライバシーポリシーの管理に留意しておりますが、欧州連合の一般データ保護規則（GDPR）への完全な準拠を監査・確認されたものではありません。 欧州市民および欧州居住者のユーザーは、当社のサービスの利用を開始する前に、これらを認識し、同意するものとします。</p>",
  //   "<h3>10. 個人情報の削除</h3>",
  //   "<p>お客様のお名前、電子メールアドレス、ログイン情報は、お客様のユーザーアカウントが閉鎖されてから3ヶ月後に、当社のシステムから削除されます。閲覧情報、求人情報、面接の質問、動画、スコア、コメントなどの非個人情報は、評価やサービス品質の向上を目的として集計され、当社のシステムに保存されます。</p>",
  //   "<h3>11. 権利制限を受けないもの</h3>",
  //   "<p>この文責のいかなる内容も、個人データ（プライバシー）条例（PDPO）に基づくデータ主体の権利を制限するものではありません。</p>",
  // ],
  "Forget_Password_Title": "パスワードを忘れた方",
  "Forget_Password_Subtitle": "パスワード再設定用のメールを送信しますので、メールアドレスを入力してください。",
  "Forget_Password_Success_Message": 'パスワード再設定メール送信先 {email}. メールに記載されているリンクを確認し、クリックしてアカウントのパスワードをリセットしてください。',
  "Forget_Password_Email_Not_Found_Message": 'メールアドレスが見つかりません。入力されたメールアドレスが正しいか確認してください。',
  "Reset_Password_Title": "パスワードリセット",
  "Reset_Password_Sutitle": "アカウント保護の為、パスワードを確認してください。: ",
  "Reset_Password_Sutitle_List": [
    '7文字以上で入力してください。.',
    'ユーザー名、またはユーザー名を大幅に含むものは使用しないでください。 "ユーザー名123"など,'
  ],
  "Reset_Password_Success_Message": "パスワードを再設定しました。",
  "Reset_Password_Failed_Message_Token_expired": "パスワードの再設定に失敗しました。",
  "Reset_Password_Failed_Message": "パスワードの再設定に失敗しました。",
  "Reset_Password_Back_Button": "ホームページに戻る",
  "InterviewLanguage_en": "英語",
  "InterviewLanguage_tc": "広東語",
  "InterviewLanguage_sc": "中国語",
  "InterviewLanguage_th": "タイ語",
  "InterviewLanguage_ja": "日本語",
  "InterviewLanguage_id": "バハサ インドネシア語",
  "InterviewLanguage_ms": "マレー語",
  "InterviewLanguage_vi": "ベトナム語",
  "InterviewLanguage_km": "クメール語",
  "InterviewLanguage_kr": "韓国語",
  "InterviewLanguage_bu": "ビルマ語",
  "InterviewLanguage_ta": "フィリピン語",
  "InterviewLanguage_hi": "ヒンディー語",
  "InterviewLanguage_de": "ドイツ人",
  "InterviewLanguage_fr": "フランス語",

  "LayoutSettings_QuestionSubType_TaskPerformance": "タスクパフォーマンス",
  "LayoutSettings_QuestionSubType_InterpersonalRelationshipCommunication": "対人関係とコミュニケーション",
  "LayoutSettings_QuestionSubType_Adaptability": "適応性",

  "Recruiter_Layout_Title": "アセスメントレイアウト設定",
  "Recruiter_Layout_Title_old": "ビデオインタビュー レイアウト設定",
  "Recruiter_Layout_Instruction": "以下に評価のためのレイアウトを設定し、「{action}」を押してください。",
  "Recruiter_Layout_Instruction_old": "以下のビデオインタビューのレイアウトを設定し、'{action}'を押してください。",
  "Recruiter_Layout_CompanyName": "会社名",
  "Recruiter_Layout_CompanyMessage": "面接完了メッセージ",
  "Recruiter_Layout_Timezone": "タイムゾーン",
  "Recruiter_Layout_CV_Upload_Enable" : "Enable Candidate to upload CV",
  "Recruiter_Layout_CV_Upload_Enable_Message" : "If you enable this function, candidate can upload their cv from their side.",
  "Recruiter_Layout_InterviewLanguage": "アセスメントレイアウト言語",
  "Recruiter_Layout_InterviewLanguage_old": "ビデオインタビュー レイアウト言語",
  "Recruiter_Layout_InterviewStart": "開始",
  "Recruiter_Layout_InterviewStartDate": "日付",
  "Recruiter_Layout_InterviewStartTime": "時間",
  "Recruiter_Layout_InterviewEnd": "締切り",
  "Recruiter_Layout_InterviewEndDate": "日付",
  "Recruiter_Layout_InterviewEndTime": "時間",
  "Recruiter_Layout_ShowAvatar": "バーチャル採用担当者を表示",
  "Recruiter_Layout_CompanyVideo": "会社紹介ビデオ",
  "Recruiter_Layout_CompanyVideo_Instruction": "動画をここにドロップするか、クリックしてファイルを選択してください。",
  "Recruiter_Layout_CompanyVideo_Format": "動画ファイルサイズ < 200MB, ファイル形式: AVI, MP4, Mov",
  "Recruiter_Layout_CompanyLogo": "会社ロゴ",
  "Recruiter_Layout_CompanyWebsite": "会社ホームページ",
  "Recruiter_Layout_CompanyLogo_Instruction": "画像をここにドロップするか、クリックしてファイルを選択してください。",
  "Recruiter_Layout_CompanyLogo_Format": "推奨サイズ 300px x 300px",
  "Recruiter_Layout_ColorScheme": "配色",
  "Recruiter_Layout_Question": "質問の設定",
  "Recruiter_Layout_QuestionSet": "質問セット {no}",
  "Recruiter_Layout_QuestionType": "質問形式",
  "Recruiter_Layout_QuestionSubType": "質問項目 サブ形式",
  "Recruiter_Layout_PleaseSelect": "選択してください",
  "Recruiter_Layout_PleaseSelectQuestion": "質問",
  "Recruiter_Layout_Answer": "回答",
  "Recruiter_Layout_QuestionRemove": "削除",
  "Recruiter_Layout_AddQuestion": "質問を追加",
  "Recruiter_Layout_UploadVideo": "ビデオのアップロード",
  "Recruiter_Layout_uploading": "アップロード中・・・",
  "Recruiter_Layout_AddQuestionSet": "質問セットを追加",
  "Recruiter_Layout_Action_Save": "保存",
  "Recruiter_Layout_Action_Confirm": "確認",
  "Recruiter_Layout_Action_Save_MsgSuccess": "保存しました。",
  "Recruiter_Layout_Action_Save_MsgFailed": "保存できませんでした。",
  "Recruiter_Layout_Goback": "戻る",
  "Recruiter_Layout_Next": "次へ",
  "Recruiter_Layout_Submit": "提出する",
  "Recruiter_Layout_QuestionLength": "各回答時間について",
  "Recruiter_Layout_Minutes": "分",
  'Recruiter_Layout_Action_Finish': '終了',
  'Recruiter_Layout_Action_Finish_MsgSuccess': '面接を作成しました',
  'Recruiter_Layout_Step': '手順{step} - ',
  'Recruiter_Layout_No_Preparation_Time': '準備期間なし',
  'Recruiter_Layout_CompanyName_Tooltip': '面接やメールを通して使用される会社名です',
  'Recruiter_Layout_CompanyWebsite_Tooltip': '面接のインターフェイスに表示される会社のウェブサイトのアドレスです。',
  "Recruiter_Layout_InterviewLanguage_Tooltip": "これは候補者評価インターフェースで使用される主な言語です。",
  "Recruiter_Layout_InterviewLanguage_Tooltip_old": "候補者ビデオ面接のインターフェースで使用される主な言語です。",
  "Recruiter_Layout_Timezone_Tooltip": "採用担当者が開始時刻と締切時刻に使用するタイムゾーンです。",
  'Recruiter_Layout_ShowAvatarIdentity': 'バーチャル採用担当者のIDを表示する',
  'Recruiter_Layout_AvatarIdentity': 'バーチャル採用担当者のID',
  "Recruiter_Layout_FirstName": "名前",
  "Recruiter_Layout_LastName": "苗字",
  "Recruiter_Layout_JobTitle": "職種",
  'Recruiter_Layout_AvatarIdentity_Tooltip': '候補者に表示されるバーチャル採用担当者のIDです',
  "Recruiter_Layout_ShowAvatar_Tooltip": "質問を読み上げるバーチャル採用担当者画像を表示します。",
  "Recruiter_Layout_ShowAvatarIdentity_Tooltip": "このスイッチでバーチャル採用担当者が表示され、候補者はこのバーチャル採用担当者に紹介されます。",
  "Recruiter_Layout_CompanyVideo_Tooltip": "この映像は、候補者を惹きつける為に、面接の最初に上映されます",
  "Recruiter_Layout_VideoReduction": "会社ビデオのファイルサイズを縮小処理しています。設定を続けてください。.",
  "Recruiter_Layout_CompanyLogo_Tooltip": "面接のインターフェイスに表示されている会社ロゴです。",
  "Recruiter_Layout_ColorScheme_Tooltip": "面接のインターフェイスに使われているメインカラーです。",
  "Recruiter_Layout_PreparationTime": "各設問の準備時間",
  "Recruiter_Layout_Totaltime": "このテストの総回答時間です",
  'Recruiter_Layout_PreparationLength_Tooltip': "この時間は、回答前、考える為に設けられています。",
  "Recruiter_Layout_QuestionLength_Tooltip": "各質問に回答するために設けられた時間です。",
  "Recruiter_Layout_CompanyMessage_Tooltip": "面接終了時の候補者へのメッセージです。",
  "Recruiter_Layout_AdvancedSetting": "詳細設定",
  "Recruiter_Layout_ScreenLayout": "採用担当者／候補者の画面レイアウト",
  'Recruiter_Layout_Arrangement_Tooltip': "採用担当者と候補者の画面のレイアウトスタイルを設定します。",
  "Recruiter_Layout_TwoScreens": "同じ画面を2つ並べて表示",
  "Recruiter_Layout_BigSmallScreen": "大スクリーンと小スクリーンを1つずつ表示",
  "Recruiter_Layout_AddQuestionSet_Tooltip": "面接の質問にランダム性を持たせるため、質問セットの1つを候補者に提示する。",
  "Recruiter_Layout_Pronunciation": "発音",
  "Recruiter_Layout_Pronunciation_None": "無し",
  "Recruiter_Layout_Pronunciation_Philipplines": "フィリピン",
  "Recruiter_Question_Title": "アセスメントの質問設定",
  "Recruiter_Test_Setting_Title": "アセスメントの設定",
  "Recruiter_Question_Title_old": "ビデオ面接の質問設定",
  "Recruiter_Settings_Test_Settings_Video_Interview": "ビデオ面接",
  "Recruiter_Settings_Test_Settings_Multiple_Choices": "複数選択",
  "Recruiter_Settings_Test_Settings_Short_Questions": "短い質問",
  "Recruiter_Settings_Test_Settings_Test_Name": "テスト名(オプション)",
  "Recruiter_Settings_Test_Settings_Add_Choice": "追加選択",
  "Recruiter_Settings_Test_Settings_Choice": "選択肢{number}",
  "Recruiter_Settings_Test_Settings_Single_Answer": "回答は1つのみ",
  "Recruiter_Settings_Test_Settings_Multiple_Answers": "複数回答",
  "Recruiter_Settings_Test_Settings_Required_Field": "必須項目です。",
  "Recruiter_Settings_Test_Settings_Test_Duaration": "テスト時間",
  "Recruiter_Settings_Test_Settings_Copy": "コピー",
  "Recruiter_Settings_Test_Settings_Delete": "削除",
  "Recruiter_Layout_QuestionLanguage": "言語",
  "Recruiter_Question_Instruction": "評価に問題を追加して、「{action}」を押してください。問題セットの追加'を押すと、問題セットの1つがランダムに選択され、受験者に提示されます。",
  "Recruiter_Question_Instruction_old": "ビデオ面接に質問を追加して、'{action}'を押してください。'Add Question Set'を押すことで追加の質問セットを追加することができ、質問セットのうち1つがランダムに選択され、候補者に提示されます。",
  "Recruiter_Multiple_Choices_Question_Instruction": "多肢選択式テストに質問を追加してください。選択肢の横にある円をクリックして、模範解答であることを示すことができます。複数回答の質問のモデル回答として、複数の選択肢を選択できます。",
  "Recruiter_Short_Question_Instruction": "短文問題テストに問題を追加してください。",
  "Recruiter_Question_CustomizeVirtualInterviewer": "カスタマイズされたバーチャル採用担当者（オプション、ビデオ/画像）。",
  "Recruiter_Question_VirtualInterviewer_Tips": "画像/動画がアップロードされていない場合、デフォルトのバーチャル採用担当者が表示されます。",
  "Recruiter_Question_File_Format": "ファイルサイズ < 20MB, 形式: AVI, MP4, Mov, JPG, PNG",
  "Recruiter_Question_Voice_Tooltip": "面接中の質問音声のオン/オフ切り替え",
  "Recruiter_Question_Contain": "この質問には:",
  "Recruiter_Email_Title": "候補者へのメールとSMSの送信",
  "Recruiter_Email_CompanyLogo": "会社ロゴ",
  "Recruiter_Email_DropFile_Title": "画像をここにドロップするか、クリックしてファイルを選択してください。",
  "Recruiter_Email_DropFile_Message": "推奨サイズ 300px x 300px",
  "Recruiter_Email_EmailDomain": "メールドメイン",
  "Recruiter_Email_Invitation": "招待状",
  "Recruiter_Email_Invitation_Title": "アセスメントへのご招待",
  "Recruiter_Email_HighScoreContent_Title": "アセスメントへのご招待",
  "Recruiter_Email_MediumScoreContent_Title": "アセスメントへのご招待",
  "Recruiter_Email_LowScoreContent_Title": "評価への招待",
  "Recruiter_Email_Invitation_Title_old": "ビデオインタビューへのご招待",
  "Recruiter_Email_Reminder": "リマインダー",
  "Recruiter_Email_Reminder_Title": "評価に関する注意点",
  "Recruiter_Email_Reminder_Title_old": "ビデオインタビューに関する注意事項",
  "Recruiter_Email_Extension": "締切日の変更",
  "Recruiter_Email_Extension_Title": "評価期限を変更",
  "Recruiter_Email_Extension_Title_old": "ビデオ面接の期限を変更",
  "Recruiter_Email_Confirmation": "確認事項",
  "Recruiter_Email_Confirmation_Title": "評価完了",
  "Recruiter_Email_Confirmation_Title_old": "ビデオインタビュー完了",
  "Recruiter_Email_AdvancedSettings": "詳細設定",
  "Recruiter_Email_Section_Title": "タイトル",
  "Recruiter_Email_Section_Message": "メッセージ",
  "Recruiter_Email_Section_Add_Attachment_Title": "添付ファイルを追加する",
  "Recruiter_Email_Section_Add_Attachment_Message": "ここでファイルを押すかドラッグして添付します (1 ファイル <20MB のみ)",
  "Recruiter_Email_Section_AddCompanyLogo": "会社ロゴを追加",
  "Recruiter_Email_High_Score_Heading": "高総合得点（7～10点）候補のレポート",
  "Recruiter_Email_Medium_Score_Heading": "総得点中位（4～6点）候補のレポート",
  "Recruiter_Email_Low_Score_Heading": "総得点下位（0～3点）候補のレポート",
  "Recruiter_Email_Section_AddSMS": "SMSを追加",
  "Recruiter_Email_Section_AddComment": "コメント追加",
  "Recruiter_Email_Save": "保存",
  "Recruiter_Email_Intoduction": "以下のボタンをクリックして、メールとSMSメッセージを開き、{action}を押してください。",
  "Recruiter_Email_Invitation_Tips": "招待メールでは、受験者にアセスメントの実行を求めます。",
  "Recruiter_Email_Invitation_Tips_old": "招待メールでは、受験者に評価の実行を求める",
  "Recruiter_Email_Reminder_Tips": "リマインダーメールは締切の24時間前に送信されます。",
  "Recruiter_Email_Extension_Tips": "本メールは、審査期限を変更した際に受験者に送信されます。",
  "Recruiter_Email_Extension_Tips_old": "このメールは、ビデオ面接の締切が変更になった際に候補者に送信されます",
  "Recruiter_Email_Confirmation_Tips": "確認書は、受験者の審査終了後に自動送信されます。",
  "Recruiter_Email_Redo": "面接のやり直し",
  "Recruiter_Email_Redo_Tips": "このメールは、候補者にビデオ面接のやり直しを要求するものです。",
  "Recruiter_Email_Report_Tips": "このメールは候補者にレポートを送信します。",
  "Recruiter_Email_Redo_Title": "ビデオ面接の一部再受験",
  "Recruiter_Email_Report_Title": "ビデオ面接開発レポート",
  "Recruiter_Email_Report_Section_Title": "候補者へのレポート",
  "Recruiter_Scoring_Title": "能力自動採点設定",
  "Recruiter_Scoring_ImpressionScore": "評価基準",
  "Recruiter_Scoring_PerformanceScore": "パフォーマンススコア",
  "Recruiter_Scoring_Weighting": "ウェイト付け (%)",
  "Recruiter_Scoring_Total": "合計:",
  "Recruiter_Scoring_Save": "保存",
  "Recruiter_Scoring_MsgNotSumTo100": "保存する前に100%まで加算してください。",
  "Recruiter_Scoring_MsgNotSumTo0": "重要、必須、ボーナスのうち、少なくとも1つの分野を選択してください。",
  "Recruiter_Scoring_Save_MsgSuccess": "保存しました。",
  "Recruiter_Scoring_Save_MsgFailed": "保存できませんでした。",
  "Recruiter_Scoring_Critical": "重要",
  "Recruiter_Scoring_Required": "必須",
  "Recruiter_Scoring_Bonus": "ボーナス",
  "Recruiter_Scoring_Irrelevant": "不適切",
  "Recruiter_Scoring_Introduction": "この仕事で重要なコンピテンシーのウエイトを選択してください。面接スコアは、これらのコンピテンシーの重み付けに応じた回答から算出されます。",
  'Recruiter_Scoring_Impression': '印象スコアリング',
  'Recruiter_Scoring_TaskPerformance': 'タスク・パフォーマンス・スコアリング',

  "Recruiter_Scoring_PotentialWorkPerformance": "潜在的なワークパフォーマンスのスコアリング",
  "Recruiter_AIRating_PotentialWorkPerformance": "潜在的なワークパフォーマンスのスコアリング",

  'Recruiter_Scoring_ContextualPerformance': '文脈能力スコアリング',
  'Recruiter_Scoring_AdaptivePerformance': '適応能力スコアリング',
  "Recruiter_Scoring_Leadership_Definition": "他者をリードし、影響を与える際に自己主張ができ、ダイナミックかつエネルギッシュに自他を成功に導き、他者をやる気にさせることができる。",
  "Recruiter_Scoring_DevelopingPeople_Definition": "個人は人として、またプロフェッショナルとして成長する可能性を持っていると信じ、フィードバックやコーチング、能力開発のための課題や経験を提供することで、それをサポートする。",
  "Recruiter_Scoring_GoalAndAchievementStriving_Definition": "目標を達成するために勤勉であり、効果的な実行と目標達成を確実にするために、タスクやプロジェクトのリソースと進捗を計画し、管理する組織力がある。",
  "Recruiter_Scoring_Responsibility_Definition": "個人的な責任を負い、物事を実現することに集中し、自らの能力を活かして自立的に職務を遂行する。",
  "Recruiter_Scoring_ManagingExecution_Definition": "リソースタスクやアクティビティのための組織的かつ協調的な計画を立て、スケジュールや目標に従ってタスクやプロジェクトを円滑に実行できるよう、指示や手順に従う。",
  "Recruiter_Scoring_AnalyticalAndLogicalThinking_Definition": "好奇心旺盛で、問題を探求し、調査し、情報やアイデアを収集・統合し、批判的に分析・評価して、一連の一般的な観察と特定の事実から結論を導き出すことができる。",
  "Recruiter_Scoring_ComplexProblemSolving_Definition": "大量の情報を精査し、問題の本質を明らかにし、柔軟に思考して行動を特定し、代替案を評価し、目標達成のための様々な選択肢の長所と短所を判断することができる。",
  "Recruiter_Scoring_Communication_Definition": "自信を持って口頭でコミュニケーションをとり、アイディアや情報を流暢に、明確に、簡潔に、整理して、説得力のある方法で提示することができる。",
  "Recruiter_Scoring_CaringAndEmpathy_Definition": "他者への思いやりと配慮を示し、他者のニーズに敏感であり、積極的に耳を傾け、共感を示すことによって、個人的に他者と関わることができる。",
  "Recruiter_Scoring_EnglishOralCommunication_Definition": "英語で流暢かつ明瞭に話すことができる。",
  "Recruiter_Scoring_CantoneseOralCommunication_Definition": "広東語で流暢かつ明瞭に話すことができる。",
  "Recruiter_Scoring_MandarinOralCommunication_Definition": "中国語で流暢かつ明瞭に話すことができる。",
  "Recruiter_Scoring_InterpersonalRelationship_Definition": "チームワークと共同行動で効果的に人と関わり、部門内および/または組織間で良好な関係を構築し維持する。",
  "Recruiter_Scoring_TeamCollaborationAndInclusion_Definition": "異なる背景、文化、組織を持つ人々と仕事をするとき、文化的な配慮をし、敬意を示すことによって、容易に他者との信頼を築き、協力的かつ親切に仕事をする。",
  "Recruiter_Scoring_BuildingRelationshipsAndNetwork_Definition": "幅広い層の人々と交流し、部門や機能、組織内外で良好な関係を築き、ネットワークを構築する能力を有する。",
  "Recruiter_Scoring_FlexibilityAndAdaptability_Definition": "新しい状況に応じて行動を適応させ、曖昧さの中で効果的に働き、目的達成のために他者との相互作用の中で自らのアプローチを柔軟にすることができる。",
  "Recruiter_Scoring_LearningAgility_Definition": "好奇心旺盛で内省的であり、継続的に学習する姿勢と新たな学習を獲得する機敏さを備えている。",
  "Recruiter_Scoring_CreativityAndInnovation_Definition": "想像力に富み、新しいアイデアを生み出し、問題解決やサービス・製品の品質向上のために新しい発明・実践を行う。",
  "Recruiter_Scoring_EmotionalIntelligence_Definition": "困難や逆境に直面しても、感情のコントロールと楽観性を保ち、粘り強く行動し、耐性力がある。",
  "Recruiter_Scoring_Enthusiasm_Definition": "生活全般における物事や人々に対し、情熱的、楽観主義的、精力的な関心を示す。",
  "Recruiter_Scoring_Composure_Definition": "プレッシャーがかかっても、緊張感や心配性、苛立ちを感じることなく、冷静さを保つことができる",
  "Recruiter_Scoring_SelfConfidence_Definition": "どのような状況下でも問題を解決し、目標を達成できる自己肯定感や力量がある。",
  "Recruiter_Scoring_VisionAndEntrepreneurialMindset_Definition": "起業家精神を持って問題を発見し、ビジョンを描き、実行することができる。ビジネスチャンスを発見し、未来像を描き、リスクを考慮しながら体系的に粘り強く行動し、問題解決のための革新と発明をもたらす。",
  "Recruiter_Scoring_TechnologyExpertiseAndBusinessSense_Definition": "技術的な専門知識を市場ニーズに合わせて適用できる。 技術に関するスキルと知識を有し、最新の技術に精通し、その知識を市場のニーズに対応するために重要なビジネス課題を理解しながら適用することができる。",
  "Recruiter_Scoring_EffectiveCommunicationAndTeambuilding_Definition": "アイデアを提示し、明確に伝えることができ、成功するチームを構築し、巻き込むことができる。流暢かつ簡潔で説得力のあるコミュニケーションを行い、共通の目標を設定し、知識、経験、成功を共有し、個人の違いを尊重することによって、より良いチームワークを促進する為に他者に影響を与えることができる。",
  "Recruiter_Scoring_GritAndPassion_Definition": "忍耐強く、失敗から立ち直り、情熱と規律をもって集中することができる。 成功への勇気と決意、そして規律ある努力と、その過程で直面する困難や逆境にもかかわらず長期的な目標を達成するための誠実な興味と熱意を併せ持つ。",

  "Recruiter_Scoring_TaskPerformance_Definition": "計画、組織化、日常業務の管理、職責を果たす能力",
  "Recruiter_Scoring_InterpersonalRelationshipCommunication_Definition": "チームワークとコラボレーションで効果的に人と関わり、部門内および/または組織間で良好な関係を構築する能力",
  "Recruiter_Scoring_Adaptability_Definition": "新しい状況に応じて行動を適応させる敏捷性、曖昧さの中で効果的に働くことができ、目的達成のために他者との相互作用の中で自らのアプローチを柔軟に変えることができること。 ",

  "Recruiter_Evaluation_Title": "レビュアー・スコアリング能力の設定",
  "Recruiter_Evaluation_Instruction": "スコアリングのための能力は、以下のように修正することができます。尚、この変更は本求人におけるすべての候補者に適用されます。 削除された能力データは全て失われます。",
  "Recruiter_Evaluation_AddCategory": "+ ここに入力してカテゴリを追加",
  "Recruiter_Evaluation_AddCriterion": "+ ここに入力して基準を追加",
  "Recruiter_Evaluation_AddCategoryButton": "+ カテゴリーを追加",
  "LayoutSettings_QuestionType_General": "人事・採用全般",
  "LayoutSettings_QuestionType_SoftSkills": "能力ソフトスキル",
  "LayoutSettings_QuestionSubType_Intro": "はじめに",
  "LayoutSettings_QuestionSubType_Motivation": "志望動機・キャリアプラン",
  "LayoutSettings_QuestionSubType_Strenth": "長所・実績・短所",
  "LayoutSettings_QuestionSubType_Attitude": "姿勢・関心・価値観",
  "LayoutSettings_QuestionSubType_Understanding": "役割／企業理解",
  "LayoutSettings_QuestionSubType_WorkPlan": "事業計画",
  "LayoutSettings_QuestionSubType_Salary": "給与",
  "LayoutSettings_QuestionSubType_Others": "その他",
  "LayoutSettings_QuestionSubType_Leadership": "リーダーシップ・マネジメント",
  "LayoutSettings_QuestionSubType_Teamwork": "チームワーク・サービス指向",
  "LayoutSettings_QuestionSubType_Communication": "コミュニケーション・人間関係の構築",
  "LayoutSettings_QuestionSubType_ProblemAnalysis": "理解・課題分析",
  "LayoutSettings_QuestionSubType_Strategy": "戦略・革新",
  "LayoutSettings_QuestionSubType_Process": "プロセス・実行の管理",
  "LayoutSettings_QuestionSubType_Change": "変化・耐性",
  "LayoutSettings_QuestionSubType_Venturing": "ベンチャー志向・成果主義",
  "Recruiter_Settings_Title": "仕事＆アセスメント設定",
  "Recruiter_Settings_Title)old": "ジョブインタビューとビデオインタビューの設定",
  "Recruiter_Settings_BulkAction": "一括処理",
  "Recruiter_Settings_AddJob": "仕事を追加する",
  "Recruiter_Settings_Edit": "編集",
  "Recruiter_Settings_Action_Import": "インポート",
  "Recruiter_Settings_Action_Export": "エクスポート",
  "Recruiter_Settings_Action_Remove": "削除",
  "Recruiter_Settings_JobCount": "{count} 仕事",
  "Recruiter_Settings_TableColumn_Department": "部署名",
  "Recruiter_Settings_TableColumn_JobTitle": "職種",
  "Recruiter_Settings_TableColumn_Created_At": "作成日時",
  "Recruiter_Settings_TableColumn_NoOfQuestion": "質問数",
  "Recruiter_Settings_TableColumn_NoOfCandidates": "候補者数",
  "Recruiter_Settings_TableColumn_Deadline": "締切日",
  "Recruiter_Settings_TableColumn_CompletionRate": "完了率",
  "Recruiter_Settings_Import_Title": "候補者情報をアップロードするファイルを選択してください。",
  "Recruiter_Settings_Import_FileDropTitle": "ここにファイルをドロップするか、クリックしてファイルを選択してください。",
  "Recruiter_Settings_Import_FileDropFormat": "対応ファイル形式: .csv ・ .xls ・ .xlsx",
  "Recruiter_Settings_Import_UploadNote": "* アップロードされるファイルには、候補者の氏名、Eメール（必須項目）のほか、国番号、電話番号、大学名、学位（非必須項目）が含まれていなければなりません。データは列で表示されるものとします。 こちらからサンプルをダウンロードしてください。 ",
  "Recruiter_Settings_Import_UploadTemplate": "ダウンロード",
  "Recruiter_Settings_Export_TopPercentile": "上位パーセンタイル",
  "Recruiter_Settings_Export_Title": "エクスポートデータ",
  "Recruiter_Settings_Export_Description": "エクスポートしたいデータを下記から選択してください。",
  "Recruiter_Settings_Export_ItemCount": "{count} 項目",
  "Recruiter_Settings_Export_TickBox": "ボックスをチエックして選択",
  "Recruiter_Settings_Export_Select_All": "全て選択",
  "Recruiter_Settings_Export_Column_CandidateName": "候補者氏名",
  "Recruiter_Settings_Export_Column_University": "大学",
  "Recruiter_Settings_Export_Column_DegreeTitle": "学位名",
  "Recruiter_Settings_Export_Column_TelephoneNumber": "電話番号",
  "Recruiter_Settings_Export_Column_EmailAddress": "メールアドレス",
  "Recruiter_Settings_Export_Column_RecruiterProgram": "採用担当者プログラム",
  "Recruiter_Settings_Export_Column_OverallScore": "総合評価",
  "Recruiter_Settings_Export_Column_ImpressionScore": "印象スコア",
  "Recruiter_Settings_Export_Column_PotentialWorkPerformanceScore": "潜在的なワークパフォーマンススコア",
  "Recruiter_Settings_Export_Column_Personal_Information": "個人情報",
  "Recruiter_Settings_Export_Column_Interview_Information": "面接情報",
  "Recruiter_Settings_Export_Column_Interview_Result": "面接結果",
  "Recruiter_Settings_Export_Column_Programme_Statistics": "プログラム統計",
  "Recruiter_Settings_Export_Column_Programme_Setting": "プログラム設定",
  "Recruiter_Settings_Export_Column_Candidate_Answer": "候補者の答え",
  "Recruiter_Settings_Export_help_0": "候補者のフルネーム、電子メール、大学、学位、電話番号がエクスポートされます。",
  "Recruiter_Settings_Export_help_1": "これにより、各候補者の採用担当者の電子メール、ジョブID、面接の開始日と終了日、評価状況、パスワードがエクスポートされます。",
  "Recruiter_Settings_Export_help_2": "これにより、選択された評価における候補者の個々のスコアがエクスポートされます。",
  "Recruiter_Settings_Export_help_3": "これにより、選択した評価における受験者の統計情報がエクスポートされます。",
  "Recruiter_Settings_Export_help_4": "これにより、選択した評価の設定がエクスポートされます。",
  "Recruiter_Settings_Export_help_5": "これにより、選択したアセスメントの受験者の回答がエクスポートされます.",
  "Recruiter_Settings_Action_Edit_ErrorInterviewInProgress": "面接は継続中のため、設定は変更しないでください。",
  "Recruiter_Settings_Action_Export_ErrorNoCompletedCandidate": "エクスポートに失敗しました。  候補者結果のエクスポートは、少なくとも1人の候補者が面接を完了後のみ可能です。",
  "Recruiter_Settings_Action_Export_MsgSuccess": "ファイルのエクスポートに成功しました。",
  "Recruiter_Settings_Action_Import_MsgSuccess": "候補者が正常にインポートされました。アセスメントに招待することができます。",
  "Recruiter_Settings_Action_Import_MsgSuccess_old": "候補者が正常にインポートされました。ビデオインタビューに招待することができます。",
  "Recruiter_Settings_Action_Import_Error": "アップロードされたファイルはサポートされていません。",
  "Recruiter_Settings_Action_Import_Error_Column_Not_Match": "Excel/csvファイルの列タイトルが、必要な形式と一致していません。例に従ってください。",
  "Recruiter_Settings_Action_Import_Error_Column_duplicate": "複数の候補者が同じEメールアドレスを使用している場合は、削除して再度アップロードしてください。",
  "Recruiter_Settings_Action_Import_Error_Miss_Information": "候補者に必要な情報が不足している部分があります。",
  "Recruiter_Settings_Action_Delete_MsgSuccess": "仕事の削除が完了しました",
  "Recruiter_Settings_Action_Delete_Error": "仕事の削除に失敗しました",
  "Recruiter_Setting_Msg_Delete_title": "仕事の削除",
  "Recruiter_Setting_Msg_Delete_content": "この操作により、選択した仕事は削除され、元に戻すことはできません。この操作を実行しますか？",
  "Recruiter_Setting_Msg_VideoWithAudio_title": "質問を保存する",
  "Recruiter_Setting_Msg_VideoWithAudio_content": "ご注意 一部の面接質問では、自動生成音声をオンにした状態でバーチャル採用担当者の映像が使用されます。そのため、面接時の音声が2種類になることがあります。この設定でよろしいですか? ",
  "Recruiter_Settings_Instruction_1": "ようこそ！ {user},",
  "Recruiter_Settings_Instruction_2": "このページではアセスメントの一覧を表示します。",
  "Recruiter_Settings_Instruction_3": "右上の[ +仕事を追加 ]ボタンを押すと開始されます。",
  "Recruiter_Settings_Add_Title": "新しい仕事を追加",
  "Recruiter_Settings_Add_RecentDepartment": "最近の部門から選択",
  "Recruiter_Settings_Add_CreateNewDepartment": "新規の部門を作る",
  "Recruiter_Settings_Add_JobName": "新しい職種名",
  "Recruiter_Settings_Add_Copy_title": "他の仕事から設定をコピーする",
  "Recruiter_Settings_Add_Confirm": "確認",
  "Recruiter_Settings_Test": "テスト {number}",
  "Recruiter_Settings_Test_Video_Interview": "ビデオ面接",
  "Recruiter_Settings_Test_Multiple_Choices": "複数選択",
  "Recruiter_Settings_Test_Short_Question": "短い質問",
  "Recruiter_Settings_Test_Test_Name": "テスト名",
  "Recruiter_Settings_Test_Add_Test": "テストの追加",
  "Recruiter_Settings_Special_Character_Error": '特殊文字 ";/?:@=&" は使用できません。',
  "Recruiter_Settings_Duplicate_Department": "部門名が重複しています。",
  "Recruiter_Settings_SideMenu_InterviewLayout": "アセスメントレイアウト",
  "Recruiter_Settings_SideMenu_InterviewQuestion": "面接質問",
  "Recruiter_Settings_SideMenu_InterviewEmail": "メール＆SMS",
  "Recruiter_Settings_SideMenu_Scoring": "能力自動採点",
  "Recruiter_Settings_SideMenu_Evaluation": "レビュアー・能力・スコアリング",
  "Recruiter_Settings_SideMenu_TestSetting": "アセスメント設定",
  'Recruiter_Settings_Addjob_disable': '全ての使用可能枠を使用している為、新規の仕事を追加することはできません。面接枠を増やすには、管理者に連絡してください。',
  "Recruiter_Stat_Title": "統計情報",
  "Recruiter_Stat_Filter": "フィルター",
  "Recruiter_Stat_Filter_OverallScore": "総合評価",
  "Recruiter_Stat_Filter_ImpressionScore": "印象スコア",
  "Recruiter_Stat_Filter_Potential_Work_Performance": "潜在的なワークパフォーマンス",
  "Recruiter_Stat_Filter_Pace": "雄弁さ",
  "Recruiter_Stat_Filter_Enthusiasm": "熱意",
  "Recruiter_Stat_Filter_SelfConfidence": "自信",
  "Recruiter_Stat_Filter_Composure": "落ち着き",
  "Recruiter_Stat_Filter_Leadership": "リーダーシップ",
  "Recruiter_Stat_Filter_Learning_Agility": "アジリティの学習",
  "Recruiter_Stat_Filter_Creativity_And_Innovation": "創造性と革新性",
  "Recruiter_Stat_Filter_Emotional_Intelligence": "感情知能",
  "Recruiter_Stat_Filter_Communication": "コミュニケーション",
  "Recruiter_Stat_Filter_Interpersonal_Relationship": "対人関係",
  "Recruiter_Stat_Filter_Goal_And_Achievement_Striving": "目標達成への取り組み",
  'Recruiter_Stat_Filter_Impression': '印象スコア',
  'Recruiter_Stat_Filter_TaskPerformance': 'タスク・パフォーマンス・スコア',
  'Recruiter_Stat_Filter_ContextualPerformance': '文脈能力スコア',
  'Recruiter_Stat_Filter_AdaptivePerformance': '適応能力スコア',

  "Recruiter_Stat_Action_Export": "エクスポート",
  "Recruiter_Stat_Section_CompletedCandidates": "完了した候補者",
  "Recruiter_Stat_Section_NoOfDaysLeft": "残り日数",
  "Recruiter_Stat_Section_NoOfQuestion": "質問数",
  "Recruiter_Stat_Section_NoOfCandidate": "候補者数",
  "Recruiter_Stat_Section_Deadline": "締切日",
  "Recruiter_Stat_Section_Trackers": "トラッキング",
  "Recruiter_Stat_Section_Trackers_Invitation": "招待状",
  "Recruiter_Stat_Section_Trackers_Reminder": "リマインダー",
  "Recruiter_Stat_Section_Trackers_Confirmation": "確認事項",
  "Recruiter_Stat_Section_OverallScore": "総合評価",
  "Recruiter_Stat_Section_OverallScore_Average": "平均",
  "Recruiter_Stat_Section_OverallScore_StandardDeviation": "標準偏差",
  "Recruiter_Stat_Section_OverallScore_Skewness": "歪度",
  "Recruiter_Stat_Section_CandidateVideoScoreDist": "候補者ビデオのスコア分布",
  "Recruiter_Stat_Section_NormalizedScore": "正規化スコア",
  "Recruiter_Stat_Deadline_Expired": "期限切れ",
  "Recruiter_JobSelection_Title": "仕事を選択してください。 ",
  "Recruiter_ProgrammeSelection_Title": "部門を選択してください。",
  "Recruiter_ProgrammeSelection_Cancel": "取消",
  "Recruiter_ProgrammeSelection_Go_Back": "戻る",
  "Recruiter_Dashboard_Title": "候補者",
  "Recruiter_Dashboard_CandidateCount": "{count} 候補者",
  "Recruiter_Dashboard_InterviewDeadline": "面接締切日",
  "Recruiter_Dashboard_Search": "検索",
  "Recruiter_Dashboard_FilterByTop": "トップで絞り込む",
  "Recruiter_Dashboard_Add_Candiadte": "候補者を追加",
  "Recruiter_Dashboard_BulkInvite": "招待する",
  "Recruiter_Dashboard_BulkReport": "候補者にレポートを送る",
  "Recruiter_Dashboard_BulkExport": "エクスポート",
  "Recruiter_Dashboard_BulkModify": "締切日の変更",
  "Recruiter_Dashboard_BulkAction": "一括処理",
  "Recruiter_Dashboard_BulkDelete": "削除",
  "Recruiter_Dashboard_BulkRedo": "リセット",
  "Recruiter_Dashboard_BulkDownloadPDF":"PDFレポートをダウンロード",
  "Recruiter_Dashboard_Filter_Auto_Score": "自動採点",
  "Recruiter_Dashboard_Filter_Recruiter_Score": "マイ・スコアリング",
  "Recruiter_Dashboard_Action_View": "表示",
  "Recruiter_Dashboard_Action_Invite": "招待",
  'Recruiter_Dashboard_Action_Redo': "リセット",
  "Recruiter_Dashboard_TableColumn_Name": "氏名",
  "Recruiter_Dashboard_TableColumn_University": "大学",
  "Recruiter_Dashboard_TableColumn_Status": "ステータス",
  "Recruiter_Dashboard_TableColumn_Status_Pending": "招待状保留中...",
  "Recruiter_Dashboard_TableColumn_Status_Wait_Invite": "招待状送付、審査待ち",
  "Recruiter_Dashboard_TableColumn_Status_Processing": "ビデオ処理中 ....",
  "Recruiter_Dashboard_TableColumn_Status_Complete": "完了",
  'Recruiter_Dashboard_TableColumn_Status_Partial_Complete': "一部完了",
  "Recruiter_Dashboard_TableColumn_AutoScoring": "自動採点",
  "Recruiter_Dashboard_TableColumn_RecruiterScoring": "マイ・スコアリング",
  "Recruiter_Dashboard_TableColumn_TestScores": "テストスコア",
  "Recruiter_Dashboard_TableColumn_TotalScore": "総合スコア",
  "Recruiter_Dashboard_TableColumn_Video": "ビデオ",
  "Recruiter_Dashboard_TableColumn_AIReport": "AIレポート",
  "Recruiter_Dashboard_TableColumn_RecruiterEvaluation": "採用担当者評価",
  "Recruiter_Dashboard_TableColumn_Start_Date": "審査開始",
  "Recruiter_Dashboard_TableColumn_End_Date": "審査締切",
  "Recruiter_Dashboard_TableColumn_Action": "動作",
  "Recruiter_Dashboard_TableColumn_Delete": "削除",
  "Recruiter_Dashboard_TableColumn_Tooltip_Invite": "審査へ招待",
  "Recruiter_Dashboard_TableColumn_Tooltip_Report": "レポートを送信",
  "Recruiter_Dashboard_TableColumn_Tooltip_Report_Sent": "候補者レポートを送付",
  "Recruiter_Dashboard_TableColumn_Tooltip_Redo": "候補者アカウントをリセット",
  "Recruiter_Dashboard_TableColumn_Tooltip_Delete": "候補者の削除",
  "Recruiter_Dashboard_TableColumn_Pending": "保留",
  "Recruiter_Dashboard_TableColumn_Tooltip_Shortlist": "ショートリスト",
  "Recruiter_Dashboard_TableColumn_Tooltip_Reject": "不採用",
  "Recruiter_Dashboard_TableColumn_Tooltip_WaitingList": "ウェイティングリストに追加",
  "Recruiter_Dashboard_TableColumn_Tooltip_Edit": "候補者情報の編集",
  "Recruiter_Dashboard_TableColumn_Tooltip_change_deadline": "締切日の変更",
  "Recruiter_Dashboard_TableColumn_Tooltip_Share": "レビュアーと共有",
  "Recruiter_Dashboard_TableColumn_Tooltip_CV_Uploaded": "履歴書のアップロード",
  "Recruiter_Dashboard_TableColumn_Tooltip_Download": "候補者の動画をダウンロードする",
  "Recruiter_Dashboard_Dialog_Invitation_Title": "招待状",
  "Recruiter_Dashboard_Dialog_Report_Title": "レポート",
  "Recruiter_Dashboard_Dialog_Invitation": "選択された候補者に評価のための招待状を送りますか？",
  "Recruiter_Dashboard_Dialog_Report": "選択した候補者に候補者レポートを送信しますか？ ",
  "Recruiter_Dashboard_Dialog_Wrong_CV_Filetype": "履歴書のアップロードに失敗しました。ファイル形式を確認してください。",
  "Recruiter_ShareDialog_Title": "メールでレビュアーと共有",
  "Recruiter_ShareDialog_Subtitle_1": "選択した候補者",
  "Recruiter_ShareDialog_Caption_1": "こちらが共有する候補として選択されました。メールの近くにある十ボタンを押すと削除できます。",
  "Recruiter_ShareDialog_ReviewerInfo": "レビュアー情報",
  "Recruiter_ShareDialog_Caption_2": "「追加」ボタンを押すと、複数のレビュアーに招待メールを送ることができます。",
  "Recruiter_ShareDialog_Add": '追加',
  "Recruiter_ShareDialog_Name": "氏名",
  "Recruiter_ShareDialog_Email": "メール",
  "Recruiter_ShareDialog_Message": "メッセージ",
  "Recruiter_ShareDialog_Caption_3": "このメッセージは、評価案内のメールに添付されます。",
  "Recruiter_ShareDialog_Confirm": "確認",
  "Recruiter_ShareDialog_Cancel": "キャンセル",
  "Recruiter_ShareDialog_Success": "招待メールが正常に送信されました。",
  "Recruiter_ShareDialog_Fail": "招待メールの送信に失敗しました。",
  "Recruiter_Dashboard_Msg_Invite_Duplicate_title": "メールの再送信",
  "Recruiter_Dashboard_Msg_Report_Duplicate_title": "レポートの再送信",
  "Recruiter_Dashboard_Msg_Invite_Duplicate_content": "この候補者にはすでに招待状が送信されています。もう一度送信しますか？",
  "Recruiter_Dashboard_Msg_Report_Duplicate_content": "この候補者にはすでに候補者レポートを送信しています。もう一度送信しますか？",
  "Recruiter_Dashboard_InviteDuplicate_No": "いいえ",
  "Recruiter_Dashboard_InviteDuplicate_Yes": "はい",
  "Recruiter_Dashboard_InviteSuccess": "招待状は正常に送信されました。",
  "Recruiter_Dashboard_InviteFail": "招待状が送信できません。この求人のメール設定を確認してください。",
  "Recruiter_Dashboard_ReportSuccess": "レポートが正常に送信されました。",
  "Recruiter_Dashboard_ReportFail": "レポートが送信できません。このジョブのメール設定を確認してください。",
  "Recruiter_Dashboard_DeleteFail": "エラーが発生しました。 (削除)",
  "Recruiter_Dashboard_ExportSuccess": "候補者データのエクスポートに成功しました。",
  "Recruiter_Dashboard_ExportFail": "エクスポートに失敗しました  選択された候補者が評価を完了していません。",
  "Recruiter_Dashboard_BulkDuplicateInvite": "以下の選択された候補者を招待しています。再度、招待しますか？",
  "Recruiter_Dashboard_Sending_Invitation": "招待状送信中...",
  "Recruiter_Dashboard_Sending_Report": "レポート送信 ...",
  "Recruiter_Dashboard_Msg_Redo_title": "候補者データのリセット",
  "Recruiter_Dashboard_Msg_Redo_content": "この操作により、選択した候補者のデータ（ビデオやAIスコアを含む）がリセットされ、その候補者はオンラインアセスメントをやり直すことができます。この操作でよろしいですか？",
  "Recruiter_Dashboard_Msg_Delete_title": "候補者の削除",
  "Recruiter_Dashboard_Msg_Delete_content": "この操作により、選択した候補が削除され、元に戻すことはできません。この操作を実行しますか？",
  "Recruiter_Dashboard_Import_Dialog_Title": "候補者を追加",
  "Recruiter_Dashboard_Import_Dialog_Form_Label": "形式別",
  "Recruiter_Dashboard_Import_Dialog_Excel_Label": "エクセル",
  "Recruiter_Dashboard_Import_Dialog_Field_Name": "氏名",
  "Recruiter_Dashboard_Import_Dialog_Field_Email": "メール",
  "Recruiter_Dashboard_Import_Dialog_Field_Country_Code": "国番号",
  "Recruiter_Dashboard_Import_Dialog_Field_Phone_Number": "電話番号",
  "Recruiter_Dashboard_Import_Dialog_Field_Degree": "資格",
  "Recruiter_Dashboard_Import_Dialog_Field_University": "所属機関",
  "Recruiter_Dashboard_Import_Dialog_Instruction": "これらの候補者の評価開始と締め切りを選択する",
  "Recruiter_Dashboard_Import_Dialog_Column_Name": "氏名",
  "Recruiter_Dashboard_Import_Dialog_Column_Email": "Email",
  "Recruiter_Dashboard_Import_Dialog_Column_Status": "ステータス",
  "Recruiter_Dashboard_Import_Duplicate_Dialog_Title": "メールの重複",
  "Recruiter_Dashboard_Import_Duplicate_Dialog_Content": "この仕事には既に複数のメールがあります。新しい情報で上書きして大丈夫ですか？",
  "Recruiter_Dashboard_Import_Duplicate_In_Excel_Dialog_Title": "インポートに成功しました。",
  "Recruiter_Dashboard_Import_Duplicate_In_Excel_Dialog_Content": "Excel/csvファイル内で、複数のメールが繰り返されていることを検出しました。最初に表示された行だけがインポートされ、他の行は中止されます。",
  "Recruiter_Dashboard_Import_Duplicate_In_Excel_Dialog_Repeat_Tag": "繰り返し使用可能",
  "Recruiter_Dashboard_Change_Deadline_Dialog_Title": "締切日の変更",
  "Recruiter_Dashboard_Change_Deadline_Dialog_Subtitle": '選択された候補者の新しい締切日を選択する',
  "Recruiter_Dashboard_Change_Deadline_Dialog_SendEmail": "候補者通知用のメール/SMSを送信",
  "Recruiter_Dashboard_Change_Deadline_Dialog_Msg": '締切日を更新しました',
  'Recruiter_Dashboard_Msg_Invite_After_Modify_title': '今すぐ招待状を送りますか？',
  'Recruiter_Dashboard_Msg_Invite_After_Modify_content': 'まだ招待していない候補者がいます。今すぐ締切日を更新して招待状を送りますか？',
  'Recruiter_Dashboard_Msg_Invite_After_Modify_Button_Yes': '今すぐ送信',
  'Recruiter_Dashboard_Msg_Invite_After_Modify_Button_No': "送信しない",
  'Recruiter_Dashboard_Modify_Deadline_Msg': '締切日を更新しました',
  "Recruiter_Dashboard_Add_New_Candiadte": "新規候補者を追加",
  "Recruiter_Dashboard_Status_Results": "クリックして結果を表示",
  "Recruiter_Dashboard_Status_Pending": "保留中の結果",
  'Recruiter_Dashboard_TableColumn_Status_Shortlisted': "ショートリスト",
  "Recruiter_Dashboard_TableColumn_Status_WaitingListed": "ウェイティングリスト",
  'Recruiter_Dashboard_TableColumn_Status_Rejected': "不採用",
  "Recruiter_Dashboard_Instruction_1": "選択した職種の候補者を一覧表示します",
  "Recruiter_Dashboard_Instruction_2": "右上の[ +ADD CANDIDATE ]ボタンを押すと、候補者を評価に追加し、評価日を設定することができます。",
  "Recruiter_Dashboard_Edit_Dialog_Failed": "候補者情報の更新に失敗しました。 ",
  "Recruiter_Dashboard_Edit_Dialog_Email_Change_Reminder": "候補者の電子メールを更新しました。以前に候補者を評価に招待したことがある場合は、候補者を再度招待するように注意してください。",
  'Recruiter_Dashboard_Status_Filter_Caption': "条件で絞り込み",
  'Recruiter_Dashboard_Status_Filter_Title': "ステータスで絞り込む",
  'Recruiter_Dashboard_Status_Filter_All': "全て",
  'Recruiter_Dashboard_Addcandidate_disable': '面接枠の残りが０になりましたので、候補者追加機能が停止しました。面接枠を増やすには、アカウント管理者に連絡してください。',
  "Recruiter_Dashboard_Redo_Questions_Dialog_Title": "再質問を行う",
  "Recruiter_Dashboard_Redo_Questions_Dialog_Instruction": "再質問が必要な質問番号を選択してください。",
  "Recruiter_Dashboard_Redo_Questions_Dialog_SendEmail": "候補者にメールを送る",
  "Recruiter_Dashboard_TableColumn_Tooltip_RedoQuestions": "再質問を行う",
  "Recruiter_Dashboard_BulkSharing_Tooltip": "候補者が選ばれなかった、または選ばれた候補者の一部が評価を完了しておらず、審査を受けることができません。",
  "Recruiter_Evaluation_Norating": "レビュアー評価なし",
  "Recruiter_ReportSideBar_VideoInterview": "ビデオ面接",
  "Recruiter_ReportSideBar_FullInterview": "完全面接",
  "Recruiter_ReportSideBar_GeneralHR": "人事全般",
  "Recruiter_ReportSideBar_Competency": "能力",
  "Recruiter_ReportSideBar_Technical": "技術",
  "Recruiter_ReportSideBar_AutoScoring": "自動採点",
  "Recruiter_ReportSideBar_OverallScore": "総合評価",
  "Recruiter_ReportSideBar_AIReport": "AIレポート",
  "Recruiter_ReportSideBar_RecruiterEvaluation": "採用担当者評価",
  "Recruiter_VideoInterview_BackToDashboard": "候補者一覧に戻る",
  "Recruiter_VideoInterview_Title": "ビデオ面接",
  "Recruiter_VideoInterview_QuestionSet": "質問セット {no}",
  "Recruiter_VideoInterview_Question": "質問 {no}: {question}",
  "Recruiter_VideoInterview_Back": "戻る",
  "Recruiter_VideoInterview_Next": "次へ",
  "Recruiter_VideoInterview_NoQuestion": "このカテゴリーに該当する質問はありません。",
  "Recruiter_VideoInterview_NoVideoSubmitted": "この質問はまだ終了していません。",
  "Recruiter_Multiple_Choices_QuestionSet": "質問セット｛no｝",
  "Recruiter_Short_Question_QuestionSet": "質問セット(no}",
  'Recruiter_CandidateResult_Title': "インタビュー解析",
  "Recruiter_CandidateResult_Multiple_Choices_Title": "マルチチョイス分析",
  "Recruiter_CandidateResult_Short_Questions_Title": "短い質問の分析",
  "Recruiter_CandidateResult_AnswerList": "候補者回答リスト",
  'Recruiter_CandidateResult_Name': "氏名:",
  'Recruiter_CandidateResult_Email': "メール:",
  "Recruiter_Dashboard_Import_Dialog_Field_1st_Preference": "第1希望",
  "Recruiter_Dashboard_Import_Dialog_Field_2nd_Preference": "第2希望",
  "Recruiter_CandidateResult_University": "大学：",
  "Recruiter_CandidateResult_Degree": "学位：",
  "Recruiter_CandidateResult_1st_Preference": "第1希望：",
  "Recruiter_CandidateResult_2nd_Preference": "第2希望：",
  'Recruiter_CandidateResult_NextCandidate': "次の候補者",
  'Recruiter_CandidateResult_LastCandidate': "最後の候補者",
  'Recruiter_CandidateResult_FacialExpression': '表情アノテーション',
  'Recruiter_CandidateResult_MyComment': "マイ・コメント:",
  'Recruiter_CandidateResult_MyScoring': "マイ・スコアリング",
  'Recruiter_CandidateResult_Transcribe': 'トランスクリプト',
  'Recruiter_CandidateResult_AutoScoring': "自動採点",
  'Recruiter_CandidateResult_ReviewerScoring': "レビュアーによる採点",
  "Recruiter_CandidateResult_Resume": "履歴書",
  'Recruiter_CandidateResult_Report': "PDFレポートのダウンロード",
  "Recruiter_CandidateResult_Save": "保存",
  'Recruiter_CandidateResult_Indicator': '感情指標',
  'Recruiter_CandidateResult_Emotion': '感情比率',
  'Recruiter_CandidateResult_Time': '時間',
  'Recruiter_CandidateResult_PositiveEmotions': 'ポジティブ感情',
  'Recruiter_CandidateResult_NeutralEmotions': '中立的感情',
  'Recruiter_CandidateResult_NegativeEmotions': 'ネガティブ感情',
  'Recruiter_CandidateResult_Translation_title': 'この候補者の回答を以下に転記する。:',
  'Recruiter_CandidateResult_Tooltip_City': '都市',
  'Recruiter_CandidateResult_Tooltip_Country': '所在地',
  'Recruiter_CandidateResult_Tooltip_IP': 'IPアドレス',
  'Recruiter_CandidateResult_Tooltip_Complete': '完了日時',
  "Recruiter_CandidateResult_Tooltip_Download_Resume": "履歴書のダウンロード",



  "Recruiter_CandidateResult_Total_Score": "総合得点：{score}",
  "Recruiter_CandidateResult_Correct": "{logo}正",
  "Recruiter_CandidateResult_Wrong": "{logo}誤",
  "Recruiter_CandidateResult_Model_Answer": "模範解答：",
  "Recruiter_CandidateResult_Candidate_Answer": "候補者の回答：",
  "Recruiter_CandidateResult_Action": "アクション",
  "Recruiter_CandidateResult_ErrorViewingShortQuestions": "この候補者は、まだ短問アセスメントを終了していません。",
  "Recruiter_CandidateResult_ErrorViewingMultipleChoicesQuestions": "この候補者は、まだ短問アセスメントを終了していません。",
  "Recruiter_AIReport_BackToDashboard": "候補者一覧に戻る",
  "Recruiter_AIReport_Title": "AIレポート",
  "Recruiter_AIReport_OverallScore": "総合評価",
  "Recruiter_AIReport_Percentile": "パーセンタイル",
  "Recruiter_AIReport_Passed": "合格",
  "Recruiter_AIReport_Failed": "不合格",
  "Recruiter_AIReport_Impression": "印象",
  "Recruiter_AIReport_PotentialWorkPerformance": "潜在的なワークパフォーマンス",
  'Recruiter_AIReport_TaskPerformance': 'タスク・パフォーマンス',
  'Recruiter_AIReport_ContextualPerformance': '文脈能力',
  'Recruiter_AIReport_AdaptivePerformance': '適応能力',
  "Recruiter_AIReport_Rating": "評価",
  "Recruiter_AIReport_Weighting": "ウェイト付け",
  "Recruiter_AIReport_QualitativeAnalysis": "定性的分析",
  'Recruiter_AIReport_NoReportAnnounce': "この候補者はビデオ面接のガイドラインに従っていないため、AIレポートを作成することができません。",
  "Recruiter_AIReport_ReportInProgress": "面接の分析は現在進行中です。しばらくお待ちください。",



  "Recruiter_AIReport_task_performance_high": "日々の業務を計画、整理、管理する高度な能力を発揮し、ほとんどの職務を遂行することができる。",
  "Recruiter_AIReport_interpersonal_relationship_communication_high": "他者と効果的に交流し、部門や組織と良好な関係を築く高い能力を有する。",
  "Recruiter_AIReport_adaptability_high": "新しい状況に柔軟に対応し、ルーチンを即座に調整することができ、他者との相互作用において非常に柔軟に自分のアプローチを行うことができる。",

  "Recruiter_AIReport_task_performance_medium": " 日常業務を計画、組織、管理する能力が低く、職務上の責任の一部を果たすことができる。",
  "Recruiter_AIReport_interpersonal_relationship_communication_medium": "他者と効果的に交流し、部門や組織と良好な関係を築くことができる中程度の能力を有する。",
  "Recruiter_AIReport_adaptability_medium": "変化に対して適度な柔軟性と適応性を持ち、日常生活や他者との関係における自身のアプローチを調整することに概して前向きである。",

  "Recruiter_AIReport_task_performance_low": "日々の仕事を計画、組織、管理する能力が低く、職務上の責任を果たすことができない。",
  "Recruiter_AIReport_interpersonal_relationship_communication_low": "他者と効果的に交流し、部門や組織と良好な関係を築く能力が低い。",
  "Recruiter_AIReport_adaptability_low": "変化に対して柔軟性に欠け、適応性に欠け、他者との相互作用の中で、ルーチンや自身のアプローチを調整しようとする試みはほとんどない。",

  "Recruiter_AIReport_task_performance_0": "このコンピテンシーを判断することはできません。これは通常、候補者が該当する面接の質問に回答していないか、面接のビデオを提供していないためです。",
  "Recruiter_AIReport_interpersonal_relationship_communication_0": "このコンピテンシーを判断することはできません。これは通常、候補者が該当する面接の質問に回答していないか、面接のビデオを提供していないためです。",
  "Recruiter_AIReport_adaptability_0": "このコンピテンシーを判断することはできません。これは通常、候補者が該当する面接の質問に回答していないか、面接のビデオを提供していないためです。",


  'Recruiter_AIReport_pace_high': ' 理想に近いスピードで話し、スピードとリズムをうまく表現し、体系的な考えがある。',
  'Recruiter_AIReport_leadership_high': ' 自己主張が強く、自信を持って他者を指導し、高いパフォーマンスを発揮させるリーダーシップの資質がある。',
  'Recruiter_AIReport_learning_agility_high': ' 常に学び続ける姿勢を持ち、新しい技術や知識を習得し、それを応用して変化をもたらすことに意欲的である。',
  'Recruiter_AIReport_creativity_innovation_high': ' 新しいアイデアを好み、現在の慣習や伝統に従うのではなく、新しいものを創造するために想像力と冒険心を持つ。.',

  'Recruiter_AIReport_interpersonal_relationship_high': ' 人と接するときは、非常にフレンドリーで明るく社交的であり、効果的にラポールを用いて調和的な関係を構築できる。',
  'Recruiter_AIReport_goal_and_achievement_striving_high': ' 勤勉で向上心があり、より高い目標や成果を達成する意欲がある。',
  'Recruiter_AIReport_developing_people_high': ' 強みを生かした明確な考え方とイニシアチブを発揮し、他者の個人的・職業的成長をサポートする。',
  'Recruiter_AIReport_responsibility_high': ' 責任感があり、目標や結果を達成しようとする意欲があり、自身の能力を最大限に発揮して職務を遂行し、自立的に物事を成し遂げる方法を知っている。',
  'Recruiter_AIReport_managing_execution_high': ' リソース、タスク、プロジェクトを計画・管理する際に、組織的かつ協調的に行動できる。慎重かつ良心的に行動し、目標や納期に従ってタスクに優先順位をつける方法を知っている。',
  'Recruiter_AIReport_analytical_and_logical_thinking_high': ' 好奇心旺盛にアイデアや情報を探求し、情報やアイデアを体系的に収集・合成して分析し、世代観察や具体的な事実から論理的な結論を導き出すことができる。',
  'Recruiter_AIReport_complex_problem_solving_high': ' 問題の本質を明らかにし、柔軟な思考で代替案を検討、実行可能な解決策を提案、適切な判断と意思決定を行うことができる。',
  'Recruiter_AIReport_communication_high': ' 口頭で情報や考えを簡潔明瞭に、落ち着いた口調で確実に伝えることができる。',
  'Recruiter_AIReport_caring_and_empathy_high': ' 他者への思いやり、共感、配慮を示し、積極的な傾聴のスキルを実践し、対人関係において忍耐と誠実さを示す。',
  'Recruiter_AIReport_english_oral_communication_high': ' とても流暢に話すことができ、考えやアイデアを明確に表現することができる。',
  'Recruiter_AIReport_cantonese_oral_communication_high': ' とても流暢に話すことができ、考えやアイデアを明確に表現することができる。',
  'Recruiter_AIReport_mandarin_oral_communication_high': ' とても流暢に話すことができ、考えやアイデアを明確に表現することができる。',
  'Recruiter_AIReport_team_collaboration_and_inclusion_high': ' 他人に対して親切で思いやりがあり、チームプレーヤーとして協力的であり、異なる背景を持つ同僚や共同経営者と協調し、文化的な配慮ができる。 ',
  'Recruiter_AIReport_building_relationships_and_network_high': ' 温厚で社交的、対人能力に優れ、様々な人とうまく接することができ、身体の使い方や解釈の仕方を知っている。; 強い意志を持ち、他人の自己啓発を助けることができる。',
  'Recruiter_AIReport_flexibility_and_adaptability_high': ' 新しい状況に柔軟に対応し、ルーチンを即座に調整することができ、他者との相互作用において非常に柔軟に自身のアプローチを行うことができる能力を有している。',
  'Recruiter_AIReport_creativity_and_innovation_high': ' オープンマインドで探究心があり、創造的な思考で新しいアイデアや破壊的なアイデアを生み出すことができる。; 問題解決の為の新しいアプローチや、新しいモノやデザインを生み出す為の新しい発明を推進する。',
  'Recruiter_AIReport_emotional_intelligence_high': ' 困難に直面しても冷静で、異なる背景を持つ顧客（障害者、高齢者、子供）に忍耐強く対応できる。',
  'Recruiter_AIReport_enthusiasm_high': '陽気で前向きな感情とエネルギーを持っている。',
  'Recruiter_AIReport_composure_high': ' 冷静沈着で、プレッシャーがある場面でもストレスを感じにくい。',
  'Recruiter_AIReport_self_confidence_high': ' 自信を持って自己の主張ができ、人との付き合いを心地よく感じる。',
  'Recruiter_AIReport_vision_and_entrepreneurial_mindset_high': ' 問題発見能力、ビジョン創造能力、起業家精神に溢れ、積極的にチャンスを掴み、リスクを考慮しながらイノベーションを生み出すことができる。',
  'Recruiter_AIReport_technology_expertise_and_business_sense_high': ' 技術的な専門知識と、市場ニーズに対応できる優れたビジネスセンスを有している。',
  'Recruiter_AIReport_effective_communication_and_teambuilding_high': ' 明確かつ簡潔な方法でアイデアを伝える優れた能力を持ち、チームを成功に導くために他者に効果的に影響を与えることができる。',
  'Recruiter_AIReport_grit_and_passion_high': ' 困難や逆境に直面しても、強い忍耐力と長期的な目標達成への情熱を持ち、成功への強い勇気と決意を示す。',


  'Recruiter_AIReport_pace_medium': ' 速すぎず、遅すぎないスピードで話す。',
  'Recruiter_AIReport_leadership_medium': ' 他者への指導や影響力において積極的であるなど、適度なリーダーシップの資質を有しており、高いパフォーマンスを発揮できるよう努力している。',
  'Recruiter_AIReport_learning_agility_medium': ' 新しい学習や経験に対して適度な興味と機敏さを持ち、それを応用して変化をもたらすことを意識している。',
  'Recruiter_AIReport_creativity_innovation_medium': ' 新しいアイデアを生み出すこと、想像力を働かせること、古いものを新しいものに変えていく可能性を適度に好む。',

  'Recruiter_AIReport_interpersonal_relationship_medium': ' 適度な親しみやすさ、温かさ、社交性を持って人と接することができる、または人間関係を築くことができる',
  'Recruiter_AIReport_goal_and_achievement_striving_medium': ' 高い目標や成果を達成するために、適度に勤勉で、野心的で、意欲的である。',
  'Recruiter_AIReport_developing_people_medium': ' 強みを生かした考え方とイニシアティブを中程度に発揮し、他者の個人的・職業的成長をサポートする',
  'Recruiter_AIReport_responsibility_medium': ' 目標や結果を達成するために、適度に信頼性と集中力を持ち、仕事の要件を満たすために必要なものを提供する。',
  'Recruiter_AIReport_managing_execution_medium': ' リソース、タスク、プロジェクトの計画・調整において、適度に組織化され、良心的である。',
  'Recruiter_AIReport_analytical_and_logical_thinking_medium': ' 適度な好奇心を持ってアイデアを探求したり、積極的に情報を調べたりすることができる。分析のために情報やアイデアを収集・統合し、合理的な結論を導き出すことが適度に体系化されている。 ',
  'Recruiter_AIReport_complex_problem_solving_medium': ' 意思決定のために合理的な論理と判断を用いて、代替案や選択肢を評価しようとするために情報を活用することが適度にできる。',
  'Recruiter_AIReport_communication_medium': ' 口頭で情報やアイデアを明確かつ簡潔に伝えることができ、口調や声のトーンに適度な落ち着きと確実性がある。 ',
  'Recruiter_AIReport_caring_and_empathy_medium': ' 他者への思いやりと共感があり、忍耐力があり、他者のニーズに耳を傾けることができ、対人関係において適切な誠実さを保つことができる。',
  'Recruiter_AIReport_english_oral_communication_medium': ' 適度に流暢に話すことができ、考えやアイデアを明確に表現することができる。',
  'Recruiter_AIReport_cantonese_oral_communication_medium': ' 適度に流暢に話すことができ、考えやアイデアを明確に表現することができる。',
  'Recruiter_AIReport_mandarin_oral_communication_medium': ' 適度に流暢に話すことができ、考えやアイデアを明確に表現することができる。',
  'Recruiter_AIReport_team_collaboration_and_inclusion_medium': ' 他者に対して思いやりが無かったり、よそよそしいといった事は無く、チームワークにおいては概して協力的であり、また、異なる背景を持つ同僚や同僚と仕事をする際には、適度に好感を持ち、文化的な配慮ができる。',
  'Recruiter_AIReport_building_relationships_and_network_medium': ' 人と接するのが好きで、時々プライベートの時間を楽しむことができ、さまざまなタイプの人とうまく付き合うことができる適度な対人能力を持っていて、他者の自己啓発に焦点を当てた強さベースの考え方を持っている。',
  'Recruiter_AIReport_flexibility_and_adaptability_medium': ' 変化に対して適度な柔軟性と適応性を持ち、日常生活や他者との関係における自身のアプローチを調整することに概して前向きである。',
  'Recruiter_AIReport_creativity_and_innovation_medium': ' 通常、古い問題に対処するために一時的な解決策を適用し、いくつかの確立された慣行に変化をもたらすことができるが、オリジナルのデザインや解決策ではない可能性がある。',
  'Recruiter_AIReport_emotional_intelligence_medium': '  困難に直面したとき、自分の感情をコントロールすることに努める。一般的に忍耐強く、異なる背景を持つ顧客（障害者、高齢者、子供）に対して寛容である。',
  'Recruiter_AIReport_enthusiasm_medium': ' 適度に陽気で前向きな感情とエネルギーを持っている。',
  'Recruiter_AIReport_composure_medium': ' 冷静沈着で穏やか、プレッシャーのある場面では中程度にストレスを受ける。',
  'Recruiter_AIReport_self_confidence_medium': ' 自分表現をするときに適度に自信があり、人とのやり取りが適度に快適であると感じる。',
  'Recruiter_AIReport_vision_and_entrepreneurial_mindset_medium': ' 問題発見能力、ビジョン創造能力、起業家精神が中程度にあり、イノベーションと発明をもたらす機会を捉え、リスクを考慮しながら行動することができる。',
  'Recruiter_AIReport_technology_expertise_and_business_sense_medium': ' 中程度の技術・知識、ビジネスセンスを持ち、市場ニーズに対応できる。',
  'Recruiter_AIReport_effective_communication_and_teambuilding_medium': ' 明確かつ簡潔な方法でアイデアを適度に伝えることができ、チームを成功に導くために他者に影響を与えることができる。',
  'Recruiter_AIReport_grit_and_passion_medium': ' 困難や逆境に直面したとき、中程度の勇気と成功への決意、長期的な目標達成のための忍耐力と情熱を発揮することができる。',


  'Recruiter_AIReport_pace_low': ' 話すスピードが速すぎたり遅すぎたりして、聞き手にスピードやリズムを合わせることができない。',
  'Recruiter_AIReport_leadership_low': ' リーダーとしての資質が未発達であり、他人をリードし指示し、高いパフォーマンスを発揮させるだけの自己主張と自信がない。',
  'Recruiter_AIReport_learning_agility_low': ' 新しい学習や経験にあまり興味がない、または機敏でなく、変化を起こす必要性を感じていない。',
  'Recruiter_AIReport_creativity_innovation_low': ' 現在の慣習や伝統から逸脱することをあまり好まず、安定を維持したい。',

  'Recruiter_AIReport_interpersonal_relationship_low': ' 他人と接する時は、より控えめであり、暖かく社交的ではなく、チーム精神よりもむしろ個人的に自立している。',
  'Recruiter_AIReport_goal_and_achievement_striving_low': ' 呑気で野心的では無く、達成感を簡単に得ることができる。',
  'Recruiter_AIReport_developing_people_low': ' 強みを生かした考え方とイニシアティブを発揮し、他者の個人的・職業的成長を支援することが少ない。',
  'Recruiter_AIReport_responsibility_low': '  目標や結果を達成するための義務や責任をあまり感じず、のんびりとリラックスして物事を進める。',
  'Recruiter_AIReport_managing_execution_low': ' リソース、タスク、プロジェクトの詳細な計画や調整について無頓着で、目的や納期に従っていない、あまり体系的で慎重でない方法で仕事をしている。 ',
  'Recruiter_AIReport_analytical_and_logical_thinking_low': ' アイデアの探求に興味や探究心がなく、分析に必要な適切かつ十分な情報を調査・収集・合成し、論理的な結論を出すことに積極的ではない。',
  'Recruiter_AIReport_complex_problem_solving_low': ' 問題の本質を明らかにして評価・提案することができない、また論理的な判断ができない。',
  'Recruiter_AIReport_communication_low': ' 明確かつ簡潔な方法で情報やアイデアを提示する能力が低く、口調や声のトーンに緊張感や疑心暗鬼が見られる。',
  'Recruiter_AIReport_caring_and_empathy_low': ' 他者への思いやりや共感が乏しい、忍耐力がない、他者のニーズに耳を傾ける姿勢がない、対人関係において誠実さの原則に固執している。',
  'Recruiter_AIReport_english_oral_communication_low': ' 流暢に話せない、または思考やアイディアを明確に表現できない。',
  'Recruiter_AIReport_cantonese_oral_communication_low': ' 流暢に話せない、または思考やアイディアを明確に表現できない。',
  'Recruiter_AIReport_mandarin_oral_communication_low': ' 流暢に話せない、または思考やアイディアを明確に表現できない。',
  'Recruiter_AIReport_team_collaboration_and_inclusion_low': ' sチームよりも一人で仕事をすることを好み、同僚や同僚と仕事をする際、あまり積極的でなく、他人と対立することがある。',
  'Recruiter_AIReport_building_relationships_and_network_low': ' 控えめで、積極的に人間関係を築こうとせず、人とうまく付き合うための対人スキルに欠けている。他者の自己啓発をサポートする強さベースの考え方を受け入れない。',
  'Recruiter_AIReport_flexibility_and_adaptability_low': ' 変化に対して柔軟性がなく、適応力もなく、また、他者との関わりの中で、ルーチンや自身のアプローチを調整しようとする試みはほとんど無い。',
  'Recruiter_AIReport_creativity_and_innovation_low': ' 問題解決のために古いアプローチに固執し、独自のデザインやソリューションを生み出すために現在の慣行から逸脱することができない。',
  'Recruiter_AIReport_emotional_intelligence_low': ' 課題に直面した時、緊張し、自信が欠如している。; 異なる背景を持つ顧客（障害者、高齢者、子供）に対応する際、忍耐力や寛容さに欠ける恐れがある。',
  'Recruiter_AIReport_enthusiasm_low': ' 飄々としていて、積極性やエネルギーが感じられない。',
  'Recruiter_AIReport_composure_low': ' 緊張や不満を感じやすく、プレッシャーがかかる場面ではストレスを受けやすい。',
  'Recruiter_AIReport_self_confidence_low': ' 自己表現をする時の自信がなく、人との付き合いが苦手。',
  'Recruiter_AIReport_vision_and_entrepreneurial_mindset_low': ' 問題発見能力、ビジョン創造能力、起業家精神が乏しく、イノベーションと発明をもたらす機会を積極的に利用し、リスクを考慮しながら行動することができない。',
  'Recruiter_AIReport_technology_expertise_and_business_sense_low': ' 技術的なスキルや知識が乏しく、市場ニーズに対応するビジネスセンスに乏しい。',
  'Recruiter_AIReport_effective_communication_and_teambuilding_low': ' 明確かつ簡潔な方法でアイデアを伝える能力が不十分であり、また、チームを成功させるために他者に影響を与え、巻き込むことができない。',
  'Recruiter_AIReport_grit_and_passion_low': ' 困難や逆境に直面したとき、成功するための勇気や決意、長期的な目標を達成するための忍耐力や情熱が乏しい。',

  'Recruiter_AIReport_0': '能力を判断することはできません。 これは通常、候補者が該当する面接の質問に答えていない、あるいは面接のビデオを提供していないことが原因です。',

  "Recruiter_AIRating_Comment": "コメント",
  "Recruiter_AIRating_BackToDashboard": "候補者一覧に戻る",
  "Recruiter_AIRating_Title": "AI評価",
  "Recruiter_AIRating_OverallScore": "総合評価",
  "Recruiter_AIRating_Percentile": "パーセンタイル",
  "Recruiter_AIRating_Passed": "合格",
  "Recruiter_AIRating_Failed": "不合格",
  "Recruiter_AIRating_ImpressionScore": "印象スコア:",
  "Recruiter_AIRating_Impression": "印象スコア:",
  "Recruiter_AIRating_PotentialWorkPerformanceScore": "潜在的なワークパフォーマンススコア:",
  "Recruiter_AIRating_FullMark": "10点満点",
  "Recruiter_AIRating_HighScore": "高スコア：7.0点以上",
  "Recruiter_AIRating_LowScore": "低スコア：5.0点以下",
  "Recruiter_AIRating_RadarLabel": ['目標・達成度', 'リーダーシップ', '創造性', 'アジリティの学習', 'コミュニケーション', '対人関係', '感情知能'],
  "Recruiter_AIRating_Big5Score": "5つの大きなパーソナリティ スコア:",
  "Recruiter_AIRating_TotalScore": "合計スコア:",
  'Recruiter_AIRating_TaskPerformance': 'タスクパフォーマンス スコア:',
  'Recruiter_AIRating_ContextualPerformance': '文脈能力スコア:',
  'Recruiter_AIRating_AdaptivePerformance': '適応能力スコア:',
  "Recruiter_Comment_BackToDashboard": "候補者一覧に戻る",
  "Recruiter_Comment_Title": "採用担当者コメント",
  "Recruiter_Comment_Impression": "感想",
  "Recruiter_Comment_PotentialWorkPerformance": "潜在的なワークパフォーマンス",
  "Recruiter_Comment_Rating": "評価",
  "Recruiter_Comment_Comments": "コメント",
  "Recruiter_Comment_OverallScore": "総合評価:",
  "Recruiter_Comment_OverallComments": "総合コメント",
  "Recruiter_Comment_Submit": "提出",
  "Recruiter_Comment_Submit_SuccessMsg": "保存しました。",
  "Recruiter_Comment_Submit_FailedMsg": "保存できませんでした。",

  "Recruiter_Candidate_Result_No_Criteria": '採点基準やウェイトが設定されていません。ポジションと面接設定ページで該当の設定を完了してください。',
  "Recruiter_Candidate_Result_Go_Setting": '設定画面に進む',
  "Recruiter_Candidate_Result_Criteria_Setting": '能力を編集  ',
  "Recruiter_Guest_Review_No_Criteria": '採点基準やウェイトが設定されていません。審査する候補者の管理責任者にお問い合わせください。',
  "Recruiter_CandidateProfile_Title": "候補者プロフィール",
  "Candidate_CandidateProfile_Upload_Title" : "Before the interview, please upload your resume",
  "Recruiter_CandidateProfile_CV": "履歴書",
  "Recruiter_CandidateProfile_CV_Instruction": "履歴書をここにドロップ、または選択",
  "Recruiter_CandidateProfile_CV_Extension": "推奨ファイル形式: PDF, Doc or JPG",
  "Recruiter_CandidateProfile_BasicInformation_Title": "基本情報",
  "Recruiter_CandidateProfile_BasicInformation_FullName": "氏名",
  "Recruiter_CandidateProfile_BasicInformation_PhoneNumber": "電話番号",
  "Recruiter_CandidateProfile_BasicInformation_Email": "メールアドレス",
  "Recruiter_CandidateProfile_BasicInformation_Address": "住所",
  "Recruiter_CandidateProfile_WorkExp_Title": "職務経歴",
  "Recruiter_CandidateProfile_WorkExp_Institute": "企業・団体名.",
  "Recruiter_CandidateProfile_WorkExp_JobFunction": "職務権限",
  "Recruiter_CandidateProfile_WorkExp_JobTitle": "職種",
  "Recruiter_CandidateProfile_WorkExp_Location": "所在地",
  "Recruiter_CandidateProfile_WorkExp_Active": "活動",
  "Recruiter_CandidateProfile_WorkExp_StartDate_Year": "開始日 - 年",
  "Recruiter_CandidateProfile_WorkExp_StartDate_Month": "開始日 - 月",
  "Recruiter_CandidateProfile_WorkExp_EndDate_Year": "終了日 - 年",
  "Recruiter_CandidateProfile_WorkExp_EndDate_Month": "終了日 - 月",
  "Recruiter_CandidateProfile_Education_Title": "学歴",
  "Recruiter_CandidateProfile_Education_Institute": "機関名",
  "Recruiter_CandidateProfile_Education_Major": "専攻",
  "Recruiter_CandidateProfile_Education_Location": "位置",
  "Recruiter_CandidateProfile_Education_Active": "活動",
  "Recruiter_CandidateProfile_Education_StartDate_Year": "開始日 - 年",
  "Recruiter_CandidateProfile_Education_StartDate_Month": "開始日 - 月",
  "Recruiter_CandidateProfile_Education_EndDate_Year": "終了日 - 年r",
  "Recruiter_CandidateProfile_Education_EndDate_Month": "終了日 - 月",
  "Recruiter_CandidateProfile_Cert_Title": "証明書と表彰",
  "Recruiter_CandidateProfile_Cert_Cert": "認定証/表彰",
  "Recruiter_CandidateProfile_Cert_Year": "年",
  "Recruiter_CandidateProfile_Skills_Title": "技能",
  "Recruiter_CandidateProfile_Skills_Skill": "特殊技能",
  "Recruiter_CandidateProfile_Action_Add": "追加",
  "Recruiter_CandidateProfile_Action_Remove": "削除",
  "Recruiter_CandidateProfile_Action_Upload": "アップロード",
  "Candidate_CandidateProfile_Confirm_Title" : "Resume Upload Confirmation", 
  "Candidate_CandidateProfile_Confirm_Content" : "Please make sure all filled information is correct, you will not be allowed to modify once you click the CONFIRM button below.", 
  "Recruiter_CandidateProfile_Upload_MsgSuccess": "プロフィールを更新しました。",
  "Recruiter_CandidateProfile_Upload_MsgFailed": "プロフィールの更新に失敗しました。",
  "Recruiter_Candidate_Invite_Result_Title": "招待状エラー",
  "Recruiter_Candidate_Invite_Result_Content": "以下の候補者の招待にエラーが発生しました。:",
  "Recruiter_Candidate_Invite_Result_Code0": "-",
  "Recruiter_Candidate_Invite_Result_Code1": "メールが送信できませんでした。",
  "Recruiter_Candidate_Invite_Result_Code2": "招待メールは正常に送信されました。 \しかし、電話番号が提供されていないため、SMSメッセージは送信できません。",
  "Recruiter_Candidate_Invite_Result_Code3": "定数不足です。",
  "Recruiter_Candidate_Invite_Result_Code4": "面接終了",
  "Recruiter_Candidate_Invite_Result_Table_Name": "氏名",
  "Recruiter_Candidate_Invite_Result_Table_Email": "メール",
  "Recruiter_Candidate_Invite_Result_Table_Result": "招待状況",
  "Recruiter_Candidate_Invite_Result_Table_Message": "理由",
  "Recruiter_Candidate_Invite_Result_Success": "招待状を送信しました。",
  "Recruiter_Candidate_Invite_Result_Fail": "招待状の送信に失敗しました。",
  "Recruiter_Skills_Attractiveness": "魅力度",
  "Recruiter_Skills_Wear_Glasses": "眼鏡をかける",
  "Recruiter_Skills_Wear_Glasses_yes": "はい",
  "Recruiter_Skills_Wear_Glasses_no": "いいえ",
  "Recruiter_Skills_Enthusiasm": "熱意",
  "Recruiter_Skills_SelfConfidence": "自信",
  "Recruiter_Skills_Composure": "落ち着き",
  "Recruiter_Skills_Pace": "雄弁さ",
  "Recruiter_Skills_Leadership": "リーダーシップ",
  "Recruiter_Skills_LearningAgility": "アジリティの学習",
  "Recruiter_Skills_CreativityAndInnovation": "創造性と革新性",
  "Recruiter_Skills_EmotionalIntelligence": "感情知能",
  "Recruiter_Skills_Communication": "影響力のあるコミュニケーション",
  "Recruiter_Skills_InterpersonalRelationship": "対人関係",

  "Recruiter_Skills_GoalAndAchievementStriving": "目標達成への取り組み",
  "Recruiter_Skills_Pleasantness": "快さ",
  "Recruiter_Skills_Patience": "忍耐力",
  "Recruiter_Skills_ComposureS4m": "落ち着き",
  "Recruiter_Skills_Independence": "独立性",
  "Recruiter_Skills_AdaptabilityAndSupporting": "適応力・サポート力",
  "Recruiter_Skills_CaringAndSensitivity": "思いやり・感性",
  "Recruiter_Skills_ResponsibleWithOwnership": "オーナーシップに基づく責任",
  'Recruiter_Skills_DevelopingPeople': '人材育成',
  'Recruiter_Skills_Responsibility': '責任感',
  'Recruiter_Skills_ManagingExecution': '実行管理',
  'Recruiter_Skills_AnalyticalAndLogicalThinking': '分析的・論理的思考力',
  'Recruiter_Skills_ComplexProblemSolving': '複合的な問題解決',
  'Recruiter_Skills_CaringAndEmpathy': '思いやり・共感',
  'Recruiter_Skills_EnglishOralCommunication': '英語によるオーラルコミュニケーション',
  'Recruiter_Skills_CantoneseOralCommunication': '広東語によるオーラルコミュニケーション',
  'Recruiter_Skills_MandarinOralCommunication': '中国語によるオーラルコミュニケーション',
  'Recruiter_Skills_TeamCollaborationAndInclusion': 'チームコラボレーション・包括',
  'Recruiter_Skills_BuildingRelationshipsAndNetwork': '人間関係・ネットワークの構築',
  'Recruiter_Skills_FlexibilityAndAdaptability': '柔軟性・適応性',
  'Recruiter_Skills_VisionAndEntrepreneurialMindset': 'ビジョン・起業家精神',
  'Recruiter_Skills_TechnologyExpertiseAndBusinessSense': '技術的な専門知識・ビジネス感覚',
  'Recruiter_Skills_EffectiveCommunicationAndTeambuilding': '効果的なコミュニケーションとチーム構築',
  'Recruiter_Skills_GritAndPassion': '度胸・情熱',

  "Recruiter_Skills_EnglishOralCommunicationOngrad": "英語によるオーラルコミュニケーション",
  "Recruiter_Skills_MotivationOngrad": "健康・環境・美観・技術への配慮（仕事1）",
  "Recruiter_Skills_MotivationOngradB": "健康・環境・美観・技術への配慮（仕事2）",
  "Recruiter_Skills_CommunicationWithImpactOngrad": "影響力のあるコミュニケーション",
  "Recruiter_Skills_TeamworkAndCollaborationOngrad": "チームワーク・協調性",
  "Recruiter_Skills_CaringAndEmpathyOngrad": "思いやり・共感",
  "Recruiter_Skills_BuildingRelationshipAndPeopleOngrad": "人間関係の構築",
  "Recruiter_Skills_ResponsibilityAndGoalAchievementOngrad": "責任感と目標達成",
  "Recruiter_Skills_EmotionalIntelligenceOngrad": "感情知能",
  "Recruiter_Skills_ManagingExecutionOngrad": "実行管理",
  "Recruiter_Skills_FlexibilityAndActiveLearningOngrad": "柔軟性と能動的な学習",
  "Recruiter_Skills_ComplexProblemSolvingOngrad": "複合的な問題解決",
  "Recruiter_Skills_AnalyticalAndLogicalThinkingOngrad": "分析的・論理的思考",
  "Recruiter_Skills_CreativityAndInnovationOngrad": "創造性と革新性",
  "Recruiter_Skills_ConfidenceOngrad": "自信",
  "Recruiter_Skills_ComposureOngrad": "落ち着き",
  "Recruiter_Skills_EnthusiasmOngrad": "熱意",

  "Recruiter_Skills_TaskPerformance": "タスクパフォーマンス",
  "Recruiter_Skills_InterpersonalRelationshipCommunication": "対人関係とコミュニケーション",
  "Recruiter_Skills_Adaptability": "適応性",


  "LayoutSettings_QuestionSubType_Leadership": "リーダーシップ",
  "LayoutSettings_QuestionSubType_DevelopingPeople": "人材育成",
  "LayoutSettings_QuestionSubType_GoalAndAchievementStriving": "目標と達成のための取り組み",


  "LayoutSettings_QuestionSubType_TechnologyExpertiseAndBusiness Sense": "技術的な専門知識とビジネスセンス",
  "LayoutSettings_QuestionSubType_Responsibility": "責任感",
  "LayoutSettings_QuestionSubType_ManagingExecution": "実行管理",
  "LayoutSettings_QuestionSubType_AnalyticalAndLogicalThinking": "分析的思考と論理的思考",
  "LayoutSettings_QuestionSubType_ComplexProblemSolving": "複雑な問題解決",
  "LayoutSettings_QuestionSubType_VisionAndEntrepreneurialMindset": "ビジョンと起業家マインド",

  "LayoutSettings_QuestionSubType_CommunicationWithImpact": "インパクトのあるコミュニケーション",
  "LayoutSettings_QuestionSubType_CaringAndEmpathy": "思いやり・共感",
  "LayoutSettings_QuestionSubType_InterpersonalRelationship": "対人関係",
  "LayoutSettings_QuestionSubType_Team CollaborationAndInclusion": "チームコラボレーションとインクルージョン",
  "LayoutSettings_QuestionSubType_Building RelationshipsAndNetwork": "人間関係の構築とネットワーク",
  "LayoutSettings_QuestionSubType_Effective CommunicationAndTeambuilding": "効果的なコミュニケーションとチームビルディング",
  "LayoutSettings_QuestionSubType_FlexibilityAndAdaptability": "柔軟性と適応性",
  "LayoutSettings_QuestionSubType_LearningAgility": "学習敏捷性",
  "LayoutSettings_QuestionSubType_CreativityAndInnovation": "創造性と革新性",
  "LayoutSettings_QuestionSubType_EmotionalIntelligence": "エモーショナルインテリジェンス",
  "LayoutSettings_QuestionSubType_GritAndPassion": "グリットと情熱",


  "Recruiter_Email_Invitation_Default": "<p>親愛なる{{Candidate’s name, don’t change}},</p><p></p><p>この度は弊社にご応募いただきありがとうございます！</p><p><p>あなたはNeufastアセスメントを行うために招待されています。30分の簡単なバーチャルアセスメントです。開始日から終了日までの間、いつでも行うことができます。</p><p></p><p>ログイン情報は以下のとおりです。  </p><ul><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>インタビューサイト ：<a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a> </li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>ログイン： {{Candidate’s login, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;’>パスワード：{{Candidate’s password, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>スタート：{{Start date and time, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>終了：{{End date and time, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>タイムゾーン： {{Timezone, don’t change}}</li></ul><span style='font-size: 14px;'><p></p><p></p><ins>システム要件：</ins></span><p>Desktop/laptop: Updated Chrome/Firefox/Safari(MacOS) on a wifi/landline-connected laptop/desktop with a webcam &amp; microphone</p><p>モバイル AndroidのChromeをアップデート / iPhone/iPadのSafari（SE2/XS以上）をアップデートしました。良好な Wi-Fi 接続をお勧めします。</p><p style='margin-left:0px;'></p><p>この度は弊社のアセスメントにご参加いただきありがとうございました。成功裏に終了し、次回のラウンドでお会いできることを楽しみにしています。</p><p></p><p>よろしくお願いします。</p><p>タレントマネージャー</p>",
  "Recruiter_Email_Invitation_Default_old": "<p>親愛なる{{Candidate’s name, don’t change}},</p><p></p><p>弊社にご応募いただきありがとうございます。</p><p>あなたはNeufast Video Interviewに招待されています。 この面接は バーチャルビデオインタビューで、30分間の簡単なものです。開始日から終了日までの間、いつでも行うことができます。</p><p></p><p>ログインの詳細は以下の通りです。</p><ul><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>面接のウェブサイト<a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;’>ログイン：{{Candidate’s login, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>パスワード：{{Candidate’s password, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>Start: {{Start date and time, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>終了：{{End date and time, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>タイムゾーン：{{Timezone, don’t change}}</li></ul><span style=\"font-size: 14px;\"><p></p><p></p><ins>システム要件：</ins></span><p>Desktop/laptop: Updated Chrome/Firefox/Safari(MacOS) on a wifi/landline-connected laptop/desktop with a webcam &amp;",
  "Recruiter_Email_Reminder_Default": "<p>親愛なる {{Candidate’s name, don’t change}},</p><p>あなたが応募した{{Company’s name, don’t change}}の{{Job Title, don’t change}}のポジションについて、{{End date and time, don’t change}}までに評価を行うよう注意してください。評価のログイン情報は、以下のように改めて提供されます。</p><ul> <li>インタビューサイト ：<a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li> <li>ログイン：<strong>{{Candidate’s login, don’t change}}</strong></li><li>パスワード：<strong>{{Candidate’s password, don’t change}}</strong></li> <li>開始：<strong>{{Start date and time, don’t change}}</strong></li><li>終了：<strong>{{End date and time, don’t change}}</strong></li> <li>タイムゾーン：<strong>{{Timezone, don’t change}}</strong></li></ul><p></p><p>この度は弊社のアセスメントにご参加いただきありがとうございました。成功裏に終了し、次回のラウンドでお会いできることを楽しみにしています。</p><p></p><p>よろしくお願いします。</p><p>タレントマネージャー</p>",
  "Recruiter_Email_Reminder_Default_old": "<p>親愛なる {{Candidate’s name, don’t change}},</p><p>{{Company’s name, don’t change}}のための{{Job Title, don’t change}}のポジションの応募について、{{End date and time, don’t change}}を受ける前にビデオ面接を受けることをお勧めします。ビデオ面接のログイン情報は、以下の通りです：</p><ul> <li>インタビューサイトです：<a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li> <li>ログイン: <strong>{{Candidate’s login, don’t change}}</strong></li><li>パスワード: <strong>{{Candidate’s password, don’t change}}</strong></li> <li>開始: <strong>{{Start date and time, don’t change}}</strong></li><li>終了: <strong>{{End date and time, don’t change}}</strong></li> <li>タイムゾーン: <strong>{{Timezone, don’t change}}</strong></li></ul><p></p><p>ビデオインタビューにご協力いただきありがとうございました。皆様の合格をお待ちしております。</p><p></p><p>よろしくお願いします。</p><p>タレントマネージャー</p>",
  "Recruiter_Email_Confirmation_Default": "<p>親愛なる{{Candidate’s name, don’t change}},</p><p>当社の評価にご協力いただき、ありがとうございました。</p><p></p><p> </p><p>次の選考に残りましたら、ご連絡いたします。</p><p> </p><p><p>Talents Manager</p><p>",
  "Recruiter_Email_Confirmation_Default_old": "<p>親愛なる {{Candidate’s name, don’t change}},</p><p>ビデオインタビューにご協力いただき、ありがとうございました。あなたの回答は審査中であり、次の選考に進むことが決まり次第、ご連絡いたします。</p><p></p><p>よろしくお願いします。</p><p>タレントマネージャー</p>",
  "Recruiter_Email_Extension_Default": "<p>親愛なる{{Candidate’s name, don’t change}},</p><p><p>{{Company’s name, don’t change}}の{{Job Title, don’t change}}のポジションの応募の件ですが、審査の締め切りが{{End date and time, don’t change}}に変更されました。評価のログイン情報は、以下のように改めて提供されます。</p><ul> <li>面接のウェブサイトです。：<a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank’>apisit.neufast.com/candidate</a></li><li>ログイン：<strong>{{Candidate’s login, don’t change}}</strong></li><li>パスワード：<strong>{{Candidate’s password, don’t change}}</strong></li> <li>スタート：<strong>{{Start date and time, don’t change}}</strong></li><li>終了：<strong>{{End date and time, don’t change}}</strong></li> <li>タイムゾーン：<strong>{{Timezone, don’t change}}</strong></li></ul><p></p><p>この度は弊社のアセスメントにご参加いただきありがとうございました。成功裏に終了し、次回のラウンドでお会いできることを楽しみにしています。</p><p></p><p>よろしくお願いします。</p><p>タレントマネージャー</p>",
  "Recruiter_Email_Extension_Default_old": "<p>親愛なる {{Candidate’s name, don’t change}},</p><p>{{Company’s name, don’t change}}のための{{Job Title, don’t change}}のポジションの応募について 、ビデオ面接の締切が{{End date and time, don’t change}}に変更になりました。ビデオ面接のログイン情報は、以下の通りです：</p><ul> <li>面接サイト ：<a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li> <li>ログイン: <strong>{{Candidate’s login, don’t change}}</strong></li><li>パスワード: <strong>{{Candidate’s password, don’t change}}</strong></li> <li>開始: <strong>{{Start date and time, don’t change}}</strong></li><li>終了: <strong>{{End date and time, don’t change}}</strong></li> <li>タイムゾーン: <strong>{{Timezone, don’t change}}</strong></li></ul><p></p><p>ビデオインタビューにご参加いただきありがとうございました。また、このような機会がありましたら、よろしくお願いいたします。, </p><p></p><p>よろしくお願いします。</p><p>タレントマネージャー</p>",
  "Recruiter_SMS_Invitation_Default": "あなたは{{company name}}で{{job title}}のポジションの査定を行うよう招待されました。詳細は {{Candidate's login, don't change}} のメールをご確認ください。ありがとうございます!",
  "Recruiter_SMS_HighScoreContent_Default": "あなたは{{company name}}で{{job title}}のポジションの査定を行うよう招待されました。詳細は {{Candidate's login, don't change}} のメールをご確認ください。ありがとうございます!",
  "Recruiter_SMS_MediumScoreContent_Default": "あなたは{{company name}}で{{job title}}のポジションの査定を行うよう招待されました。詳細は {{Candidate's login, don't change}} のメールをご確認ください。ありがとうございます!",
  "Recruiter_SMS_LowScoreContent_Default": "あなたは{{company name}}で{{job title}}のポジションの査定を行うよう招待されました。詳細は {{Candidate's login, don't change}} のメールをご確認ください。ありがとうございます!",
  "Recruiter_SMS_Reminder_Default": "{{company name}}で{{job title}}のポジションのアセスメントをできるだけ早く行うよう、ご留意ください。アセスメントのデッドリングは24時間以内です。詳細は{{Candidate's login, don't change}}のメールを確認してください。ありがとうございました。",
  "Recruiter_SMS_Extension_Default": "{{company name}}での{{job title}}のポジションに対するあなたの評価の締め切りが{{終了日時, 変更しないでください}}に変更されました。できるだけ早く完了させ、{{Candidate's login, don't change}}のメールを確認してください。ありがとうございました。",
  "Recruiter_SMS_Invitation_Default_old": "あなたは{{company name}}の{{job title}}のポジションのためのビデオ面接を行うために招待されています。詳細は{{Candidate's login, don't change}}のメールを確認してください。ありがとうございます！",
  "Recruiter_SMS_Reminder_Default_old": "{{job title}}のポジションで{{company name}}のビデオ面接をできるだけ早く行うようご留意ください。ビデオ面接の締切は24時間以内です。詳細は{{Candidate's login, don't change}}のメールを確認してください。ありがとうございました！",
  "Recruiter_SMS_Extension_Default_old": "{{company name}}の{{job title}}のポジションのビデオ面接の締め切りが{{End date and time, don’t change}}に変更されました。できるだけ早く完了させ、{{Candidate's login, don't change}}のメールで詳細を確認してください。ありがとうございました！",
  "Recruiter_Email_Redo_Default": "<p>親愛なる {{Candidate’s name, don’t change}},</p><p>{{Company’s name, don’t change}}の{{Job Title, don’t change}}のポジションのための私達の査定に参加し、ありがとうございました。残念ながら、{{Number of retaking questions, don’t change}}の問題の動画が欠落していることが判明しました。これらの特定の質問は、終了日前に以下のリンクから再受験してください。</p><p> </p><p>ログインの詳細については、以下をご参照ください。面接には、ウェブカメラとマイクを備えたアンドロイド携帯電話またはノートパソコンで、最新のChromeブラウザを使用してください。</p><ul> <li>面接のウェブサイト ：<a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li> <li>ログイン: <strong>{{Candidate’s login, don’t change}}</strong></li><li>パスワード: <strong>{{Candidate’s password, don’t change}}</strong></li> <li>開始: <strong>{{Start date and time, don’t change}}</strong></li><li>終了: <strong>{{End date and time, don’t change}}</strong></li> <li>タイムゾーン: <strong>{{Timezone, don’t change}}</strong></li></ul><p></p><p>あなたの合格を楽しみにしています。</p><p></p><p>よろしくお願いします。</p><p>タレントマネージャー</p>",
  "Recruiter_Email_Redo_Default_old": "<p>親愛なる {{Candidate’s name, don’t change}},</p><p>この度は、{{Company’s name, don’t change}}の{{Job Title, don’t change}}のポジションのビデオインタビューにご参加いただき、ありがとうございます。残念ながら、{{Number of retaking questions, don’t change}}の問題の動画が欠落していることが判明しました。これらの特定の質問は、終了日前に以下のリンクから再受験してください。</p><p> </p><p>ログイン情報は以下の通りです。面接には、ウェブカメラとマイクを備えたアンドロイド携帯電話またはノートパソコンで、最新のChromeブラウザを使用してください。</p><ul> <li>面接サイト: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li> <li>ログイン: <strong>{{Candidate’s login, don’t change}}</strong></li><li>パスワード: <strong>{{Candidate’s password, don’t change}}</strong></li> <li>開始: <strong>{{Start date and time, don’t change}}</strong></li><li>終了: <strong>{{End date and time, don’t change}}</strong></li> <li>タイムゾーン: <strong>{{Timezone, don’t change}}</strong></li></ul><p></p><p>あなたの合格を楽しみにしています。</p><p></p><p>よろしくお願いします。</p><p>タレントマネージャー</p>",
  "Recruiter_Email_Report_Default": "<p>親愛なる{{Candidate’s name, don’t change}}の皆さん。 </p><p> アセスメントを完了していただき、ありがとうございます。あなたの面接は分析されました。以下は、あなたの総合スコアと私たちのコメントです。 </p><p></p><p> </p>スコア：{{Score, don’t change}}/10</p><p>コメント：{{Comment, don’t change}}</p><p></p><p>開発レポートも同封していますので、開発箇所を確認するのに役立ちます。</p><p></p><p>よろしくお願いします。</p><p>タレントマネージャー</p>",
  "Recruiter_Email_WithoutScore_Report_Default": "<p>親愛なる{{Candidate’s name, don’t change}}の皆さんへ。</p><p>アセスメントを完了していただき、ありがとうございます。あなたのインタビューは分析されました。開発レポートが同封されていますので、開発すべき領域を特定するのにお役立てください。</p><p></p><p>よろしくお願いします。</p><p>タレントマネージャー</p>",
  "Recruiter_Upload_Large_File_Warning_Title": '大きなファイルが検出されました。',
  "Recruiter_Upload_Large_File_Warning_Message": 'アップロードされた動画ファイルが200MB以上です。そのため、面接の読み込みに時間がかかることがあります。',
  "Recruiter_AccountSetting_Title": "アカウント設定",
  "Recruiter_AccountSetting_RecruiterProfile_Title": "採用担当者プロフィール",
  "Recruiter_AccountSetting_CompanyProfile_Title": "会社概要",
  "Recruiter_AccountSetting_Functionality_Title": "職務",
  "Recruiter_AccountSetting_UsageHistory_Title": "利用履歴",
  "Recruiter_AccountSetting_Password_Title": "パスワード",
  "Recruiter_AccountSetting_Add_Recruiter_Button": "サブ採用担当者の追加",
  "Recruiter_AccountSetting_Register_Dialog_Title": "サブ採用担当者の登録",
  "Recruiter_AccountSetting_Register_Dialog_SubTitle_Login": "ログイン情報",
  "Recruiter_AccountSetting_Register_Dialog_SubTitle_Account": "アカウント情報",
  "Recruiter_AccountSetting_Register_Dialog_Email": "メール",
  "Recruiter_AccountSetting_Register_Dialog_Password": "パスワード",
  "Recruiter_AccountSetting_Register_Dialog_FirstName": "名前",
  "Recruiter_AccountSetting_Register_Dialog_LastName": "苗字",
  "Recruiter_AccountSetting_RecruiterProfile_Picture": "プロフィール写真:",
  "Recruiter_AccountSetting_RecruiterProfile_FirstName": "名前:",
  "Recruiter_AccountSetting_RecruiterProfile_LastName": "苗字:",
  "Recruiter_AccountSetting_RecruiterProfile_Email": "メール:",
  "Recruiter_AccountSetting_RecruiterProfile_JobTitle": "職種名:",
  "Recruiter_AccountSetting_RecruiterProfile_Tel": "電話番号:",
  "Recruiter_AccountSetting_Functionality_RecruiterEvaluation": "採用担当者の評価",
  "Recruiter_AccountSetting_Functionality_FacialAnnotation": "ビデオにおける表情のアノテーション",
  "Recruiter_AccountSetting_UsageHistory_NumberInvitations": "招待状数",
  "Recruiter_AccountSetting_UsageHistory_NumberCompletedInterviews": "インタビュー完了数",
  "Recruiter_AccountSetting_UsageHistory_TimePeriod": "期間",
  "Recruiter_AccountSetting_UsageHistory_Number": "数字",
  "Recruiter_AccountSetting_Password_CurrentPassword": "現在のパスワード",
  "Recruiter_AccountSetting_Password_NewPassword": "新しいパスワード",
  "Recruiter_AccountSetting_Password_PasswordConfirmation": "パスワードの確認",
  "Recruiter_AccountSetting_PurchaseBalance_Title": "購入および残高",
  "Recruiter_AccountSetting_DateOfPurchase": "購入日",
  "Recruiter_AccountSetting_ValidUntil": "有効期限",
  "Recruiter_AccountSetting_Reference": "参考",
  "Recruiter_AccountSetting_NumberOfInterviews": "面接回数",
  "Recruiter_AccountSetting_NumberOfExpiredInterviews": "期限切れの面接",
  "Recruiter_AccountSetting_RecruiterAccount": "採用担当者アカウント",
  "Recruiter_AccountSetting_InterviewUsage": "面接の使用状況",
  "Recruiter_AccountSetting_PurchasedInterviews": "購入者面接",
  "Recruiter_AccountSetting_Usage": "使用状況",
  "Recruiter_AccountSetting_Balance": "残り",
  "Recruiter_AccountSetting_AccountStatus": "アカウントステータス",
  "Recruiter_AccountSetting_TotalNumberOfInterviews": "面接総数（1）",
  "Recruiter_AccountSetting_TotalInterviewUsage": "面接の利用合計(2)",
  "Recruiter_AccountSetting_TotalNumberOfExpiredInterviews": "有効期限切れの面接回数合計（3）",
  "Recruiter_AccountSetting_TotalBalance": "残り = (1) - (2) - (3)",

  "Recruiter_CV_Upload_Message": "履歴書をアップロードする",
  "Recruiter_CV_Extension": "ファイル形式 jpg、pdf、doc、docx",

  "Candidate_Common_Next": "次へ",
  "Candidate_Common_Start": "開始",
  "Candidate_Common_Step_Setting": "音声・映像のチェック",
  "Candidate_Common_Step_Practice": "テスト",
  "Candidate_Common_Step_Real": "面接",
  "Candidate_Common_Step_Finished": "終了",
  "Candidate_Common_HideCamera": "カメラを非表示にする。",
  "Candidate_Common_TimeRemaining": "残り時間",
  "Candidate_Common_Video_Recording": "記録中...",
  "Candidate_Common_Video_Stop": "停止",
  "Candidate_Common_Video_Uploading": "アップロード中...",
  "Candidate_Interview_LoadingMessage": "評価を読み込んでいるため、お待ちください...",
  "Candidate_Interview_LoadingMessage_old": "ビデオインタビューを読み込んでいるため、しばらくお待ちください...",
  "Candidate_Browser_Msg": "<p> お使いのブラウザは動画の録画に対応していません。</p> <p>Google Chromeブラウザをご使用ください。下記よりダウンロード可能です。:</p><p><a href=\"https://www.google.com/chrome/\">https://www.google.com/chrome/</a></p><p> または、Android携帯電話のChromeブラウザの使用も可能です。</p>",
  "Candidate_Browser_Warning_IOS": "iPhone/iPadのブラウザは、ビデオ面接に対応していません。App StoreのNeufast面接アプリ、またはGoogle Chromeブラウザを搭載したMac/Android/Window端末をご利用ください。",
  "Candidate_Browser_Warning_Edge": "お使いのEdgeブラウザのバージョンは、ビデオ面接に対応していません。Edgeブラウザを最新のバージョンにアップデートしてください。",
  "Candidate_Browser_Warning_Generic": "お使いのブラウザはビデオ面接に対応していません。Google Chromeブラウザをご利用ください。",
  "Candidate_Browser_Warning_CriOS": "iOSのChromeは、アプリと互換性がありません。Safariに切り替えてください",
  "Candidate_Interview_WelcomeTitle": "ようこそ、{name}さん! 私たちはあなたと一緒にこの評価をすることができてうれしいです。",
  "Candidate_Interview_WelcomeTitle_old": "ようこそ、{name}さん! このビデオインタビューに参加できてうれしいです。",
  'Candidate_Interview_WelcomeTitle_ongrad': "ようこそ、 {name}! ぜひ一度、面接をお受けください。",
  "Candidate_Interview_Welcome_Company": "<b>会社:</b> {companyName}",
  "Candidate_Interview_Welcome_JobTitle": "<b>職種名:</b> {jobTitle}",
  "Candidate_Interview_Welcome_CompanyWebsite": "<b>ウェブサイト:</b> {companyWebsite}",
  "Candidate_Interview_Welcome_Deadline": "<b>締切日:</b> {deadline}",
  "Candidate_Interview_Language": "<b>評価言語:</b> {interviewLanguage}",
  "Candidate_Interview_Language_old": "<b>ビデオインタビュー言語：</b> {interviewLanguage}.",
  "Candidate_Introduction_Title": "会社紹介ビデオ",
  "Candidate_Instruction_Title": "使用方法",
  "Candidate_Instruction_Tips": "(<b>ヒント:</b> このビデオをご覧いただくと、会社やポジションについてより深くご理解いただけると思います。)",
  "Candidate_Instruction_Details": ['周囲の雑音が少ない静かな場所でインターネットに接続できるようにしてください','スタンドでデバイスを支えるか、安定した手でしっかりと持ってください','他のウェブページやアプリケーションを閉じてください','この評価はプロクターで行い、ビデオは録画されます。公正な評価を行うため、テスト中はマスクを着用しないようお願いします。'],
  "Candidate_Instruction_Details_old": ['周囲の雑音が少ない静かな場所からインターネットにアクセスできるようにする','スタンドでデバイスを支えるか、安定した手でしっかり持ってください','他のウェブページやアプリケーションを閉じてください','このビデオ面接はプロクターで撮影され、ビデオは録画されています。公正な評価を行うため、ビデオ面接ではマスクを着用しないようにお願いします。'],
  "Candidate_Instruction_Details2": ['ウェブカメラとマイクを備えたノートパソコンまたはデスクトップで、最新のChrome/Firefoxブラウザを使用してアセスメントを行ってください。','ビデオ面接でのスマートフォン・携帯端末の使用は<b>お勧めしません</b>。','<b>ビデオ面接ではマスクを着用しないでください</b>', 'ビデオ面接は1回で終了してください。', 'ビデオ面接は1回で終了してください。', '終了後、動画のアップロードが完了するのを待ってからブラウザを閉じてログアウトしてください。', '気が散らないように背景を設定しておいてください。'],

  "Candidate_Instruction_Details_last": "準備ができたら、 \"次へ\"を押します。次に、ウェブカメラと音声の設定を確認します。",

  "Candidate_Instruction_RecordedInterview_Message": "このアセスメントは自動で行われるため、実際の人間による面接は行われません",
  "Candidate_Instruction_RecordedInterview_Message_old": "この面接は自動ビデオ面接なので、実際の人間が面接するわけではありません！",
  "Candidate_Settings_Title": "音声・映像のチェック",
  "Candidate_Settings_Caption": "アセスメントを行う前に、お使いのデバイスのウェブカメラ、マイク、スピーカーがオンになっており、正常に動作することを確認してください。",
  "Candidate_Settings_Caption_old": "ビデオ面接を行う前に、お使いの機器のウェブカメラ、マイク、スピーカーのスイッチがオンになっていること、および正常に動作することをご確認ください。",
  "Candidate_Settings_Browser_Compatibility": "ブラウザの互換性",
  "Candidate_Settings_Browser_Compatibility_Caption": "お使いのブラウザは",
  "Candidate_Settings_Browser_Compatibility_Text_True": "互換性",
  "Candidate_Settings_Browser_Compatibility_Text_False": "互換性がありません",
  "Candidate_Settings_Browser_Compatibility_Warning": "警告: ブラウザが古いかサポートされていません",
  "Candidate_Settings_Browser_Compatibility_Warning_Message": "ブラウザを最新バージョンに更新するか、別のブラウザを使用してください。続行を選択すると、面接プロセスが失敗する可能性があります。",
  "Candidate_Settings_Browser_Compatibility_Warning_Message_Button": "確認",
  "Candidate_Settings_Browser_Compatibility_Browser": "サポートされているブラウザ:",
  "Candidate_Settings_Browser_Compatibility_Handling": "問題が解決しない場合は、別のデバイスで試してください",
  "Candidate_Settings_Browser_Compatibility_Handling_iOS": "検出された iOS/MacOS バージョン。 {version}。 ver.14.3以降にアップデートしてください",
  "Candidate_Settings_Browser_Compatibility_Handling_CriOS": "iOS/iPad で Chrome を使用しています。代わりに Safari ブラウザを使用してください",
  "Candidate_Settings_Browser_Compatibility_Handling_Unknown": "iOS/iPadOS/MacOS ver.で不明なエラーを検出しました。 {version}。",
  "Candidate_Settings_Webcam": "ウェブカメラ",
  "Candidate_Settings_Webcam_Caption": "ウェブカメラへのアクセスを許可し、以下の画面に自分の顔が表示されていることを確認してください。",
  "Candidate_Settings_Microphone": "マイク",
  "Candidate_Settings_Microphone_Caption": "マイクへのアクセスを許可し、下のインジケーターであなたの声が検出されるように話しかけてください。",
  "Candidate_Settings_MicrophoneVolume_TooLow": "小さ過ぎます",
  "Candidate_Settings_MicrophoneVolume_Low": "小さいです",
  "Candidate_Settings_MicrophoneVolume_Recommended": "推奨",
  "Candidate_Settings_MicrophoneVolume_Loud": "大きいです",
  "Candidate_Settings_MicrophoneVolume_TooLoud": "大き過ぎます",
  "Candidate_Settings_Lighting": "照明と位置",
  "Candidate_Settings_Speaker": "スピーカー音量",
  "Candidate_Settings_Speaker_Caption": "音楽を再生し、聞こえることを確認してください。",
  "Candidate_Settings_TestAudio": "テスト音声",
  'Candidate_Settings_PauseAudio': "音声の一時停止",
  "Candidate_Settings_LightCheckPrefix": "押す",
  "Candidate_Settings_LightCheckSuffix": "照明や位置が適切かどうかを確認してください。",
  "Candidate_Settings_LightCheckPrefixButton": "こちら",
  "Candidate_Settings_NetworkCondition": "ネットワーク状態",
  "Candidate_Settings_NetworkCondition_UploadSpeed": "アップロード速度: {speed}",
  "Candidate_Settings_NetworkCondition_DownloadSpeed": "ダウンロード速度: {speed}",
  "Candidate_Settings_NetworkCondition_Estimating": "計測中...",
  "Candidate_Settings_NetworkCondition_Recommendation": "(安定したWi-Fiネットワークの利用を推奨します。)",
  "Candidate_Settings_NetworkCondition_NASpeed": "--- KB/秒",
  "Candidate_Settings_NetworkCondition_B": "{speed} B/秒",
  "Candidate_Settings_NetworkCondition_KB": "{speed} KB/秒",
  "Candidate_Settings_NetworkCondition_MB": "{speed} MB/秒",
  "Candidate_Settings_NetworkCondition_GB": "{speed} GB/秒",
  "Candidate_Settings_Error_Msg": "カメラ/オーディオデバイスにアクセスできません。これらが有効になっているか、他のアプリケーションで使用されていないかを確認してください。",
  "Candidate_Settings_Microphone_No_Voice_Error_Msg": "お使いのマイクで音声が録音されていません。このダイアログを閉じて、マイクに話しかけてからもう一度'次へ'を押してください。問題が解決しない場合は、マイクの設定を確認してください。",
  "Candidate_Detail_Greeting": "こんにちは、 {name}!",
  "Candidate_Detail_Greeting_In_Mobile_View": "こんにちは！ {name}",
  "Candidate_Detail_QuestionAndTimeLimit": "この面接は全部で<span style=\"font-size: 150%\">{totalQuestion}</span> 問の質問で構成されており、 <span style=\"font-size: 150%\">{timeLimit}</span> 分の時間がかかります",
  "Candidate_Detail_Deadline": "締切日",
  "Candidate_Detail_InterviewPractice": "面接の練習",
  "Candidate_Detail_Multiple_Choices_Practice": "多肢選択問題演習",
  "Candidate_Detail_Short_Question_Practice": "短文問題の練習",
  "Candidate_Detail_Question": "質問:",
  "Candidate_Detail_Interview": "面接",
  "Candidate_Detail_Duration": "期間:",
  "Candidate_Detail_Format": "形式:",
  "Candidate_Detail_Interview_Reminder": "リマインダー",
  "Candidate_Detail_Language_Text_Suffix": 'にて{language}',
  "Candidate_Detail_Paragraph_1": "このテストを実施する前に、模擬テストを受け、テスト形式に慣れることをお勧めします。",
  "Candidate_Detail_Paragraph_2": '面接の内容は<span style=\"font-weight: bold;font-size: 200%\">{noOfQuestion}</span> {measureWord}です。: ',
  "Candidate_Detail_Paragraph_2_Retake": '面接の一部再受験は、以下の内容で構成されています。<span style=\"font-weight: bold;font-size: 200%\">{noOfQuestion}</span> {measureWord}: ',
  "Candidate_Detail_Language_Text_Suffix_2": '<span style=\"font-weight: bold;font-size: 200%;color: red\">{noOfQuestion}</span> {measureWord}にて {language}',
  "Candidate_Detail_Paragraph_3": "各質問に対して <span style=\"background-color: #e3f2fd\">{preparationTime} を考え、対応し、</span>そして <span style=\"background-color: #e3f2fd\">{timeForEachQuestion} 答えてください。</span>",
  "Candidate_Detail_Paragraph_3_No_Preparation_Time": "各質問に対して、最大で<span style=\"background-color: #e3f2fd\">{timeForEachQuestion} で答えてください。</span>",
  "Candidate_Detail_Paragraph_4": "<b>合計予定時間:</b> {totalTime}",
  "Candidate_Detail_Video_Interview": "ビデオ面接",
  "Candidate_Detail_Short_Question": "短い質問",
  "Candidate_Detail_Multiple_Choices": "複数の選択肢",
  "Candidate_Detail_Video_Interview_Paragraph_1_normal": "あなたのビデオ面接テストは{noOfQuestion} {measureWord}で構成されています。",
  "Candidate_Detail_Video_Interview_Paragraph_1_normal_Retake": "あなたの面接の一部再試験は、{noOfQuestion}{measureWord}で構成されています。",
  "Candidate_Detail_Video_Interview_Paragraph_2_normal": "各質問に対して、{preparationTime}で回答を考え、{timeForEachQuestion}までで回答することになります。",
  "Candidate_Detail_Video_Interview_Paragraph_2_normal_No_Preparation_Time": "各質問に対して、{timeForEachQuestion}まで回答することができます。",
  "Candidate_Detail_Multiple_Choices_Paragraph_1_normal": "あなたの多肢選択テストは{noOfQuestion} {measureWord}で構成されています。",
  "Candidate_Detail_Short_Question_Paragraph_1_normal": "あなたの短文問題は{noOfQuestion} {measureWord}で構成されています。",
  "Candidate_Detail_Multiple_Choices_Paragraph_1": "各質問に対して、{timeForEachQuestion}程度の回答時間があります。",
  "Candidate_Detail_Multiple_Choices_Text_Suffix": "<span style=\"font-weight: bold;font-size: 200%;color: black\">{noOfQuestion}</span>",
  "Candidate_Detail_Short_Question_Paragraph_1": "各質問に対して、{timeForEachQuestion}程度の回答時間があります。",
  "Candidate_Detail_Short_Question_Text_Suffix": "<span style=\"font-weight: bold;font-size: 200%;color: black\">{noOfQuestion}</span>",
  "Candidate_Detail_Start_Practice": "練習を開始",
  "Candidate_Detail_Sec_to_Prepare": "準備時間",
  "Candidate_Detail_Min_To_Answer": "回答時間",
  "Candidate_Detail_Start_Interview": "面接開始",
  "Candidate_Detail_Start_Test": "テスト開始",
  "Candidate_Detail_Interview_Info_Heading": "あなたの評価情報は以下の通りです。",
  "Candidate_Detail_Compay": "会社",
  "Candidate_Detail_Position_Requested": "職種名",
  "Candidate_Detail_Website": "ウェブサイト",
  "Candidate_Detail_Interview_Date_And_Time": "アセスメント日時",
  "Candidate_Detail_Help_Center": "ヘルプセンター",
  "Candidate_Detail_Video_Interview_Information": "ビデオ面接情報",
  "Candidate_Detail_Multiple_Choices_Information": "多肢選択式試験について",
  "Candidate_Detail_Short_Question_Information": "短問テスト情報",

  "Candidate_Interview_Time_Remaining": "残り時間 :",
  "Candidate_Interview_Question_Of": "{totalQuestion}の質問{question}",

  "Candidate_Practice_Title": "面接の練習",
  "Candidate_Practice_PracticeAgain": "再度練習を行う",
  "Candidate_Practice_Question": "質問",
  "Candidate_Practice_Placeholder": "ここに答えを入力してください",
  "Candidate_Practice_Answer_In": "回答は{language}です。",

  "Candidate_Practice_Answer_In_pu_en": "中国普通語／英語で回答する。",
  "Candidate_Practice_Answer_In_cn_en": "広東語/英語で回答する。",

  "Candidate_Practice_Answer_Time": "回答時間",
  "Candidate_Practice_You_have": "所持",
  "Candidate_Practice_To_Think": "考え、対応する.",
  "Candidate_Practice_Skip_Message": '「録音 」ボタンをクリックすると、この部分をスキップしてすぐに始めることができます。',
  "Candidate_Practice_Web_Skip_Message": '「録画開始」ボタンをクリックすると、この部分をスキップしてすぐに始めることができます。',
  "Candidate_Practice_Record": "録画する",
  "Candidate_Practice_Start_Recording": "録画開始",
  "Candidate_Practice_Hide_Self_View": "セルフビューを非表示にする",
  "Candidate_Practice_Tip": "ヒント",
  "Candidate_Practice_Tip_Message": "準備時間を利用して、良い答えを考えてください。",
  "Candidate_Practice_Enable_Self_View": "セルフビューを非表示にする",
  "Candidate_Practice_Done": "完了",


  "Candidate_Practice_Check_Title": '録画された練習用ビデオです',
  "Candidate_Practice_Check_Content": '録音した音声は聞き取りやすく、映像は鮮明ですか？',
  "Candidate_Practice_Check_YES": 'はい',
  "Candidate_Practice_Check_NO": 'いいえ',
  "Candidate_Practice_Check_FAIL": '再度、デバイスの確認にリダイレクトします。ウェブカメラやマイクを変更し、正常に動作していることを確認する必要がある場合があります。',
  "Candidate_Practice_Check_Redirect": '音声・映像チェック',



  "Candidate_Practice_NextStagePopup_Title": "こんにちは! 私は本日の面接を行います{recruiterFirstname}と申します。",
  "Candidate_Practice_NextStagePopup_Start_Interview": "それでは面接を始めましょう!",

  "Candidate_Practice_Welcome_Title": '面接練習へようこそ',
  "Candidate_Practice_Welcome_Content": '各問題は <span class=\"{spanClass}\">準備時間 {preparationTimeString}</span>で行われますので、回答を考えてから録音することができます。',
  "Candidate_Practice_Welcome_Content_No_Preparation": '準備時間はなく、3秒のカウントダウンの後、ビデオ撮影が開始されます。',
  "Candidate_Practice_Welcome_Checkbox_Label": 'セルフビューを非表示にする。 (回答は記録されます).',
  "Candidate_Practice_Welcome_Confirm": 'はい',
  "Candidate_Practice_Welcome_Start": "開始",

  "Candidate_Multiple_Choices_Practice_Welcome_Title": "ようこそ{testName}練習へ",
  "Candidate_Multiple_Choices_Practice_Content": "この練習は、テスト形式に慣れるのに役立ちます。テストとは異なる問題が出題されます。",

  "Candidate_Short_Question_Practice_Welcome_Title": "ようこそ{testName}練習へ",
  "Candidate_Short_Question_Practice_Content": "この練習は、テスト形式に慣れるのに役立ちます。テストとは異なる問題が出題されます。",

  "Candidate_Interview_Submit_Confirm": "投稿",
  "Candidate_Interview_Submit_Not_Confirm": "戻る",
  "Candidate_Interview_Submit_Content": "回答を送信してよろしいですか？",
  "Candidate_Interview_Face_Detection_Warning": "顔が検出されません。カメラが正面にある場合は、設定を確認してください。",

  "Candidate_Interview_Upload_Header_Progressing": "エラーが検出されました お待ちください。ビデオをアップロードしています....",
  "Candidate_Interview_Upload_Header_Completed": "前問のビデオ録画に失敗した。",
  "Candidate_Interview_Upload_Body_Progressing": "前問のビデオ録画に失敗しました。ブラウザや端末の問題である可能性があります。過去問の動画アップロードが完了するまでお待ちください。",
  "Candidate_Interview_Upload_Body_Completed": "ブラウザまたはデバイスの問題の可能性があります。ブラウザを再起動するか、別のデバイスを使用してテストを続行してください。それでも問題が解決しない場合は、'customer-service@neufast.com'までご連絡ください。ご不便をおかけして申し訳ございません。",

  "Candidate_Practice_Finish_Title": '録画された練習用ビデオです。',
  "Candidate_Multiple_Choices_Practice_Finish_Title": "多肢選択問題演習は終了しました。",
  "Candidate_Short_Question_Practice_Finish_Title": "短問練習は終了しました。",
  "Candidate_Practice_Finish_Content": "テストは練習と同じ形式で行われます",
  "Candidate_Practice_Finish_Content_old": "面接は、練習と同じ形式で行われます",
  "Candidate_Practice_Finish_Button_Practice": 'もう一度練習する',
  "Candidate_Practice_Finish_Button_Back": 'メニューに戻る',
  "Candidate_Practice_Finish_Button_Start": "テスト開始",
  "Candidate_Practice_Finish_Button_Start_old": "面接開始",

  "Candidate_Logout_Confirm": "「あなたの評価はまだ完了していませんが、締め切り前に再度ログインすることができます。",


  "Candidate_RealInterview_Welcome_Title": 'ビデオ面接へようこそ！',
  "Candidate_RealInterview_Welcome_Content": '<div>面接が完全に終了した後でなければ、<span style=\"font-weight: bold;font-size: 110%\">退出できません。</span> ビデオ面接は<span style=\"font-weight: bold;font-size: 110%\">一度きり</span> ですので、中断は避けてください。</div><br/><div>また、ブラウザの「戻る」「更新」ボタンは押さないでください。</div>',
  "Candidate_RealInterview_Placeholder": 'ここに答えを入力してください',
  "Candidate_RealInterview_Welcome_Checkbox_Label": 'セルフビューを非表示にする (回答は記録されます).',
  "Candidate_RealInterview_Welcome_Confirm": 'はい',

  "Candidate_Multiple_Choices_Welcome_Title": "{testName}へようこそ!",
  "Candidate_Multiple_Choices_Welcome_Content": "<div>面接を完全に終えた後でなければ、その場を<span style=\"font-weight: bold;font-size: 110%\">離れてはいけません。</span>多肢選択式試験のチャンスは<span style=\"font-weight: bold;font-size: 110%\">一度きり</span>ですので、中断は避けなければなりません。</div><br/><div>テストを開始すると、タイマーが始まり、時間切れか「Submit」ボタンがクリックされるまで継続されます。</div>",

  "Candidate_Short_Question_Welcome_Title": "{testName}へようこそ!",
  "Candidate_Short_Question_Welcome_Content": "<div>面接を完全に終了しない限り、その場を<span style=\"font-weight: bold;font-size: 110%\">離れてはいけません。</span>多肢選択式のテストは<span style=\"font-weight: bold;font-size: 110%\">一度きり</span>ですので、中断は避けなければなりません。</div><br/><div>テストを開始すると、タイマーが始まり、時間切れまたは「Submit」ボタンがクリックされるまで継続されます。</div>",

  "Candidate_RealInterview_Title": "ビデオ面接",
  "Candidate_RealInterview_Question": "質問",
  "Candidate_RealInterview_Video": "上のビデオをご覧になった後、質問にお答えください。",
  "Candidate_RealInterview_TotalQuestion": "面接の質問総数:",
  "Candidate_RealInterview_NextQuestion": "次の質問",
  "Candidate_RealInterview_Finish": "終了",
  "Candidate_RealInterview_BackButton": "戻るボタンでビデオ面接から退出しました。",
  "Candidate_RealInterview_Reject": "申し訳ありませんが、透明性と公平性を保つため、あなたのビデオ面接は中断され、再開することはできません。技術的な問題が発生した場合は、customer-service@neufast.com までメールをお送りください。",
  'Candidate_RealInterview_CheckWebcam_Message': '申し訳ございません。あなたのカメラは実行エラーが発生しました。解決してみましょう。',
  "Candidate_RealInterview_Warning": "警告",
  "Candidate_RealInterview_noVoiceWarning":"あなたの声が 10 秒以上検出されていません。発言するか、マイクを確認してください。",

  "Candidate_Interview_Part": "パート {number}",
  "Candidate_Interview_Proctoring": "プロクタリング",
  "Candidate_Interview_Question_List": "質問リスト",
  "Candidate_Interview_Question": "質問 {questionNo}: {question}",
  "Candidate_Interview_Question_Previous": "前",
  "Candidate_Interview_Question_Next": "次へ",
  "Candidate_Interview_Question_Submit": "提出する",
  "Candidate_Interview_Multiple_Choices_Reminder": "* 複数の回答を選択することができます。",

  "Candidate_Multiple_Choices_Title": "複数選択可",
  "Candidate_Short_Question_Title": "小問題",


  "Candidate_RealInterview_english_Section": "英語部門",
  "Candidate_RealInterview_cantonese_Section": "広東語部門",
  "Candidate_RealInterview_mandarin_Section": "北京語部門",
  "Candidate_RealInterview_thai_Section": "タイ語部門",
  "Candidate_RealInterview_japanese_Section": "日本語部門",
  "Candidate_RealInterview_indonesian_Section": "インドネシア語部門",
  "Candidate_RealInterview_vietnamese_Section": "ベトナム語部門",
  "Candidate_RealInterview_khmer_Section": "クメール語部門",
  "Candidate_RealInterview_malay_Section": "マレー語部門",
  "Candidate_RealInterview_german_Section": "ドイツのセクション",
  "Candidate_RealInterview_french_Section": "フランス語セクション",
  "Candidate_RealInterview_korean_Section": "韓国語セクション",

  "Candidate_RealInterview_cn_en_Section": "広東語/英語部門",
  "Candidate_RealInterview_pu_en_Section": "中国普通語/英語部門",
  "Candidate_RealInterview_th_en_Section": "タイ語/英語部門",

  "Candidate_RealInterview_english": "英語",
  "Candidate_RealInterview_cantonese": "広東語",
  "Candidate_RealInterview_mandarin": "北京語",
  "Candidate_RealInterview_thai": "タイ語",
  "Candidate_RealInterview_putonghua": "中国普通語",
  "Candidate_RealInterview_japanese": "日本語",
  "Candidate_RealInterview_indonesian": "インドネシア語",
  "Candidate_RealInterview_vietnamese": "ベトナム語",
  "Candidate_RealInterview_khmer": "クメール語",
  "Candidate_RealInterview_malay": "マレー語",
  "Candidate_RealInterview_german": "ドイツ人",
  "Candidate_RealInterview_french": "フランス語",
  "Candidate_RealInterview_korean": "韓国語",

  "Candidate_RealInterview_pu_en": "中国普通語/英語",
  "Candidate_RealInterview_cn_en": "広東語/英語",


  "Candidate_Language_Change_Dialog": '次の {noOfQuestion} {measureWord} に回答する必要があります{language}.',
  "Candidate_Language_Gotit": "了解しました",

  "Candidate_Upload_Completed": "% 完了",
  "Candidate_Upload_Thankyou": "全ての質問に答えていただき、ありがとうございました。",
  "Candidate_Upload_Wait": "完成した動画はアップロード中です。しばらくお待ちください。.",
  "Candidate_upload_Complete_Wait": "100%完了するまで、ブラウザを閉じないでください。",
  "Candidate_Finish_Continue": "続ける",
  "Candidate_Finish_Logout": "ログアウト",
  "Candidate_Finish_Uploading": "完成した動画はアップロード中です。しばらくお待ちください...。",
  'Candidate_Finish_Redo': '申し訳ございません。あなたの{numberOfErrors} 問に対する回答が正しく記録されていません。\'次へ\'ボタンを押してこれら {numberOfErrors} の答えを記録してください。ありがとうございました。',

  "Candidate_Support_Button": "候補者サポート",
  "Candidate_Support_Title": "ビデオ面接とアセスメントのための候補者サポート",
  "Candidate_Support_Walkthrough": "ビデオ面接＆アセスメントのウォークスルー",
  "Candidate_Support_TroubleShooting": "トラブルシューティング",
  "Candidate_Support_Contact": "その他ご質問がございますか？下記までご連絡ください。<u>customer-service@neufast.com</u>.",
  "Candidate_Support_Back": "戻る",
  "Candidate_Support_Login_Subtitle": "アセスメントにログインする",
  "Candidate_Support_Login_Msg": "<p>ステップ1：apisit.neufast.com/candidateにある受験者のログインページにアクセスします。面接と評価には、最新のChrome/Firefoxウェブブラウザでアクセスすることができます。クロームまたはファイヤフォックスのブラウザが古いバージョンであれば、アップデートしてください。</p> <p>ステップ2: 面接の招待メールに記載されている電子メールアドレスとアクセスコードを入力します。ログインは、指定されたインタビュー時間帯にのみ可能です。",
  "Candidate_Support_Check_Subtitle": "ウェブカメラと音声の確認",
  "Candidate_Support_Check_Msg": "ビデオと設定のページを開き、ウェブカメラ、インターネット接続、照明、マイク、スピーカーの設定を確認します。ウェブカメラとマイクがオンになっていること、およびスムーズで高速なインターネット接続が可能であることを確認してください。",
  "Candidate_Support_Practice_Subtitle": "ビデオ面接とアセスメントのための練習",
  "Candidate_Support_Practice_Msg": "アセスメント（ビデオ面接／マルチチョイス／Q&A）の種類ごとに、実際のアセスメントの前にランダムな練習問題が用意されています。練習問題では、実際のアセスメントと同じように、レイアウトや回答タイミングが設定されています。この機会を利用して、練習し、システムに慣れることをお勧めします。この練習用アセスメントは、何度でも行うことができます。",
  "Candidate_Support_Record_Subtitle": "面接・アセスメントの実施",
  "Candidate_Support_Record_Msg": "練習用セクションを経て、アセスメントが開始される予定です。具体的な回答時間は、採用担当者によって規定されます。すべての候補者の公平性を保証するために、すべての評価は一度しか行うことができません。したがって、受験者は評価の前にもっと多くの練習テストをすることをお勧めします。",
  "Candidate_Support_Tips_Subtitle": "ビデオ撮影の成果を上げるためのヒント（ビデオ面接のみ）",
  "Candidate_Support_Tips_Msg": "採用担当者向けに高品質のビデオを録画する為に役立つヒントがいくつかあります。<ul><li>静かな場所を確保する</li><li>通常の写真撮影と同様に、逆光のない十分な照明のもとでビデオを録画します。</li><li>カメラを顔から少し離し、目の見える範囲で撮影してください。これは自信を示すのに役立ち、採用担当者にとっては普通の会話のように見えるでしょう。</li></ul>",
  "Candidate_Support_Help_Subtitle": "面接のテクニックをもっと知りたい",
  "Candidate_Support_Help_Msg": "ノートパソコン/デスクトップでは、最新のGoogle Chrome（90以上）、Firefox（88以上）、Chromium Edge（76以上）がサポートされています。AndroidのGoogle Chrome（92以上）にも対応しています。IEやSafariなどのブラウザをご利用の方は、Google Chromeブラウザのインストールをお勧めします。iPhone/iPadをご利用の方は、App StoreよりNeufast Interview Appをダウンロードし、面接を行う必要があります。ビデオ面接を行う際は、最新のGoogle ChromeまたはFirefoxブラウザを搭載したWindowsまたはMacOS搭載のノートパソコン/デスクトップを使用することを強く推奨します。 携帯電話でも、インターネット接続が確立され、(着信など)中断がなければ、使用可能です。",

  "Candidate_Support_SystemRequirement_Subtitle": "ビデオ面接と評価のためのシステム要件",
  "Candidate_Support_SystemRequirement_Msg": "<p>求職者の方は、ノートパソコン/デスクトップでは最新のGoogle Chrome（90以上）、Firefox（88以上）、Safari（14以上）、Chromium Edge（76以上）がサポートされています。AndroidのGoogle Chrome（92以上）、iOSのSafari & Chrome（14以上）にも対応しています。その他のブラウザは、Google Chromeブラウザのインストールを推奨します。</p><p>最高のビデオインタビューのパフォーマンスを実現するために、最新のGoogle ChromeまたはFirefoxブラウザを使用したWindowsまたはMacOS搭載のラップトップ/デスクトップを使用してビデオインタビューを行うことを強くお勧めします。携帯電話を使用することも、良好なインターネット接続が確立されており、（着信などの）中断がない場合に限り可能です。",
  "Candidate_Support_AllowAccess_Subtitle": "カメラとマイクへのアクセスを許可する",
  "Candidate_Support_AllowAccess_Msg": "<p>本サイトでは、インタビューや評価を実施するために、Webカメラとマイクへのアクセスが必要です。ビデオとオーディオの設定ページで、あらかじめ正しく設定された対応ブラウザを使用する場合、マイクとカメラの両方へのアクセスを許可するよう促されます。両方許可する]をクリックします。(</p><p>誤ってカメラまたはマイクへのアクセスを拒否した場合、ブラウザを再起動すれば、ビデオとオーディオの設定ページに再度アクセスする際に、アクセスを許可するようブラウザが促してきます。</p>",
  "Candidate_Support_Speaker_Subtitle": "スピーカーをオンにする",
  "Candidate_Support_Speaker_Msg": "必須ではありませんが、スピーカーを有効にすると、システムが面接の質問を読み上げるため、より魅力的な面接が経験できます。ビデオとオーディオのセットアップ時にテストすることができます。",
  "Candidate_Support_NetworkQuality_Subtitle": "ネットワーク品質に関する問題を解決する",
  "Candidate_Support_NetworkQuality_Msg": "<p>ビデオを高画質で録画するために、面接の前にお使いの端末が適切にインターネットに接続されている必要があります。.</p><p>動画や音声をスムーズにアップロードするためには、最低でも1Mbpsのアップロード速度が必要ですが、固定回線やWi-Fiネットワークを使っている場合は、通常、この速度に達します。</p><p>speedtest.netを利用して、ユーザーの接続速度を確認してください。</p><p>携帯電話のセルラーネットワークを利用する場合、データ通信を改善するために録画解像度を下げます。しかし、録音中に問題が生じる場合があります。以下のポイントを参考に、より良い品質の回線にアクセスできるようにすることを強くお勧めします。:</p><ul><li>Wi-Fiをご利用の方は、お使いの端末が強い電波を発していること、ルーターがインターネットに接続されていることをご確認ください。 また、端末をWi-Fiルーターに近づけたり、ルーターを再起動するだけでも効果があります。</li><li>携帯電話をご利用の方は、電波の強い場所を探してください。</li><li>電波に関する問題は、インターネットサービスプロバイダにお問い合わせください。</li></ul>",
  "Candidate_Support_CameraIssues_Subtitle": "カメラに関する問題を解決する",
  "Candidate_Support_CameraIssues_Msg": "<p>カメラの問題を解決するには、以下の方法をお試しください。:</p><ul><li>カメラへのアクセスを許可していることを確認してください。</li><li>Chromeブラウザを使用し、ブラウザが最新であることを確認してください。</li><li>更新したブラウザで端末を再起動します。</li><li>システムの設定を確認し、カメラが正しくインストールされ、アクセスできることを確認します。</li><li>それでも問題が解決しない場合は、ウェブカメラの製造元にお問い合わせください。</li></ul>",
  "Candidate_Support_MicrophoneIssues_Subtitle": "マイクに関する問題を解決する",
  "Candidate_Support_MicrophoneIssues_Msg": "<p>マイクが使えない場合は、以下の方法をお試しください。:</p><ul><li>マイクへのアクセスを許可していることを確認してください。</li><li>マイクがミュートされていないことを確認し、スイッチ類がある場合は確認します。</li><li>システムの設定を確認し、マイクがデフォルトの録音デバイスであること、正しい録音レベルが設定されていることを確認してください。</li><li>デバイスを再起動します。</li><li>上記の対処法を試みても、同様の問題が発生する場合は、マイクのメーカーにお問い合わせください。</li></ul>",
  "Candidate_Support_AboutNeufast_Subtitle": "Neufastについて",
  "Candidate_Support_AboutNeufast_Msg": "Neufastは、オンラインビデオ面接のリーダーでありエキスパートです。採用担当者が適切な人材をより早く見つけ、人材がより早く、より公平に内定を獲得できるよう支援します。ビデオによる面接では、言葉や文字による評価では表現しきれない才能を発揮することができます。採用担当者も、効果的な方法で候補者を総合的に評価することができます。",
  "Candidate_Support_FAQ_Subtitle": "よくある質問",
  "Candidate_Support_FAQ_Msg": "<ul><li><p>一方的なビデオ面接の評価とは何ですか？</p><p>ビデオ面接は、一方的なオンライン面接です。採用担当者が面接に招待した後は、オンラインでシステムにアクセスし、自動的に面接を行うことができます。面接は事前収録されています。これにより、より多くの候補者が、純粋に履歴書だけで判断されるのではなく、自分の才能や野心を潜在的な雇用主にアピールする機会を持つことができます。</p></li><br/><li><p>面接システムに使用できるデバイスは何ですか？</p><p>ノートパソコン/デスクトップでは、最新のGoogle Chrome（90以上）、Firefox（88以上）、Chromium Edge（76以上）がサポートされていること。AndroidのGoogle Chromeにも対応しています。IEやSafariなどのブラウザをお使いの方は、Google Chromeブラウザのインストールをお勧めします。 iPhoneのiOSには対応していません。Mac/WindowsノートパソコンとChromeブラウザーの使用をお勧めします。</p><p>ビデオ面接を行う際は、最新のGoogle ChromeまたはFirefoxブラウザを搭載したWindowsまたはMacOS搭載のノートパソコン/デスクトップの使用を推奨します。インターネット環境が整っていれば、Chromeブラウザを搭載したアンドロイド携帯での利用も可能です。</p></li><br/><li><p>ノートパソコンを持っていないのですが、どうしたらいいですか？携帯電話を使ってもいいですか？</p><p>結構です。しかし、携帯電話のインターネット接続は安定性に欠けますので、Wi-Fi接続の強い場所を探すことをお勧めします。また、Android携帯電話にのみ対応しておりますので、iOSユーザーは通常、ノートパソコンの使用を推奨しています。</p></li><br/><li><p>私の携帯電話は3G回線しかないのですが、問題ないでしょうか？</p><p>本サービスをご利用の際は、良好なWi-Fi/4Gのご利用をお勧めします。3Gを使用すると、アップロード時間が長くなり、ビデオの品質が低下します。もし、これしか選択肢がない場合、アップロード速度が最も速くなる場所を探して、ビデオとオーディオの設定画面でネットワークの状態をテストしてみることをお勧めします。</p></li><br/><li><p>面接は何回受けることができますか？</p><p>面接は1度しか受けられません。面接の練習は何度でもできますので、システムに慣れるためにも、ぜひやってみてください。</p></li><br/><li><p>ビデオ面接の所要時間はどのくらいですか？</p><p>採用担当者が設定する質問数によります。通常、30分以内です。</p></li></ul>",

  "Candidate_AppSupport_PP_Title": "プライバシーポリシー（PPS）",
  "Candidate_AppSupport_TC_Title": "利用規約（T&C）",

  "Button_Yes": '確認',
  "Button_No": 'キャンセル',
  "Deparment": "所属",
  "Job": "仕事",
  "Candidate": "候補者",
  "Understand": "理解",
  "Name": "氏名",
  "Email": "メールl",
  "Current_Deadline": "現在の締切日",
  "Interview_Status": "面接状況",
  "Close": "閉じる",
  "Minutes": "分",
  "Minute": "分",
  "Second": '秒',
  "Seconds": '秒',
  "Question": "質問",
  "Questions": "質問",
  "Or": "または",
  'Back': '戻る',
  'Start': '開始',

  'Record_Control_Error_Msg': "カメラ/オーディオ機器にアクセスできません。これらが有効であること、他のアプリケーションがそれらを使用していないことを確認してください。",


  "Shortlisted": "ショートリスト",
  "Rejected": "不採用",
  "Waiting_Listed": "ウェイティングリスト",
  "Pending": "招待状保留中...",
  "Waiting_Invitation": "招待状送付、面接待ち",
  "Processing": "ビデオ処理中 ....",
  "Completed": "完了",
  "Partially_Completed": "一部完了",
  "No_Quota": "定数不足",

  "Login_HiAdmin": "Neufast CMSへようこそ",

  "Recruiter_Review_Title": "審査中の候補者",
  "Recruiter_Dashboard_TableColumn_ProgrammeName": "プログラム名",
  "Recruiter_Dashboard_TableColumn_JobName": "職種名",
  "Recruiter_Dashboard_TableColumn_InterviewLanguage": "面接の言語",
  "Recruiter_Dashboard_TableColumn_Last_Video": "最後の動画",
  "Recruiter_Dashboard_TableColumn_First_Video": "最初の動画",
  "Recruiter_Dashboard_TableColumn_Num_Of_Video": '動画アップロード数',
  "Recruiter_Dashboard_TableColumn_Export": "エクスポート",
  "Review_Evaluation_Title": "レビュアー評価",
  "Recruiter_Skills_Openness": "オープン性",
  "Recruiter_Skills_Conscientiousness": "誠実性",
  "Recruiter_Skills_Extraversion": "外向性",
  "Recruiter_Skills_Agreeableness": "協調性",
  "Recruiter_Skills_Neuroticism": "神経症的傾向",
  "Recruiter_Review_Instruction": "このページでは、審査中の候補者を掲載しています。",
  'Recruiter_Review_List_Files_Failure_Msg': 'ファイルの取得に失敗しました。',
  'Recruiter_Review_Transfer_S3_Files_Dialog_Title': 'S3からファイルを転送する。',
  'Recruiter_Review_Transfer_S3_Files_Dialog_LocalFiles': '弊社リポジトリ上のファイル',
  'Recruiter_Review_Transfer_S3_Files_Dialog_S3Files': 'S3上のファイル',
  'Recruiter_Review_Transfer_S3_Files_Dialog_Success_Msg': '選択されたファイルが正常にコピーされました。',
  'Recruiter_Review_Transfer_S3_Files_Dialog_Failure_Msg': '選択されたファイルのコピーに失敗しました。',
  'Question_Number': '質問番号',
  'Filename': 'ファイル名',
  'Filesize': 'ファイルサイズ',
  "Candidate_Interview_Finish_Message": "この度は、{interview_name}（{interview_type}）をご記入いただき、ありがとうございました。",
  "Candidate_Continue_Message": "{interview_name}  ({interview_type}) にお進みください。",
  "interview": "インタビュー",
  "TextField_Required": "* 必須",
  'Happy': '幸福',
  'Sad': '悲しみ',
  'Fear': '恐怖心',
  'Surprise': '驚き',
  'Neutral': '中立的',
  'Grimace': '険しい表情',
  'Pouty': '不機嫌',


  "Recruiter_Interview_Monitor_Title": "面接実施中の求人情報",
  "Recruiter_Interview_Monitor_Hintbox_Message": "このページでは、面接締切日前に「招待待ち」「招待されて面接待ち」になっている候補者がいる求人情報を表示しています。",
  "Recruiter_Interview_Monitor_TableColumn_RecruiterName": "採用担当者名",
  "Recruiter_Interview_Monitor_TableColumn_RecruiterEmail": "採用担当者メールアドレス",
  "Recruiter_Interview_Monitor_TableColumn_JobTitle": "求人ID",
  "Recruiter_Interview_Monitor_TableColumn_InterviewDeadline": "面接締切日",
  "Recruiter_Interview_Monitor_TableColumn_Total_Num_Of_Candidates": "候補者総数",
  "Recruiter_Interview_Monitor_TableColumn_Completion_Rate": "完了率",
  "Recruiter_Interview_Monitor_TableColumn_Num_Of_Invited_Candidates": "招待者数",
  "Recruiter_Interview_Monitor_TableColumn_Num_Of_Pending_Invitations": "招待状未送付者数",
  "Recruiter_Interview_Monitor_Job": "{count}のジョブ",



  "TC_Header": "利用規約",
  "TC_Top_Section": "ウェブサイトneufast.com（以下「ウェブサイト」）へのアクセスおよびコンテンツの使用は、Neufast Limited（以下「当社」）によって提供され、以下の条件に従って行われるものとする。お客様は、当ウェブサイトをご利用になることにより、これらの条件に同意されたものとみなし、当ウェブサイトを最初にご利用になった時点から効力を生じることに同意されたものとします。当社は、オンラインで変更を掲示することにより、いつでも本規約を変更する権利を留保します。お客様は、本ページに定期的にアクセスし、お客様に適用される本規約を確認することをお勧めします。 変更後に本ウェブサイトを継続して使用することにより、掲載された変更により修正された本契約に同意したものとみなされます。 本サイトに掲載されている「お客様」、「ユーザー」、「ユーザー等」とは、いかなる理由または目的においても、本サイトにアクセスまたは使用するすべての個人または法人を指します。.",
  "TC_Content_1": "ウェブサイトの利用について",
  "TC_Content_1.1": "お客様は、当サイトを合法的な目的でのみ使用することに同意するものとします。また、第三者の権利を侵害したり、第三者による当ウェブサイトの使用や享受を制限したり、抑制したりすることのないようにお願いします。 違法行為、嫌がらせ、苦痛や不便を与える行為、また、わいせつまたは不快なコンテンツの送信や、本ウェブサイト内の正常な対話の流れを阻害する行為も禁止します。",
  "TC_Content_1.2": "お客様は、当ウェブサイトを利用して、他人の知的財産権を侵害してはならないものとします。",
  "TC_Content_1.3": "お客様は、本ウェブサイトを利用して、脅迫的、嫌がらせ、中傷的、不法、有害、わいせつ、中傷的、またはその他の不快もしくは好ましくない資料を送信、発行、アップロード、投稿、回覧または保存してはならないものとします。",
  "TC_Content_1.4": "お客様は、本ウェブサイトのサーバーの正常な動作を妨げるようなソフトウェア、ツール、プログラムの使用またはその他の行為をしてはならないものとします。",
  "TC_Content_1.5": "お客様は、当ウェブサイトのシステムに故意または過度の負担をかけないものとします。",
  "TC_Content_1.6": "お客様は、本ウェブサイトおよびその会員に対して、コンピュータウィルスまたは有害なプログラムを送信しないものとします。",
  "TC_Content_1.7_Title": "特定のユーザー - 求職者",
  "TC_Content_1.7_a": "本サイトで就職を希望するユーザー（以下「求職者」といいます）は、ログイン名およびパスワードを厳重に管理し、他者に開示しないことに同意するものとします。求職者は、ログイン名とパスワードの機密保持、および（承認されたか否かにかかわらず）その使用について、単独で責任を負うものとします。求職者は、不正使用があった場合、直ちに当社に通知することに同意するものとします。",
  "TC_Content_1.7_b": "求職者は、本サイトまたは当社に対して、不完全、虚偽または不正確な履歴書情報を投稿してはならないものとします。",
  "TC_Content_1.7_c": "求職者が本ウェブサイトに提出する情報は、合法的、良識的、非差別的かつ真実でなければなりません。求職者は、本ウェブサイトまたは当社に送信した内容および資料について、単独で責任を負うものとします。",
  "TC_Content_1.7_d": "求職者は、求人広告に応募する以外の理由で、求人広告に応じてはならない。",
  "TC_Content_1.7_e": "求職者が提出する履歴書は、従業員を求めるユーザーまたは広告主（以下「雇用者」といいます）に関連情報を提供することを目的としています。",
  "TC_Content_1.7_f": "求職者から提供された個人情報は、求職者が求人企業や本サイトの求人会員と適切な雇用関係を結ぶことを支援する目的で利用されます。求職者は、求人に応募する際、または履歴書を当社のデータベースに登録する際、求人企業および当社の採用担当者に個人情報を開示しますが、これらはすべて求職者の了承を得た上で行われます。",
  "TC_Content_1.7_g": "求職者が本ウェブサイトまたは当社に提出する情報には、当社のプライバシーポリシーに関する声明が適用されるものとします。",
  "TC_Content_1.7_h": "求職者は、求人企業に提供する個人データまたは情報は、すべて求職者自身のリスクで提供されることを承諾するものとします。求人企業が求職者の個人情報を求人以外の用途に使用した場合、当社はいかなる場合も責任を負わないものとします。",
  "TC_Content_1.7_i": "求職者は、本ウェブサイトに広告を掲載している雇用主に対して、直接履歴書を送付することができます。また、求職者は、求人広告に返信する形で、本ウェブサイトを通じて当社に履歴書を送付することができます。この場合、求職者の履歴書は、法的要件に従い、本サービスの停止にかかわらず、また求職者から消去または削除の要求がない限り、所定の期間本ウェブサイトに保存されるものとします。その後、求職者の責任において、当社のデータベースに保存されるものとします。",
  "TC_Content_1.7_j": "求職者は、自己の履歴書を当社のデータベースに保存することができますが、求人企業がこれを検索することはできません。この場合、求職者は自身の履歴書を使用してオンラインで求職活動を行うことができますが、求人企業や人材紹介会社は当社のデータベースを通じて履歴書にアクセスすることはできません。",
  "TC_Content_1.7_k": "求職者が「候補者マッチング」機能に参加し、潜在的な求人企業に対して履歴書を開示することに同意した場合、当社に広告を掲載する、または当社のサービスに加入するすべての求人企業および人材紹介会社は、求職者の履歴書にアクセスすることができるようになるものとします。 当社は、求職者の情報を特定できない求人企業や人材紹介会社に開示することはありません。求職者から提供された個人情報は、当社の個人情報収集方針およびプライバシーポリシーに関する声明に基づき、厳重に使用されます。",
  "TC_Content_1.7_l": "求職者から提出された履歴書または個人情報は、求人企業が従業員を募集する際に関連情報を提供することを目的としています。",
  "TC_Content_1.7_m": "求職者から提出された個人情報は、求職者が本ウェブサイトの求人企業および求人会員と適切な雇用関係を結ぶことを支援する目的で利用されます。求職者は、求人に応募する際、または履歴書を当社の履歴書データベースに登録する際に、本ウェブサイトの採用担当会員および当社に対して個人情報を開示しますが、これらはすべて求職者の了承を得た上で行われるものであります。",
  "TC_Content_1.7_n": "当社は、データベースへのアクセスを雇用主、採用担当者、ヘッドハンター、人事専門家および社内の許可された担当者のみに許可するよう最善の努力をしますが、当社は、当社の同意なしに他の当事者がデータベースへのアクセスを取得しないことを保証するものではありません。求職者は、いつでも求人企業から自己の履歴書を閲覧できないようにすることができます。ただし、求職者は、求人企業、およびデータベースにアクセスしたその他の関係者が、求職者の履歴書のコピーを自身のファイルまたはデータベースに保持している可能性があることを認めるものとします。 当社は、これらの場合における履歴書の保持、使用、プライバシーについて、また、履歴書がデータベースに登録されている間の当該当事者による履歴書の使用やプライバシーについて、一切責任を負わないものとします。",
  "TC_Content_1.7_o": "求職者が「候補者マッチング」機能に参加し、求人企業による履歴書の検索を許可しない場合、当社は、求職者の希望に合った求人があった場合に、求職者に求人情報を送信します。この場合、求職者の履歴書は、求人企業に開示されることはありません。",
  "TC_Content_1.7_p": "求職者は、就職活動において情報を必要とする知人に対して、本ウェブサイトの求人情報を送信することができますが、他の目的に使用したり、この機能を悪用したりしないものとします。",
  "TC_Content_1.7_q": "個人情報（プライバシー）条例に基づき、求職者は、当社に保管されているご自身の個人情報（事前に本人確認をさせていただきます）にアクセスする権利があり、いつでも当該個人情報を編集・訂正することができます。 アクセスまたは訂正の要請は、当社に書面で送付することにより行うことができます。詳細については、個人情報収集に関する声明およびプライバシーポリシーに関する声明をご参照ください。 また、求職者は、（事前に本人であることを確認した上で）いつでも本ウェブサイトにおいて、自らの個人情報を直接編集・修正することができます。",
  "TC_Content_1.8": "特定のユーザー - 雇用主",
  "TC_Content_1.8_a": "求人企業は、当社へのサービス料金の支払い、および当社が随時定めるその他の条件（もしあれば）により、一定期間本ウェブサイトを利用して求人広告を掲載することができます。求人企業は、広告に含まれる内容および資料について、単独で責任を負うものとします。当社は、広告を適切に編集する権利を有します。",
  "TC_Content_1.8_b": "求人者は、求職者の情報へのアクセスに関して当社が随時定める条件または要件に従い、当社が管理する求職者のデータベースにアクセスする権利を有するが、すべての情報は潜在的な従業員を求める目的のみに使用され、当該求職者の事前の同意なくして、他のいかなる当事者にも情報を開示しないことに同意するものとします。",
  "TC_Content_1.9": "特定のユーザー - 新卒者",
  "TC_Content_1.9_a": "ユーザーは、本ウェブサイトの「オープンフォーラム」に投稿したスピーチ、メッセージ、添付ファイル（該当する場合）の内容およびそこから生じるすべての結果について、単独で責任を負うものとします。",
  "TC_Content_1.9_b": "本サイトの「オープンフォーラム」に投稿される記事、コメント、コンテンツは、議論、研究、意見表明をテーマとしたものでなければならないものとします。誹謗中傷、下品な言葉、卑猥な言葉は厳禁です。記事の内容は、商品・サービスの勧誘、広告、他者への誹謗中傷などの性質があるものは不可です。当社は、本規約に違反する「オープンフォーラム」内の資料およびコンテンツを編集または削除する権利を有し、その結果生じたいかなる損失または損害についても責任を負わないものとします。",
  "TC_Content_2_Title": "未成年者の場合",
  "TC_Content_2": "18歳未満の方、未成年者または法的責任を負う能力がないとみなされる方は、当ウェブサイトをご利用になれません。本ウェブサイトの閲覧やアクセスを希望される方は、これらの条件の意味や結果について、保護者の方の助言を得てください。 当社は、当ウェブサイトを利用されるすべてのお客様が、適法な年齢に達しているものと推定しています。当社は、お客様の年齢を確認する義務を負いませんが、当ウェブサイトの利用者が法定年齢に達していないことが判明した場合、当社は、当該利用者または当該利用者の両親もしくは保護者に対して、当ウェブサイトへのアクセスを停止する権利を含む、可能な限りの権利を留保します。",
  "TC_Content_3": "保証及び責任",
  "TC_Content_3.1": "本ウェブサイトおよびそこで提供される情報は、法律で認められている最大限の範囲において、明示または黙示を問わずいかなる種類の保証もなく「現状のまま」提供されます。",
  "TC_Content_3.2": "当社は、明示または黙示を問わず、商品性、特長ある製品またはサービスの利用可能性、特定目的への適合性および非侵害に関する保証を含め、一切の保証をいたしません。",
  "TC_Content_3.3": "当社は、本ウェブサイト上の資料、コンテンツまたは情報の正確性、信頼性、完全性または適時性について、いかなる保証もいたしません。",
  "TC_Content_3.4": "当社は、本ウェブサイトのコンテンツの誤りや脱落、ユーザー通信や個人設定の削除、誤配信、保存の失敗について、いかなる責任も負いません。",
  "TC_Content_3.5": "また、当社は、このウェブサイトに過誤がないこと、このウェブサイト及びサーバーにコンピュータウィルスその他の有害なものがないこと、欠点を修正すること、このウェブサイトの運営を中断又は中止すること、このウェブサイトの運営を中断又は中止すること、このウェブサイトの運営を停止又は中止すること、このウェブサイトの運営を停止又は中止すること、このウェブサイトの運営を中断又は中止すること、このウェブサイトの運営を停止又は中止することについても一切保証いたしません。お客様が本ウェブサイト、商品または資料をご利用になった結果、機器やデータの保守または交換が必要になった場合、当社はそれらの費用について責任を負いません。",
  "TC_Content_3.6": "当社ウェブサイトおよび当社ウェブサイトを通じてアクセスできる他のウェブサイトは、すべて利用者ご自身の責任においてご利用ください。お客様はご自身のコミュニケーションに責任を持ち、その投稿の結果について責任を負うものとします。当社は、他のユーザーが投稿した通信の真実性、正確性、信頼性を表明・保証するものではなく、また、ユーザーが表明した意見を支持するものではありません。他のユーザーが投稿した資料に対するユーザーの信頼は、ユーザー自身のリスクで行われるものとします。当社は、本契約に違反した場合または法令に違反した場合には、いつでもユーザーを除名し、本ウェブサイトへのアクセスを禁止する権利を有します。また、当社が独自の裁量により、容認できない、虐待的、違法または破壊的と判断したメッセージまたは素材を本ウェブサイトから削除する権利も有します。",
  "TC_Content_3.7": "当ウェブサイトには、第三者のウェブサイトへのリンクが含まれている場合があります。これらは、あくまでもお客様の便宜のために提供されるものであり、当社が当該第三者のウェブサイトのコンテンツを保証するものではありません。お客様がリンク先の第三者のウェブサイトにアクセスされる場合は、すべてお客様ご自身の責任において行ってください。当社は、当社のウェブサイトにリンクしている第三者のウェブサイトの内容については責任を負わず、当該第三者のウェブサイト上の資料の内容や正確さについて、いかなる表明や保証も行いません。 また、お客様が当ウェブサイトに掲載した資料や内容は、当ウェブサイトにリンクしている他のウェブサイトの利用者も閲覧することが可能であり、当社は、当ウェブサイトに掲載された資料や内容をリンク先の第三者のウェブサイトからお客様または第三者が不正使用された場合にも責任を負うものではありません。",
  "TC_Content_3.8": "当社および当ウェブサイトに掲載されている第三者は、当ウェブサイト、商品および資料の使用もしくは使用不能、または性能の故障、エラー、脱落、中断、削除、欠陥、操作もしくは伝送の遅れ、コンピュータウィルスによって生じるいかなる損害または損傷（付随的および結果的損害、利益の損失、データの損失または事業の中断による損害を含むが、これに限らない）に対しても（法律で認められる範囲において）責任を負うものではありません。契約違反、違法行為、過失、または当ウェブサイトの使用、当ウェブサイトへのまたは当ウェブサイトからのデータ、テキスト、画像、その他の素材や情報のアップロード、ダウンロード、公開から直接的または間接的に生じるその他の原因によるか否かにかかわらず、また当社がそのような損害の可能性を知らされているか否かにかかわらず、当ウェブサイトの盗難、破壊または改ざんが行われた場合でも責任を負うものではありません。",
  "TC_Content_3.9_i": "また、当社は、本ウェブサイトへのアクセスおよび使用に関する以下の事項について、いかなる表明も保証も行わず、いかなる責任も負わないものとします。: ",
  "TC_Content_3.9_ii": "• ウイルス、マルウェア、その他の有害な構成要素がないこと",
  "TC_Content_3.9_iii": "• 技術的な欠陥が無いこと",
  "TC_Content_3.9_iv": "• 香港およびその他の地域・管轄区域における利用およびアクセスの可能性。",
  "TC_Content_3.9_v": "お客様は、本ウェブサイト、そのコンテンツおよびツールの使用にあたり、お客様の司法管轄区において適用されるあらゆる法律を遵守する責任を負います。",
  "TC_Content_4_Title": "賠償",
  "TC_Content_4": "すべてのユーザーは、本ウェブサイトの使用または本契約の条項の違反に起因する、あらゆる請求、訴訟、要求、損失または損害から、当社、その役員、取締役、従業員および代理人を補償し、損害を与えないことに同意するものとします。当社は、かかる請求、訴訟または手続について、当該ユーザーに速やかに通知するものとします。",
  "TC_Content_5_Title": "広告主との取引について",
  "TC_Content_5": "本ウェブサイトに掲載されている広告主との通信や取引、または広告主のプロモーションへの参加（関連商品またはサービスの支払いと配送、およびそのような取引に関連するその他の条件、保証または表明を含む）は、お客様と広告主との間でのみ行われるものです。お客様は、このような取引の結果、または本ウェブサイトに広告主が存在することによって生じるいかなる種類の損失または損害に対しても、当社が責任を負わないことに同意するものとします。",
  "TC_Content_6": "他のユーザーとのお取引について",
  "TC_Content_6.1": "当社は、公平な求職・求人サービスを提供し、雇用者と被雇用者の間の情報交換を支援する媒体として最善の努力を行いますが、当社は求職者と雇用者の間の取引に関与せず、当社は求人サービスの品質、安全性および合法性に関して責任を負わないものとします。",
  "TC_Content_6.2": "当社は、求職者から提供された情報および履歴書、ならびに求人企業から提供された求人広告の正確性を保証するものではございません。",
  "TC_Content_6.3": "当社は、求人企業が当該給与を支払うことができるかどうか、求職者が職務を遂行する能力を有するかどうかについて、責任を負いません。",
  "TC_Content_6.4": "求人企業と求職者の間で何らかの紛争が生じた場合、求人企業は自己の責任においてこれを解決するものとし、当社は一切の責任を負わないものとします。",
  "TC_Content_7": "終了のお知らせ",
  "TC_Content_7.1": "ユーザーが提供した情報が不正確である場合、法令に違反する場合、またはわいせつな要素を含む場合、当社は当該ユーザーのアカウントを予告なく即座に破棄し、当該ユーザーに対する法的措置など当社が適切、望ましいまたは必要と考える措置を取る権利を留保します。",
  "TC_Content_7.2": "当社は、ユーザーが本規約のいずれかの条項に違反したと判断した場合、予告なく直ちにユーザーのアカウントまたは本ウェブサイトもしくは当社が提供するサービスへのアクセスを停止する権利、または当社が適切、望ましい、もしくは必要と考える措置をとる権利を常に有するものとします。",
  "TC_Content_7.3": "当社は、ユーザー、求職者及び求人企業が本規約に違反したか否かを判断する最終的な権利と絶対的な裁量権を有するものとします。",
  "TC_Content_8": "知的財産権について",
  "TC_Content_8.1": "本ウェブサイトに掲載されているすべての情報、画像、文章、画像コンテンツ、デザインは、当社の財産であり、著作権およびその他の知的財産権により保護されています。 本ウェブサイトにアクセスされる場合、ユーザーは、コンテンツが個人的な非商業的使用のためにのみダウンロードされることに同意されるものとします。",
  "TC_Content_8.2": "当社の書面による事前の承諾なしに、いかなる目的であれ、本ウェブサイトのコンテンツを複写、複製、送信、普及、販売、配布、出版、放送、回覧、保存（媒体を問わない）、翻案、変更することを禁じます。",
  "TC_Content_9": "一般事項",
  "TC_Content_9.1": "本規約の1つ以上またはその適用が何らかの理由で無効、違法または執行不能とされた場合、その他の点における当該条項または条件および残りの規約の有効性、合法性、執行可能性は、いかなる形でも損なわれないものとします。",
  "TC_Content_9.2": "本規約に基づくいかなる権利または救済措置の行使に対する当社側の不作為または遅延も、権利放棄として解釈または作動するものではなく、また当社によるいかなる権利または救済措置の単一または部分的行使も、当社による当該権利または救済措置の更なる行使を妨げるものではありません。",
  "TC_Content_9.3": "当社は、本規約に含まれる権利および義務の一部または全部をいつでも任意の当事者に譲渡することができます。",
  "TC_Content_9.4": "この一般条件と、このサイトに掲載されている特定の素材に関する規則および/または特定の使用条件との間に矛盾がある場合、後者が優先されるものとします。",
  "TC_Content_9.5": "このご利用条件および当社ウェブサイトのご利用に起因または関連するすべての紛争は、香港特別行政区の法律に準拠し、お客様と当社の双方が香港特別行政区の裁判所の管轄に従うことに同意するものとします。",

  "PPS_Header": "プライバシーポリシー（PPS）",
  "PPS_Top_Section": "Neufast Limited (以下、「当社」) は個人データを尊重し、データ保護の原則および個人データ (プライバシー) 条例 (以下、「条例」) のすべての関連規定を遵守することを約束します。データは、当社のウェブサイトサービスNeufast.com（以下、「サイト」）によって収集されます。当社のPPSは、データ利用者が取り扱う個人データに関するプライバシーポリシーとその運用に関する一般的なステートメントです。",
  "PPS_Content_1_i": "ポリシーステートメント",
  "PPS_Content_1_ii": "個人情報を提供された方の個人的な利益を保護するための当社の全般的な取り組みについて。",
  "PPS_Content_1_iii": "私たちは、個人データのプライバシーを尊重し、個人データ（プライバシー）条例（PDPO）および個人データに関するプライバシー委員会（PCPD）が適宜発行する関連する実施規範を遵守しています。",
  "PPS_Content_2_i": "プラクティス ステートメント",
  "PPS_Content_2_ii": "本サイトのご利用に際し、ご利用者は個人情報を開示したり、提供を求められたりすることがあります。当サイトが提供する様々なサービスをご利用いただくために、お客様の個人情報をご提供いただく場合があります。 利用者は当サイトで要求された情報やデータを提供する義務はありませんが、提供されない場合、当社は当サイトの一部のサービスを提供することができなくなります。",
  "PPS_Content_2_iii": "利用者は、利用者が当社に提供するいかなる情報も、自発的なものであり、正確、真実、最新かつ完全であることに同意するものとします。このような場合、またはそうであると当社が疑う合理的な理由がある場合、当社はユーザーに対するサービスの提供を中止または拒否する権利を有します。",
  "PPS_Content_2_iv": "当社が本サイト上の情報およびデータを収集し使用する目的は、以下のとおりですが、これらに限定されるものではありません。:",
  "PPS_Content_2_v": "•ユーザーに提供するサービスの日常的な運用のため;",
  "PPS_Content_2_vi": "• 求職者が雇用主と適切な雇用関係を結ぶのを支援し、雇用主が幅広い職種や業界の求人に対して求職者の適性を評価するのを支援すること。;",
  "PPS_Content_2_vii": "• 本サイトおよび関連会社が提供する各種サービス、ニュースレター、求人情報、宣伝・マーケティング資料（詳細については、以下の「ニュースレター/宣伝・マーケティング資料の購読」の項をご参照ください）を利用者に提供すること。;",
  "PPS_Content_2_vii": "• アフィリエイトがユーザーにプロモーションやマーケティング資料を提供するために、アフィリエイトと共有すること。;",
  "PPS_Content_2_ix": "•ユーザーからのお問い合わせ、ご要望、苦情への対応およびフォローアップのため;",
  "PPS_Content_2_x": "• 本サイトの使用に関連する管理上の通知や連絡について利用者に連絡し、利用者の問い合わせや要求に応じるため。;",
  "PPS_Content_2_xi": "• 将来のマーケティングおよび販売促進の目的またはその他の内部目的のために、当社が開発を支援すること。;",
  "PPS_Content_2_xii": "• 本サイトに広告、資料、表現、メッセージ、見解、コメントまたはその他の情報（以下、総称して「情報」）を投稿したユーザーの身元を確認するため。;",
  "PPS_Content_2_xiii": "• 本サイトに掲載された情報を閲覧したユーザーを特定するため。;",
  "PPS_Content_2_xiv": "• 当社およびその関連会社、提携会社が主催するイベントやキャンペーンに登録することにより、利用者に本サイトの会員としての特典を享受していただくため。;",
  "PPS_Content_2_xv": "• マーケティング用販促物の受領および使用により、本サイトの会員としての特典を享受しているユーザーを特定するため。;",
  "PPS_Content_2_xvi": "• 当社および関連会社が、当社が提供するサービス、当社および関連会社のマーケティングサービスおよび/または特別なイベントの提供に関連する目的で、利用者の個人情報を利用することを容易にするため。;",
  "PPS_Content_2_xvii": "• 当サイトの利用状況を分析し、今後の社内利用に役立てるため、利用者に関する統計情報を取得すること。;",
  "PPS_Content_2_xviii": "• 上記以外の目的であって、当社が適切と判断する関連会社の製品および/またはサービスの提供またはマーケティングに関連する場合。",
  "PPS_Content_2_xix": "• 本サイトが提供するサービスの改善に役立てるため。",
  "PPS_Content_2_xx": "ユーザーが13歳未満の場合、当社は、親または保護者などの親権者の事前の同意を得ることを強くお勧めします。親権者は、「お問い合わせ」に記載されているカスタマーサポート担当者の連絡先に連絡して、当サイトの会員として登録することができるものとします。",
  "PPS_Content_2_xxi": "当社は、上記の目的に照らして、必要かつ十分な個人情報を収集するよう努めています。",
  "PPS_Content_2_xxii": "上記以外の目的でお客様の個人情報を利用する必要が生じた場合には、お客様から当社所定の同意をいただきます。なお、お客様が未成年の場合は、親権者の方にご同意をお願いしております。",
  "PPS_Content_3_i": "セキュリティについて",
  "PPS_Content_3_ii": "利用者の個人情報およびデータのセキュリティは、Neufast Groupにとって重要です。当社は、利用者の個人情報およびデータが不正なアクセスから保護されるよう常に努めています。当社は、お客様の個人情報を保護するために、適切な電子的および管理的措置を講じています。",
  "PPS_Content_3_iii": "利用者から提供されたすべての個人情報およびデータは、当社または当社が認めた第三者によってのみアクセス可能であり、当該担当者は、当該個人情報およびデータにアクセスする際に本プライバシーステートメントの条件を遵守するよう指示されるものとします。お客様の個人情報およびデータは、収集された目的を達成するために必要な期間のみ保管されますのでご安心ください。登録ユーザーは、ユーザー名とパスワードを秘密として保持し、これらの情報を他者と共有しないものとします。.",
  "PPS_Content_3_iv": "当社は、本サイトにおける電子決済取引を円滑に行うため、第三者であるサービスプロバイダを利用しています。",
  "PPS_Content_3_v": "当社は、利用者が本サイトに提出した個人情報およびデータを、送信中および受信後の両方において、一般に認められた業界標準に従って保護します。 しかしながら、インターネット上の送信方法、電子的な保存方法は、100％安全保証されるものではありません。したがって、当社は利用者の個人情報およびデータを不正アクセスから保護するよう努めますが、その絶対的な安全性を保証するものではありません。",
  "PPS_Content_4_i": "ユーザーのプロフィールや履歴書の保存",
  "PPS_Content_4_ii": "雇用主および広告主にユーザーに関する最も関連性の高い情報を提供するため（およびサイト上のユーザーのプロファイルのプライバシー設定に応じて）、サイト上のユーザーのプロファイルに添付された主要な履歴書は、サイトによってスキャンされ、関連するコンテンツが広告主データベース内の広告主に表示される場合があります。レジュメの内容が広告主に表示されることを望まない場合は、レジュメを添付しないでください。",
  "PPS_Content_5_i": "個人情報の保存について",
  "PPS_Content_5_ii": "Neufast Groupがユーザーの個人情報および/またはデータを取得した場合、「実施声明」に記載されているように、データを収集した目的を果たすために必要な期間、当社のシステムで安全に維持されるものとします。 一旦登録した利用者は、「お問い合わせ」に記載されている当社の個人情報保護管理者に連絡することにより、本サイトの利用を停止することができます。 当社は、当社の法的義務の遵守、規制要件の遵守、ユーザー間の紛争の解決、詐欺や不正行為の防止、または本プライバシーステートメントおよび利用規約の執行のために合理的に必要な場合には、ユーザーがアカウントを閉鎖した後でも、ユーザーの個人情報を保持することができます。",
  "PPS_Content_6_i": "本プライバシーステートメントの変更について",
  "PPS_Content_6_ii": "当社は、当社が必要と判断した場合には、いつでも本プライバシーステートメントを更新、改訂、修正または変更する権利を留保していますので、利用者は、本プライバシーステートメントを頻繁に確認することを強くお勧めします。当社は、本プライバシーステートメントを更新、改訂、修正または変更することを決定した場合、当社が収集する情報の種類、その使用方法、および当社が情報を開示する場合はその状況について利用者が認識できるように、本サイトおよび当社が適切と考えるその他の場所に変更内容を掲載します。",
  "PPS_Content_6_iii": "当社は、本プライバシーステートメントに重要な変更を加える場合、本ウェブページ、電子メール、または本サイトのホームページ上の通知手段により、利用者に通知します。本プライバシーステートメントの変更は、当社が本サイトに掲載した時点から適用されるものとします。利用者が本サイトおよび本サイト上のサービスを継続して利用することにより、本プライバシーステートメントの変更を承認したものとみなされます。",
  "PPS_Content_7_i": "Cookies（Cookie）の使用について",
  "PPS_Content_7_ii": "Cookiesは、ウェブサイトが記録保持のために個人のハードドライブに転送する情報のアイテムです。Cookiesは、特にお客様のパスワード、購入履歴、好みなどを保存することにより、ウェブサーフィンを容易にすることができます。Cookiesの使用は業界標準であり、ほとんどの主要なWebサイトでCookiesを見つけることができます。.",
  "PPS_Content_7_iii": "Cookies自体には個人を特定する情報は含まれませんが、Cookiesにより、当社は、ユーザーの本サービスの利用を、ユーザーが過去に提出した個人を特定する情報と関連付けることができます（該当する場合）。.",
  "PPS_Content_7_iv": "お客様は、当社の広告主からCookiesを取得する場合があります。これらのCookiesは、第三者のコンピュータから送信され、当該第三者のポリシーが適用されます。このサイトでは、訪問者の行動をさらに理解するために、Google Analyticsがインストールされています。 分析広告機能の停止を希望される場合は、関連するGoogleのサービスページをご覧ください。",
  "PPS_Content_7_v": "ほとんどのブラウザは、初期状態ではCookiesを受け入れるように設定されています。もし、上記のような情報の開示を希望されない場合は、Cookiesの受け入れを拒否するように設定してください。ただし、その場合、本サイトのほとんどのページが正常に機能しなくなる可能性があります。",
  "PPS_Content_8_i": "アウトソーシングの取り決め",
  "PPS_Content_8_ii": "当社は、ITシステムの開発・保守を社内のリソースで行っています。当社がITシステムに関連する特定のサービスを提供するために第三者ベンダーに委託する場合、当該ベンダーは通常、ITシステムに格納された個人データにアクセスすることはできません。",
  "PPS_Content_8_iii": "例外的に、当該ベンダーがそのようなアクセスを有する場合、当社は、以下のことを確保するために合理的な手段を用います。: (i) 当該業者は、契約上、当該個人データの機密を保持し、不正アクセス、使用、損失、保持、変更、転送等を防止するための適切な手段を講じる義務を負います。",
  "PPS_Content_9_i": "お問い合わせ、データアクセスリクエスト、データ修正について",
  "PPS_Content_9_ii": "PDPOに基づき、いかなる個人も、当社が保有する自身の個人データについて、問い合わせ、アクセス、訂正を要求する権利を有します。 POPOの条件に従い、当社は、データアクセス要求の処理に合理的な手数料を請求する権利を有します。",
  "PPS_Content_9_iii": "弊社が保有するお客様の個人情報の照会、アクセス、訂正を希望される場合は、下記までご連絡ください。:",
  "PPS_Content_9_iv": "個人情報保護管理者",
  "PPS_Content_9_v": "Neufast Limited",
  "PPS_Content_9_vi": "住所: 1032, 10/F, Building 19W, No.19 Science Park Avenue West, Shatin, N.T., Hong Kong",
  "PPS_Content_9_vii": "電話: (+852)59876904",
  "PPS_Content_9_viii": "メール: customer-service@neufast.com",
  "PPS_Content_10_i": "権利制限なし",
  "PPS_Content_10_ii": "このステートメントのいかなる内容も、個人データ（プライバシー）条例（PDPO）に基づくデータ主体の権利を制限するものではありません。",

  "Africa/Cote_d'Ivoire": "アフリカ/コートジボワール",
  "Africa/Ghana": "アフリカ/ガーナ",
  "Africa/Addis_Ethiopia": "アフリカ/アディス エチオピア",
  "Africa/Algeria": "アフリカ/アルジェリア",
  "Africa/Eritrea": "アフリカ/エリトリア",
  "Africa/Mali": "アフリカ/マリ",
  "Africa/Central_African_Republic": "アフリカ/中央アフリカ共和国",
  "Africa/Gambia": "アフリカ/ガンビア",
  "Africa/Guinea-Bissau": "アフリカ/ギニアビサウ",
  "Africa/Malawi": "アフリカ/マラウイ",
  "Africa/Republic_of_Congo": "アフリカ/コンゴ共和国",
  "Africa/Democratic Republic of Congo/West Time": "アフリカ/コンゴ民主共和国/西時間",
  "Africa/Democratic Republic of Congo/Eastern Time": "アフリカ/コンゴ民主共和国/東部時間",
  "Africa/Burundi": "アフリカ/ブルンジ",
  "Africa/Egypt": "アフリカ/エジプト",
  "Africa/Morocco": "アフリカ/モロッコ",
  "Atlantic/Canary_Islands": "大西洋/カナリア諸島",
  "Africa/Guinea": "アフリカ/ギニア",
  "Africa/Senegal": "アフリカ/セネガル",
  "Africa/United_Republic_of_Tanzania": "アフリカ/タンザニア連合共和国",
  "Africa/Djibouti": "アフリカ/ジブチ",
  "Africa/Cameroon": "アフリカ/カメルーン",
  "Africa/Western_Sahara": "アフリカ/西サハラ",
  "Africa/Sierra_Leone": "アフリカ/シエラレオネ",
  "Africa/Botswana": "アフリカ/ボツワナ",
  "Africa/Zimbabwe": "アフリカ/ジンバブエ",
  "Africa/South_Africa": "アフリカ/南アフリカ",
  "Africa/South_Sudan": "アフリカ/南スーダン",
  "Africa/Uganda": "アフリカ/ウガンダ",
  "Africa/Sudan": "アフリカ/スーダン",
  "Africa/Rwanda": "アフリカ/ルワンダ",
  "Africa/Nigeria": "アフリカ/ナイジェリア",
  "Africa/Gabon": "アフリカ/ガボン",
  "Africa/Togo": "アフリカ/トーゴ",
  "Africa/Angola": "アフリカ/アンゴラ",
  "Africa/Zambia": "アフリカ/ザンビア",
  "Africa/Equatorial_Guinea": "アフリカ/赤道ギニア",
  "Africa/Mozambique": "アフリカ/モザンビーク",
  "Africa/Lesotho": "アフリカ/レソト",
  "Africa/Swaziland": "アフリカ/スワジランド",
  "Africa/Somalia": "アフリカ/ソマリア",
  "Africa/Liberia": "アフリカ/リベリア",
  "Africa/Kenya": "アフリカ/ケニア",
  "Africa/Chad": "アフリカ/チャド",
  "Africa/Niger": "アフリカ/ニジェール",
  "Africa/Mauritania": "アフリカ/モーリタニア",
  "Africa/Burkina_Faso": "アフリカ/ブルキナファソ",
  "Africa/Benin": "アフリカ/ベナン",
  "Africa/Sao_Tome_and_Principe": "アフリカ/サントメ・プリンシペ",
  "Africa/Libya": "アフリカ/リビア",
  "Africa/Tunisia": "アフリカ/チュニジア",
  "Africa/Namibia": "アフリカ/ナミビア",
  "America/Hawaii-Aleutian Standard Time": "アメリカ/ハワイ-アリューシャン標準時",
  "America/Hawaii-Aleutian Daylight Time": "アメリカ/ハワイ-アリューシャン夏時間",
  "America/Alaska Standard Time": "アメリカ/アラスカ州標準時",
  "America/Alaska Daylight Time": "アメリカ/アラスカ州夏時間",
  "America/Mountain Standard Time": "アメリカ/山岳部標準時",
  "America/Mountain Daylight Time": "アメリカ/山岳部夏時間",
  "America/Central Standard Time": "アメリカ/中央標準時",
  "America/Central Daylight Time": "アメリカ/中央夏時間",
  "America/Pacific Standard Time": "アメリカ/太平洋標準時",
  "America/Pacific Daylight Time": "アメリカ/太平洋夏時間",
  "America/Eastern Standard Time": "アメリカ/東部標準時",
  "America/Eastern Daylight Time": "アメリカ/東部夏時間",
  "America/Newfoundland Standard Time": "アメリカ/ニューファンドランド標準時",
  "America/Newfoundland Daylight Time": "アメリカ/ニューファンドランド州の夏時間",
  "America/Atlantic Standard Time": "アメリカ/大西洋標準時",
  "America/Atlantic Daylight Time": "アメリカ/大西洋夏時間",
  "America/Brazil/Acre Standard Time": "アメリカ/ブラジル/オークル標準時",
  "America/Brazil/Amazon Standard Time": "アメリカ/ブラジル/アマゾン標準時",
  "America/Brazil/Brasilia Standard Time": "アメリカ/ブラジル/ブラジリア標準時",
  "America/Brazil/Fernando de Noronha Standard Time": "アメリカ/ブラジル/フェルナンド・デ・ノローニャ標準時",
  "America/West Greenland Time": "アメリカ/西グリーンランド時間",
  "America/East Greenland Time": "アメリカ/東グリーンランド時間",
  "America/Anguilla": "アメリカ/アンギラ",
  "America/Antigua_and_Barbuda": "アメリカ/アンティグア・バーブーダ",
  "America/Argentina": "アメリカ/アルゼンチン",
  "America/Aruba": "アメリカ/アルバ",
  "America/Paraguay": "アメリカ/パラグアイ",
  "America/Barbados": "アメリカ/バルバドス",
  "America/Belize": "アメリカ/ベリーズ",
  "America/Colombia": "アメリカ/コロンビア",
  "America/Bolivarian_Republic_of_Venezuela": "アメリカ/ベネズエラ・ボリバル共和国",
  "America/French_Guiana": "アメリカ/フランス領ギアナ",
  "America/Cayman_Islands": "アメリカ/ケイマン諸島",
  "America/Costa_Rica": "アメリカ/コスタリカ",
  "America/Curacao": "アメリカ/キュラソー",
  "America/Dominica": "アメリカ/ドミニカ共和国",
  "America/El_Salvador": "アメリカ/エルサルバドル",
  "America/Turks_and_Caicos_Islands": "アメリカ/タークス・カイコス諸島",
  "America/Grenada": "アメリカ/グレナダ",
  "America/Guadeloupe": "アメリカ/グアドループ",
  "America/Guatemala": "アメリカ/グアテマラ",
  "America/Ecuador/Galapagos Time": "アメリカ/エクアドル/ガラパゴス時間",
  "America/Ecuador Time": "アメリカ/エクアドル時間",
  "America/Guyana": "アメリカ/ガイアナ",
  "America/Cuba": "アメリカ/キューバ",
  "America/Jamaica": "アメリカ/ジャマイカ",
  "America/Sint_Eustatius_and_Saba_Bonaire": "アメリカ/シント・ユースタティウス島とサバ島 ボネール島",
  "America/Bolivia": "アメリカ/ボリビア",
  "America/Peru": "アメリカ/ペルー",
  "America/Sint_Maarten": "アメリカ/セント・マーチン島",
  "America/Nicaragua": "アメリカ/ニカラグア",
  "America/Saint_Martin": "アメリカ/サンマルタン",
  "America/Martinique": "アメリカ/マルティニーク",
  "America/Saint_Pierre_and_Miquelon": "アメリカ/サンピエール島・ミクロン島",
  "America/Uruguay": "アメリカ/ウルグアイ",
  "America/Montserrat": "アメリカ/モントセラト",
  "America/Bahamas": "アメリカ/バハマ",
  "America/Panama": "アメリカ/パナマ",
  "America/Suriname": "アメリカ/スリナム",
  "America/Haiti": "アメリカ/ハイチ",
  "America/Trinidad_and_Tobago": "アメリカ/トリニダード・トバゴ",
  "America/Puerto_Rico": "アメリカ/プエルトリコ",
  "America/Easter Island Standard Time": "アメリカ/イースター島標準時",
  "America/Chile Standard Time": "アメリカ/チリ標準時",
  "America/Chile Summer Time": "アメリカ/チリの夏時間",
  "America/Dominican_Republic": "アメリカ/ドミニカ共和国",
  "America/St_Barthelemy": "アメリカ/サン・バルテルミー島",
  "America/St_Kitts_and_Nevis": "アメリカ/セントクリストファー・ネイビス",
  "America/St_Lucia": "アメリカ/セントルシア",
  "America/US_Virgin_Islands": "アメリカ/アメリカ領ヴァージン諸島",
  "America/St_Vincent_and_Grenadines": "アメリカ/セントビンセントおよびグレナディーン諸島",
  "America/Honduras": "アメリカ/ホンジュラス",
  "America/British_Virgin_Islands": "アメリカ/英領ヴァージン諸島",
  "Asia/Yemen": "アジア/イエメン",
  "Asia/Kazakhstan/East Time": "アジア/カザフスタン/東部時間",
  "Asia/Kazakhstan/West Time": "アジア/カザフスタン/西時間",
  "Asia/Jordan": "アジア/ヨルダン",
  "Asia/Turkmenistan": "アジア/トルクメニスタン",
  "Asia/Iraq": "アジア/イラク",
  "Asia/Bahrain": "アジア/バーレーン",
  "Asia/Azerbaijan": "アジア/アゼルバイジャン",
  "Asia/Thailand": "アジア/タイ",
  "Asia/Lebanon": "アジア/レバノン",
  "Asia/Kyrgyzstan": "アジア/キルギスタン",
  "Asia/Brunei_Darussalam": "アジア／ブルネイ・ダルサラーム",
  "Asia/Mongolia/Choibalsan Time": "アジア／モンゴル／チュバルサン時間",
  "Asia/Mongolia/Ulaanbaatar Time": "アジア/モンゴル/ウランバートル時間",
  "Asia/Mongolia/Hovd Time": "アジア/モンゴル/ホブド時間",
  "Asia/China Standard Time": "アジア/中国標準時",
  "Asia/Sri_Lanka": "アジア/スリランカ",
  "Asia/Syrian_Arab_Republic": "アジア/シリア・アラブ共和国",
  "Asia/Bangladesh": "アジア/バングラデシュ",
  "Asia/Timor-Leste": "アジア/東ティモール",
  "Asia/UAE": "アジア/アラブ首長国連邦",
  "Asia/Tajikistan": "アジア/タジキスタン",
  "Asia/Cyprus": "アジア/キプロス",
  "Asia/Palestine": "アジア/パレスチナ",
  "Asia/Vietnam": "アジア/ベトナム",
  "Asia/Hong_Kong": "アジア/香港",
  "Asia/Russia/Irkutsk_Time": "アジア/ロシア/イルクーツク時間",
  "Asia/Russia/Kamchatka_Time": "アジア/ロシア/カムチャツカ時間",
  "Asia/Russia/Krasnoyarsk_Time": "アジア/ロシア/クラスノヤルスク時間 ",
  "Asia/Russia/Magadan_Time": "アジア/ロシア/マガダン時間",
  "Asia/Russia/Omsk_Time": "アジア/ロシア/オムスク時間",
  "Asia/Russia/Vladivostok_Time": "アジア/ロシア/ウラジオストク時間",
  "Asia/Russia/Yakutsk_Time": "アジア/ロシア/ヤクーツク 時間",
  "Asia/Russia/Yekaterinburg_Time": "アジア/ロシア/エカテリンブルグ 時間",
  "Asia/Turkey": "アジア/トルコ",
  "Asia/Indonesian/Western Time": "アジア／インドネシア／西部時間",
  "Asia/Indonesian/Central Time": "アジア/インドネシア/中部時間",
  "Asia/Indonesian/Eastern Time": "アジア/インドネシア/東部時間",
  "Asia/Israel": "アジア/イスラエル",
  "Asia/Afghanistan": "アジア/アフガニスタン",
  "Asia/Pakistan": "アジア/パキスタン",
  "Asia/Nepal": "アジア/ネパール",
  "Asia/India": "アジア/インド",
  "Asia/Malaysia": "アジア/マレーシア",
  "Asia/Kuwait": "アジア/クウェート",
  "Asia/Macau": "アジア/マカオ",
  "Asia/Philippines": "アジア/フィリピン",
  "Asia/Oman": "アジア/オマーン",
  "Asia/Cambodia": "アジア/カンボジア",
  "Asia/North_Korea": "アジア/北朝鮮",
  "Asia/Qatar": "アジア/カタール",
  "Asia/Saudi_Arabia": "アジア/サウジアラビア",
  "Asia/Uzbekistan": "アジア/ウズベキスタン",
  "Asia/South_Korea": "アジア/韓国",
  "Asia/Singapore": "アジア/シンガポール",
  "Asia/Taiwan": "アジア/台湾",
  "Asia/Georgia": "アジア/ジョージア",
  "Asia/Iran": "アジア/イラン",
  "Asia/Bhutan": "アジア/ブータン",
  "Asia/Japan": "アジア/日本",
  "Asia/Laos": "アジア/ラオス",
  "Asia/Myanmar": "アジア/ミャンマー",
  "Asia/Armenia": "アジア/アルメニア",
  "Europe/Netherlands": "ヨーロッパ/オランダ",
  "Europe/Andorra": "ヨーロッパ/アンドラ",
  "Europe/Greece": "ヨーロッパ/ギリシャ",
  "Europe/Serbia": "ヨーロッパ/セルビア",
  "Europe/Germany": "ヨーロッパ/ドイツ",
  "Europe/Slovakia": "ヨーロッパ/スロバキア",
  "Europe/Belgium": "ヨーロッパ/ベルギー",
  "Europe/Romania": "ヨーロッパ/ルーマニア",
  "Europe/Hungary": "ヨーロッパ/ハンガリー",
  "Europe/Moldova": "ヨーロッパ/モルドバ",
  "Europe/Denmark": "ヨーロッパ/デンマーク",
  "Europe/Ireland": "ヨーロッパ/アイルランド",
  "Europe/Gibraltar": "ヨーロッパ/ジブラルタル",
  "Europe/Guernsey": "ヨーロッパ/ガーンジー島",
  "Europe/Finland": "ヨーロッパ/フィンランド",
  "Europe/Isle_of_Man": "ヨーロッパ/マン島",
  "Europe/Turkey": "ヨーロッパ/トルコ",
  "Europe/Jersey": "ヨーロッパ/ジャージー",
  "Europe/Russia/Kaliningrad_Time": "ヨーロッパ/ロシア/カリニングラード 時間",
  "Europe/Russia/Moscow_Time": "ヨーロッパ/ロシア/モスクワ時間",
  "Europe/Russia/Samara_Time": "ヨーロッパ/ロシア/サマラ時間",
  "Europe/Ukraine": "ヨーロッパ/ウクライナ",
  "Europe/Portugal": "ヨーロッパ/ポルトガル",
  "Atlantic/Portugal/Azores": "大西洋／ポルトガル／アゾレス諸島",
  "Europe/Slovenia": "ヨーロッパ/スロベニア",
  "Europe/United_Kingdom": "ヨーロッパ/イギリス",
  "Europe/Luxembourg": "ヨーロッパ/ルクセンブルク",
  "Europe/Spain": "ヨーロッパ/スペイン",
  "Europe/Malta": "ヨーロッパ/マルタ",
  "Europe/Åland_Islands": "ヨーロッパ/オーランド諸島",
  "Europe/Belarus": "ヨーロッパ/ベラルーシ",
  "Europe/France": "ヨーロッパ/フランス",
  "Europe/Cyprus": "ヨーロッパ/キプロス",
  "Europe/Norway": "ヨーロッパ/ノルウェー",
  "Europe/Montenegro": "ヨーロッパ/モンテネグロ",
  "Europe/Czech_Republic": "ヨーロッパ/チェコ共和国",
  "Europe/Latvia": "ヨーロッパ/ラトビア",
  "Europe/Italy": "ヨーロッパ/イタリア",
  "Europe/San_Marino": "ヨーロッパ/サンマリノ",
  "Europe/Bosnia_and_Herzegovina": "ヨーロッパ/ボスニア・ヘルツェゴビナ",
  "Europe/Macedonia": "ヨーロッパ/北マケドニア共和国",
  "Europe/Bulgaria": "ヨーロッパ/ブルガリア",
  "Europe/Sweden": "ヨーロッパ/スウェーデン",
  "Europe/Estonia": "ヨーロッパ/エストニア",
  "Europe/Albania": "ヨーロッパ/アルバニア",
  "Europe/Moldova": "ヨーロッパ/モルドバ",
  "Europe/Liechtenstein": "ヨーロッパ/リヒテンシュタイン",
  "Europe/Holy_See_Vatican": "ヨーロッパ／ローマ法王庁 バチカン",
  "Europe/Austria": "ヨーロッパ/オーストリア",
  "Europe/Lithuania": "ヨーロッパ/リトアニア",
  "Europe/Poland": "ヨーロッパ/ポーランド",
  "Europe/Croatia": "ヨーロッパ/クロアチア",
  "Europe/Switzerland": "ヨーロッパ/スイス",
  "Europe/Iceland": "ヨーロッパ/アイスランド",
  "Oceania/Australia/Western Standard Time": "オセアニア／オーストラリア／西部標準時",
  "Oceania/Australia/Central Western Standard Time": "オセアニア/オーストラリア/中西部標準時",
  "Oceania/Australia/Central Standard Time": "オセアニア/オーストラリア/中部標準時",
  "Oceania/Australia/Eastern Standard Time": "オセアニア/オーストラリア/東部標準時",
  "Oceania/Australia/Lord Howe Standard Time": "オセアニア/オーストラリア/ロード・ハウ標準時",
  "Oceania/New_Zealand": "オセアニア/ニュージーランド",
  "Oceania/New_Zealand/Chatham Island": "オセアニア・ニュージーランド・チャタム島",
  "Admin_Auto_Email_opening_title": "Neufastリクルーターアカウント開設",
  "Admin_Auto_Email_add_quota_title": "Neufast インタビュー枠の追加",
  "Admin_Auto_Email_suspension_title": "Neufast Recruiter アカウントの一時停止",
  "Admin_Auto_Email_reactivation_title": "Neufast採用担当者アカウントの再活性化",
  "Admin_Auto_Email_out_of_quota_title": "Neufast採用担当者アカウント - ノルマ不足の警告",
  "Admin_Auto_Email_low_quota_title": "Neufast採用担当者アカウント - 低クォータレベル警告",
  "Admin_Auto_Email_return_quota_title": "Neufast面接ノルマの返上",
  "Admin_Auto_Email_opening_content": '<p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">親愛なる {{Recruiter’s name, don’t change}},</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>Neufastリクルーターアカウントのログイン情報は、以下の通りです。</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>ウェブサイト：</span> <a href="https://apisit.neufast.com/" target="_blank"><span style="color: blue;font-size: medium;font-family: Times New Roman", serif;">apisit.neufast.com</span></a></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>ログイン：{{Login email, don’t change}}</span>&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">p/s: {{Login password, don’t change}}</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>インタビュー枠の数：{{Number of interview quota}}</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>最新のChromeブラウザ（バージョン89、90）またはFirefoxでアクセスしてください。ご利用ガイドを添付しています。</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>何かご不明な点がございましたら、お気軽にお問い合わせください。ありがとうございました。</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">Best Regards,</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>ニューファストカスタマーサービスチーム</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>メール: customer-service@neufast.com</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">電話: (+852) 59876904</span></p>',
  "Admin_Auto_Email_add_quota_content": '<p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>親愛なる {{Recruiter’s name, don’t change}},</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>なお、リクルーターアカウントには、以下の面接枠が追加されています。</span>&nbsp;</p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>インタビュー枠を追加した数： {{Number of interview quota added}}</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>面接のクォータバランス：{{Number of interview quota balance}}</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>何かご不明な点がございましたら、お気軽にお問い合わせください。ありがとうございました。</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>よろしくお願いします。</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>ニューファストカスタマーサービスチーム</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>メール: customer-service@neufast.com</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">電話: (+852) 59876904</span></p>',
  "Admin_Auto_Email_suspension_content": '<p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>親愛なる {{Recruiter’s name, don’t change}},</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>あなたのリクルーターアカウントは停止されましたので、ご注意ください。</span>&nbsp;</p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>何かご不明な点がございましたら、お気軽にお問い合わせください。ありがとうございました。</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>よろしくお願いします。</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>ニューファストカスタマーサービスチーム</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>メール: customer-service@neufast.com</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">電話: (+852) 59876904</span></p>',
  "Admin_Auto_Email_reactivation_content": '<p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>親愛なる {{Recruiter’s name, don’t change}},</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>リクルーターアカウントが再有効化されましたので、ご注意ください。</span>&nbsp;</p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>何かご不明な点がございましたら、お気軽にお問い合わせください。ありがとうございました。</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>よろしくお願いします。</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>ニューファストカスタマーサービスチーム</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>メール: customer-service@neufast.com</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">電話: (+852) 59876904</span></p>',
  "Admin_Auto_Email_out_of_quota_content": '<p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>親愛なる {{Recruiter’s name, don’t change}},</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>リクルーターアカウントの残高がゼロになりましたので、ご注意ください。面接を中断することなく継続的にサービスを提供するために、面接枠の追加購入を希望される場合は、弊社までご連絡ください。</span>&nbsp;</p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>何かご不明な点がございましたら、お気軽にお問い合わせください。ありがとうございました。</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>よろしくお願いします。</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>ニューファストカスタマーサービスチーム</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>メール: customer-service@neufast.com</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">電話: (+852) 59876904</span></p>',
  "Admin_Auto_Email_low_quota_content": '<p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>親愛なる {{Recruiter’s name, don’t change}},</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>リクルーターアカウントの残高が5のみになりましたので、ご注意ください。面接を中断することなく継続的にサービスを提供するために、面接枠の追加購入を希望される場合は、弊社までご連絡ください。</span>&nbsp;</p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>何かご不明な点がございましたら、お気軽にお問い合わせください。ありがとうございました。</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>よろしくお願いします。</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>ニューファストカスタマーサービスチーム</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>メール: customer-service@neufast.com</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">電話: (+852) 59876904</span></p>',
  "Admin_Auto_Email_return_quota_content": '<p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>親愛なる {{Recruiter’s name, don’t change}},</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>なお、リクルーターアカウントには、以下の面接枠が追加されています。</span>&nbsp;</p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>インタビュー枠を縮小： {{Number of interview quota added}}</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>インタビュークォータバランス ：{{Number of interview quota balance}}</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>何かご不明な点がございましたら、お気軽にお問い合わせください。ありがとうございました。</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>よろしくお願いします。</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>ニューファストカスタマーサービスチーム</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;”>メール: customer-service@neufast.com</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">電話: (+852) 59876904</span></p>',
  "Sap_status_update_fail": "Success Factor 更新失敗",
  "Recruiter_Candidate_Result_Invalid_Identity": "採用担当者のアカウントは、この候補者の情報を表示する権限を持っていません。正しいアカウントを使用してください。",
  "Sap_videolink_welcome_message": "候補者のインタビュー解析を開くには、ログイン情報を入力してください。",
  "PDF_Bulk_download_title":"PDF 一括ダウンロードのステータス",
  "PDF_Bulk_download_content":"以下の候補者のレポートはダウンロードできません",
  "PDF_Bulk_download_status":"状態",
  "PDF_Bulk_download_fail":"失敗",
  "PDF_Bulk_download_reason":"レポートの準備ができていません",
  "Candidate_CandidateProfile_With_CV_OPTION" : "I have a resume",
  "Candidate_CandidateProfile_Without_CV_OPTION" : "I don't have a resume",
  "Candidate_CandidateProfile_WorkExperience_SubTitle" : "Work Experience",
  "Candidate_CandidateProfile_Education_SubTitle" : "Education",
  "Candidate_CandidateProfile_Confirm_Title" : "Resume Upload Confirmation", 
  "Candidate_CandidateProfile_Confirm_Content" : "Please make sure all filled information is correct, you will not be allowed to modify once you click the CONFIRM button below.", 
  "Candidate_CandidateProfile_Validation_Error_Msg" : "there are some errors in the filled fields, please check again.",
  "Recruiter_CandidateProfile_Languages_Title": "Languages",
  "Recruiter_CandidateProfile_Upload_Title" : "Before the interview, please upload your resume",
  "Candidate_CandidateProfile_Action_Upload" : "Submit",
  "Recruiter_Layout_ShowConsent" : "カスタマイズされたユーザー同意書を追加",
  "Recruiter_Layout_ShowConsent_Tooltip" : "これにより、候補者のカスタマイズされたユーザー同意が可能になります",
  "Recruiter_Layout_ShowConsent_Default_Message" : "<p>これは利用規約です</p>",
  "Recruiter_Layout_ShowConsent_Title" : "契約内容",
  "Candidate_Consent_Form_Title" : "ユーザー規約",
  "Candidate_Consent_Form_Checkbox_Content" : "利用規約を読み、同意します",
  "Candidate_Consent_Form_Confirmation_Title" : "確認",
  "Candidate_Consent_Form_Confirmation_Content" : "確認をクリックしたら、撤回のために当社に連絡する必要があります。契約について確認してください。",
  "Candidate_Consent_Form_Non_Latest_Message" : "古いバージョンのユーザー同意書を確認しています。更新してからもう一度お試しください。",
  "Candidate_Consent_Form_No_Consent_ID" : "このユーザー同意書はデータベースにありません。更新してから再試行してください。",
  "Do_you_confirm_your_interview_language": "Do you confirm your interview language?",
  "You_selected": "You selected:",
  "You_can_not_change_it_once_you_click_confirm": "*You can not change it once you click confirm",
  "Cancel": "Cancel",
  "Confirm": "Confirm",
  "Candidate_Consent_Form_Non_Latest_Message" : "古いバージョンの同意を確認しています。更新してからもう一度お試しください。",
  "Candidate_Consent_Form_No_Consent_ID" : "この同意はデータベースにありません。更新してから再試行してください。",
  "SESSION_TIMEOUT_TITLE" : "Session Timeout",
  "SESSION_TIMEOUT_CONTENT": "You're being timed out due to inactivity. Please choose to stay signed in or to logoff. Otherwise, you will be logged out automatically in {remaining} seconds.",
  "SESSION_STAY_LOGGED_IN": "Stay Logged In",
  "SESSION_LOGOUT": "Logout",
  "Session_Management_Title" : "Session Management",
}
